import { af as fr, P as Qe, w as hr, ag as vn, Y as wn, Q as xn, Z as yr, ah as gr, ai as br, aj as Ot, ak as kn, al as In, U as Se, i as Te, O as xe, o as St, ac as vr, ad as at, am as wr, an as xr, b as ze, d as Tn, ao as kr, E as Ft, ap as Ir, aq as Tr, ar as Sr, c as Nr, a3 as Er, j as Ar } from "./trackerSavedViews-B1fUFnV-.js";
import { U as ht, t as Cr, m as Lr, n as Pr, o as Dr, T as Sn, p as Nn, q as Be, v as _r, w as Rr, a as $r, x as Mr } from "./trackerReadiness-7BkIYlPX.js";
import { y as tt, s as Or, b as Fr } from "./trackerReferenceLifecycle-xEM9DpA6.js";
import { jsxs as m, jsx as o, Fragment as Le } from "react/jsx-runtime";
import Pe, { useState as O, useRef as ce, useEffect as pe, useMemo as Q, useCallback as Z, Suspense as he, lazy as ye, useLayoutEffect as Br } from "react";
import { C as jr } from "./createTrackerFilterFields-DFU8FW1n.js";
import { M as R } from "./MaterialSymbol-hT2awJjQ.js";
import { a as Vr } from "./syncClientInfo-D4E7fbgz.js";
import { a as Bt } from "./jwtScopes-Dudgipf5.js";
import { f as jt, D as Kr, F as Vt, h as zr, L as Kt, j as qr, g as ue, i as Nt, k as Et, m as yt, r as Ur, n as Yr, o as En, p as An } from "./TrackerDataModel-D7fU-Wum.js";
import { u as Cn, a as Ln, o as Pn, f as Dn, s as _n, b as Wr, c as Hr, d as Jr, e as Gr, F as Rn } from "./floating-ui.react-87bo4V3_.js";
import { w as Qr } from "./windowControlsClearance-BonpJzP6.js";
const zt = 0, $e = 256 * 1024;
function Ne(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function Xr(t) {
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const r = t.charCodeAt(n);
    r < 128 ? e += 1 : r < 2048 ? e += 2 : r >= 55296 && r <= 56319 && n + 1 < t.length && t.charCodeAt(n + 1) >= 56320 && t.charCodeAt(n + 1) <= 57343 ? (e += 4, n++) : e += 3;
  }
  return e;
}
function Zr(t, e) {
  if (!Ne(t)) return { success: !1, error: "payload must be a JSON object" };
  if (typeof t.itemId != "string" || t.itemId.length === 0)
    return { success: !1, error: "payload.itemId must be a non-empty string" };
  if (e !== void 0 && t.itemId !== e)
    return { success: !1, error: "payload.itemId must match envelope itemId" };
  if (typeof t.primaryType != "string" || t.primaryType.length === 0)
    return { success: !1, error: "payload.primaryType must be a non-empty string" };
  if (typeof t.archived != "boolean")
    return { success: !1, error: "payload.archived must be a boolean" };
  if (!Number.isSafeInteger(t.bodyVersion) || t.bodyVersion < 0)
    return { success: !1, error: "payload.bodyVersion must be a non-negative safe integer" };
  if (!Ne(t.fields))
    return { success: !1, error: "payload.fields must be an object" };
  if (!Ne(t.labels))
    return { success: !1, error: "payload.labels must be an object" };
  for (const [n, r] of Object.entries(t.labels))
    if (!Ne(r) || r.id !== n || typeof r.value != "string" || r.tombstone !== void 0 && r.tombstone !== !0)
      return { success: !1, error: `payload.labels.${n} is not a valid label entry` };
  if (!Array.isArray(t.comments))
    return { success: !1, error: "payload.comments must be an array" };
  for (const n of t.comments)
    if (!Ne(n) || typeof n.id != "string" || n.id.length === 0 || !Ne(n.authorIdentity) || typeof n.body != "string" || typeof n.createdAt != "number" || !Number.isFinite(n.createdAt))
      return { success: !1, error: "payload.comments contains an invalid comment" };
  return t.activity !== void 0 && !Array.isArray(t.activity) ? { success: !1, error: "payload.activity must be an array when present" } : Ne(t.system) ? t.issueNumber !== void 0 && (!Number.isSafeInteger(t.issueNumber) || t.issueNumber <= 0) ? { success: !1, error: "payload.issueNumber must be a positive safe integer when present" } : t.issueKey !== void 0 && (typeof t.issueKey != "string" || t.issueKey.length === 0) ? { success: !1, error: "payload.issueKey must be a non-empty string when present" } : { success: !0, value: t } : { success: !1, error: "payload.system must be an object" };
}
function $n(t, e) {
  if (Xr(t) > $e)
    return {
      success: !1,
      error: `payload exceeds ${$e} UTF-8 bytes`
    };
  let n;
  try {
    n = JSON.parse(t);
  } catch {
    return { success: !1, error: "payload must be valid JSON" };
  }
  return Zr(n, e);
}
function ei(t) {
  return t.direction === "symmetric" ? t.label : t.inverseLabel?.trim() || t.label;
}
function Fo(t, e, n, r) {
  const i = [];
  for (const s of t)
    s.valueShape === "entity" && jt(s.subjectKinds, e, r) && (s.objectKinds && !jt(s.objectKinds, n, r) || i.push({
      predicateId: s.id,
      label: s.label,
      inverseLabel: ei(s),
      direction: s.direction
    }));
  return i;
}
const ti = /^[a-z0-9][a-z0-9-]*$/, ni = ["labels", "properties", "claimProperties"], ri = [
  "id",
  "label",
  "pluralLabel",
  "description",
  "broader",
  "icon",
  "color",
  "role",
  "properties",
  "expects",
  "factBox",
  "template",
  "actions"
], ii = ["id", "label", "type", "options", "qualifiers", "facet", "description", "range", "multiValue"], si = ["range", "options", "facet", "description"];
function be(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function Ve(t) {
  return Array.isArray(t) && t.every((e) => typeof e == "string" && e.length > 0);
}
function H(t, e, n) {
  return { code: t, path: e, message: n };
}
class ai {
  constructor() {
    this.issues = [], this.warnings = [];
  }
  unknownKeys(e, n, r, i) {
    for (const s of Object.keys(e))
      n.includes(s) || this.warnings.push(H("LABEL_UNKNOWN_FIELD", Ie(r, s), `'${s}' is not part of ${i}`));
  }
  id(e, n) {
    const r = e.id;
    return typeof r != "string" || r.length === 0 ? (this.issues.push(H("LABEL_MISSING_FIELD", Ie(n, "id"), "'id' is required")), null) : (ti.test(r) || this.issues.push(H("LABEL_INVALID_FIELD", Ie(n, "id"), `'${r}' must be lowercase letters, digits, and hyphens`)), r);
  }
  requiredString(e, n, r) {
    const i = e[n];
    i == null ? this.issues.push(H("LABEL_MISSING_FIELD", Ie(r, n), `'${n}' is required`)) : (typeof i != "string" || i.trim().length === 0) && this.issues.push(H("LABEL_INVALID_FIELD", Ie(r, n), `'${n}' must be a non-empty string`));
  }
  optionalString(e, n, r) {
    e[n] !== void 0 && typeof e[n] != "string" && this.issues.push(H("LABEL_INVALID_FIELD", Ie(r, n), `'${n}' must be a string when present`));
  }
  optionalBoolean(e, n, r) {
    e[n] !== void 0 && typeof e[n] != "boolean" && this.issues.push(H("LABEL_INVALID_FIELD", Ie(r, n), `'${n}' must be a boolean when present`));
  }
  optionalStringList(e, n, r) {
    e[n] !== void 0 && !Ve(e[n]) && this.issues.push(H("LABEL_INVALID_FIELD", Ie(r, n), `'${n}' must be an array of ids`));
  }
}
function Ie(t, e) {
  return t ? `${t}.${e}` : e;
}
function oi(t, e = {}) {
  if (!be(t))
    return {
      valid: !1,
      registry: null,
      issues: [H("LABEL_REGISTRY_NOT_AN_OBJECT", "", "A label registry must be an object with labels, properties, and claimProperties")],
      warnings: []
    };
  const n = new ai();
  n.unknownKeys(t, ni, "", "a label registry");
  const r = qt(t, "labels", n), i = qt(t, "properties", n);
  let s = {};
  t.claimProperties !== void 0 && (be(t.claimProperties) ? s = t.claimProperties : n.issues.push(H("LABEL_INVALID_FIELD", "claimProperties", "'claimProperties' must be an object keyed by predicate id")));
  const a = e.baseFieldNames ?? Kr, l = e.predicateIds ? new Set(e.predicateIds) : null, c = /* @__PURE__ */ new Set();
  i.forEach((p, f) => {
    const h = ci(p, `properties[${f}]`, n);
    h && (c.has(h) && n.issues.push(H("LABEL_DUPLICATE_ID", `properties[${f}].id`, `Property '${h}' is declared more than once`)), a.includes(h) && n.issues.push(H("LABEL_PROPERTY_BASE_FIELD", `properties[${f}].id`, `Property '${h}' has the name of a base field`)), l?.has(h) && n.issues.push(H("LABEL_PROPERTY_ID_CONFLICT", `properties[${f}].id`, `'${h}' is already a predicate; properties and predicates share one id namespace`)), c.add(h));
  });
  const d = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Map();
  r.forEach((p, f) => {
    const h = li(p, `labels[${f}]`, n);
    if (!h) return;
    if (d.has(h)) {
      n.issues.push(H("LABEL_DUPLICATE_ID", `labels[${f}].id`, `Label '${h}' is declared more than once`));
      return;
    }
    d.add(h);
    const b = p.broader;
    u.set(h, { index: f, broader: Ve(b) ? b : [] });
  });
  const g = (p) => c.has(p) || a.includes(p) || (l?.has(p) ?? !1);
  r.forEach((p, f) => {
    if (!be(p)) return;
    const h = `labels[${f}]`, b = p.broader;
    Ve(b) && b.forEach((w, L) => {
      d.has(w) || n.issues.push(H("LABEL_BROADER_UNKNOWN", `${h}.broader[${L}]`, `Broader label '${w}' is not declared`));
    }), l && (Ve(p.properties) && p.properties.forEach((w, L) => {
      g(w) || n.issues.push(H("LABEL_UNKNOWN_PROPERTY", `${h}.properties[${L}]`, `'${w}' is neither a property nor a predicate`));
    }), Array.isArray(p.expects) && p.expects.forEach((w, L) => {
      const N = be(w) ? w.property : void 0;
      typeof N == "string" && !g(N) && n.issues.push(H("LABEL_EXPECTS_UNKNOWN_PROPERTY", `${h}.expects[${L}].property`, `'${N}' is neither a property nor a predicate`));
    }));
  }), di(u, n);
  for (const [p, f] of Object.entries(s)) {
    const h = `claimProperties.${p}`;
    if (!be(f)) {
      n.issues.push(H("LABEL_INVALID_FIELD", h, `Claim property '${p}' must be an object`));
      continue;
    }
    n.unknownKeys(f, si, h, "a claim property"), n.optionalStringList(f, "range", h), n.optionalStringList(f, "options", h), n.optionalBoolean(f, "facet", h), n.optionalString(f, "description", h), Ut(f.range, d, h, n), c.has(p) && !l?.has(p) ? n.issues.push(H("LABEL_PROPERTY_ID_CONFLICT", h, `'${p}' is a field property, not a predicate`)) : l && !l.has(p) && n.issues.push(H("LABEL_CLAIM_PROPERTY_UNKNOWN_PREDICATE", h, `No predicate '${p}' is declared`));
  }
  return i.forEach((p, f) => {
    be(p) && Ut(p.range, d, `properties[${f}]`, n);
  }), n.issues.length > 0 ? { valid: !1, registry: null, issues: n.issues, warnings: n.warnings } : {
    valid: !0,
    registry: {
      labels: r,
      properties: i,
      claimProperties: s
    },
    issues: [],
    warnings: n.warnings
  };
}
function qt(t, e, n) {
  const r = t[e];
  return r == null ? [] : Array.isArray(r) ? r : (n.issues.push(H("LABEL_INVALID_FIELD", e, `'${e}' must be an array`)), []);
}
function Ut(t, e, n, r) {
  Ve(t) && t.forEach((i, s) => {
    e.has(i) || r.warnings.push(H("LABEL_RANGE_UNKNOWN", `${n}.range[${s}]`, `Range label '${i}' is not declared`));
  });
}
function li(t, e, n) {
  if (!be(t))
    return n.issues.push(H("LABEL_NOT_AN_OBJECT", e, "A label declaration must be an object")), null;
  n.unknownKeys(t, ri, e, "a label declaration");
  const r = n.id(t, e);
  n.requiredString(t, "label", e);
  for (const i of ["pluralLabel", "description", "icon", "color", "template"]) n.optionalString(t, i, e);
  for (const i of ["broader", "properties", "factBox"]) n.optionalStringList(t, i, e);
  return t.role !== void 0 && !Kt.includes(t.role) && n.issues.push(H("LABEL_INVALID_FIELD", `${e}.role`, `'role' must be one of ${Kt.join(", ")}`)), t.expects !== void 0 && (Array.isArray(t.expects) ? t.expects.forEach((i, s) => {
    const a = `${e}.expects[${s}]`;
    if (!be(i) || typeof i.property != "string" || i.property.length === 0) {
      n.issues.push(H("LABEL_INVALID_FIELD", a, "An expectation needs a 'property'"));
      return;
    }
    for (const l of ["min", "max"]) {
      const c = i[l];
      c !== void 0 && (typeof c != "number" || !Number.isInteger(c) || c < 0) && n.issues.push(H("LABEL_INVALID_FIELD", `${a}.${l}`, `'${l}' must be a non-negative integer`));
    }
    n.unknownKeys(i, ["property", "min", "max"], a, "an expectation");
  }) : n.issues.push(H("LABEL_INVALID_FIELD", `${e}.expects`, "'expects' must be an array"))), r;
}
function ci(t, e, n) {
  if (!be(t))
    return n.issues.push(H("LABEL_NOT_AN_OBJECT", e, "A property declaration must be an object")), null;
  n.unknownKeys(t, ii, e, "a property declaration");
  const r = n.id(t, e);
  n.requiredString(t, "label", e), n.optionalString(t, "description", e), n.optionalBoolean(t, "facet", e), n.optionalBoolean(t, "multiValue", e), n.optionalStringList(t, "range", e);
  const i = t.type;
  i === void 0 ? n.issues.push(H("LABEL_MISSING_FIELD", `${e}.type`, "'type' is required")) : Vt.includes(i) || n.issues.push(H("LABEL_INVALID_FIELD", `${e}.type`, `'type' must be one of ${Vt.join(", ")}`));
  const s = i === "select" || i === "multiselect";
  if (t.options !== void 0 ? Array.isArray(t.options) && t.options.length > 0 && t.options.every((l) => typeof l == "string" && l.length > 0 || be(l) && typeof l.value == "string" && l.value.length > 0) ? s || n.issues.push(H("LABEL_INVALID_FIELD", `${e}.options`, "'options' only applies to select and multiselect")) : n.issues.push(H("LABEL_INVALID_FIELD", `${e}.options`, "'options' must be a non-empty array of values or { value, label }")) : s && n.issues.push(H("LABEL_MISSING_FIELD", `${e}.options`, `A '${String(i)}' property must declare 'options'`)), t.range !== void 0 && i !== "relationship" && n.issues.push(H("LABEL_INVALID_FIELD", `${e}.range`, "'range' only applies to a relationship property")), t.qualifiers !== void 0)
    if (!be(t.qualifiers))
      n.issues.push(H("LABEL_INVALID_FIELD", `${e}.qualifiers`, "'qualifiers' must be an object keyed by qualifier name"));
    else {
      const a = [], l = [];
      for (const [c, d] of Object.entries(t.qualifiers))
        zr(c, d, a, l);
      for (const c of a) n.issues.push({ ...c, path: `${e}.${c.path}` });
      for (const c of l) n.warnings.push({ ...c, path: `${e}.${c.path}` });
    }
  return r;
}
function di(t, e) {
  const n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), i = [], s = (a) => {
    n.set(a, "visiting"), i.push(a);
    for (const l of t.get(a)?.broader ?? []) {
      if (!t.has(l)) continue;
      const c = n.get(l);
      if (c === "visiting") {
        const d = i.slice(i.indexOf(l)), u = [...d].sort().join("|");
        r.has(u) || (r.add(u), e.issues.push(H(
          "LABEL_CYCLE",
          `labels[${t.get(a).index}].broader`,
          `Broader labels form a cycle: ${[...d, l].join(" -> ")}`
        )));
      } else c || s(l);
    }
    i.pop(), n.set(a, "done");
  };
  for (const a of t.keys())
    n.has(a) || s(a);
}
const ui = 90;
function Re(t) {
  return typeof t == "string" ? t.trim() || null : typeof t == "number" && Number.isFinite(t) ? String(t) : null;
}
function Mn(t) {
  if (t && typeof t == "object" && !Array.isArray(t)) return t;
  if (typeof t == "string" && t.trim().startsWith("{"))
    try {
      return Mn(JSON.parse(t));
    } catch {
      return {};
    }
  return {};
}
function gt(t) {
  if (Array.isArray(t)) {
    for (const e of t) {
      const n = gt(e);
      if (n) return n;
    }
    return null;
  }
  if (typeof t == "string") return t || null;
  if (t && typeof t == "object") {
    const e = t.itemId;
    return typeof e == "string" && e ? e : null;
  }
  return null;
}
function pi(t) {
  if (typeof t == "number" && Number.isFinite(t)) return t;
  if (t instanceof Date) return t.getTime();
  const e = typeof t == "string" ? Date.parse(t) : Number.NaN;
  return Number.isFinite(e) ? e : 0;
}
function Bo(t) {
  if (t.primaryType !== void 0 && t.primaryType !== "claim") return null;
  const e = t.fields ?? {}, n = t.system ?? {};
  return {
    id: t.id,
    subjectId: gt(e.subject),
    predicate: Re(e.predicate),
    objectId: gt(e.object),
    valueText: Re(e.valueText),
    qualifiers: Mn(e.qualifiers),
    status: Re(e.status),
    archived: t.archived === !0,
    updatedAt: pi(n.updatedAt ?? n.lastModifiedAt ?? n.createdAt)
  };
}
function mi(t) {
  return !t.archived && (t.status === null || t.status === "asserted");
}
function bt(t) {
  const e = Re(t.qualifiers.asOf);
  return e && Number.isFinite(Date.parse(e)) ? e : null;
}
function fi(t) {
  const e = t.qualifiers.asOfPrecision;
  return e === "month" || e === "year" ? e : "day";
}
function Yt(t) {
  if (t.valueText) return t.valueText;
  const e = Re(t.qualifiers.amount);
  return e ? [e, Re(t.qualifiers.unit)].filter(Boolean).join(" ") : null;
}
function hi(t, e) {
  const n = bt(t), r = bt(e), i = n ? Date.parse(n) : Number.NEGATIVE_INFINITY, s = r ? Date.parse(r) : Number.NEGATIVE_INFINITY;
  return i !== s ? s > i ? 1 : -1 : e.updatedAt - t.updatedAt;
}
function yi(t, e = /* @__PURE__ */ new Date(), n = "day") {
  const r = t ? /^(\d{4})-(\d{2})-(\d{2})/.exec(t) : null;
  if (!r) return !1;
  const [i, s, a] = [Number(r[1]), Number(r[2]) - 1, Number(r[3])], l = n === "year" ? Date.UTC(i + 1, 0, 0) : n === "month" ? Date.UTC(i, s + 1, 0) : Date.UTC(i, s, a);
  return e.getTime() - l > ui * 864e5;
}
function jo(t, e, n, r = {}) {
  const i = new Set(typeof e == "string" ? [e] : e), s = t.filter((d) => d.predicate === n && d.subjectId !== null && i.has(d.subjectId) && mi(d) && (Yt(d) !== null || d.objectId !== null)).sort(hi), a = s[0];
  if (!a) return null;
  const l = bt(a), c = fi(a);
  return {
    claimId: a.id,
    predicate: n,
    value: Yt(a),
    objectId: a.objectId,
    asOf: l,
    asOfPrecision: c,
    stale: yi(l, r.now ?? /* @__PURE__ */ new Date(), c),
    qualifiers: a.qualifiers,
    history: s
  };
}
const Wt = 500;
function Ht(t) {
  if (t === void 0 || t.length <= Wt) return t;
  let e = Wt - 1;
  const n = t.charCodeAt(e - 1);
  return n >= 55296 && n <= 56319 && (e -= 1), `${t.slice(0, e)}…`;
}
function On(t) {
  return t === "local" ? { sharing: "personal", draftByDefault: !1 } : { sharing: "team", draftByDefault: t === "hybrid" };
}
function Fn(t, e = "personal") {
  const n = t.sync?.mode, r = n && ["local", "shared", "hybrid"].includes(n) ? On(n) : null, { sync: i, ...s } = t, a = t.sharing === "team" || t.sharing === "personal" ? t.sharing : r?.sharing ?? e;
  return {
    ...s,
    sharing: a,
    draftByDefault: a === "team" ? t.draftByDefault ?? r?.draftByDefault ?? !1 : !1
  };
}
function Bn(t) {
  const e = tt.load(t);
  if (!e)
    throw new Error("Empty YAML document");
  if (typeof e.extends == "string" && e.extends.length > 0)
    throw new Error(
      `Tracker type '${e.type ?? "(unnamed)"}' extends '${e.extends}'; use parseTrackerTypeYAML to parse a derived type`
    );
  if (!e.type) throw new Error("Missing required field: type");
  if (!e.displayName) throw new Error("Missing required field: displayName");
  if (!e.displayNamePlural) throw new Error("Missing required field: displayNamePlural");
  if ((e.storage === "pages" || e.storage === "table") && (e.icon ??= "description", e.color ??= "#64748b", e.modes ??= { inline: !0, fullDocument: !1 }, e.idPrefix ??= String(e.type).slice(0, 3)), !e.icon) throw new Error("Missing required field: icon");
  if (!e.color) throw new Error("Missing required field: color");
  if (!e.modes) throw new Error("Missing required field: modes");
  if (!e.idPrefix) throw new Error("Missing required field: idPrefix");
  if (!e.fields || !Array.isArray(e.fields))
    throw new Error("Missing or invalid field: fields (must be an array)");
  const n = jn(e.fields), r = gi(e, n);
  return Vn(r, e);
}
function jn(t) {
  return t.map((e) => {
    if (!e.name) throw new Error("Field missing required property: name");
    if (!e.type) throw new Error(`Field '${e.name}' missing required property: type`);
    const n = {
      name: e.name,
      type: e.type,
      required: e.required || !1,
      default: e.default,
      displayInline: e.displayInline !== void 0 ? e.displayInline : !0
    };
    return e.readOnly !== void 0 && (n.readOnly = e.readOnly), e.minLength !== void 0 && (n.minLength = e.minLength), e.maxLength !== void 0 && (n.maxLength = e.maxLength), e.min !== void 0 && (n.min = e.min), e.max !== void 0 && (n.max = e.max), e.itemType !== void 0 && (n.itemType = e.itemType), e.objectShape !== void 0 && (n.objectShape = e.objectShape), e.relationshipTypeKey !== void 0 && (n.relationshipTypeKey = e.relationshipTypeKey), e.predicate !== void 0 && (n.predicate = e.predicate), e.targetTrackerTypes !== void 0 && (n.targetTrackerTypes = e.targetTrackerTypes), e.multiValue !== void 0 && (n.multiValue = e.multiValue), e.inverseFieldId !== void 0 && (n.inverseFieldId = e.inverseFieldId), e.inverseRelationshipTypeKey !== void 0 && (n.inverseRelationshipTypeKey = e.inverseRelationshipTypeKey), e.symmetric !== void 0 && (n.symmetric = e.symmetric), e.preventsCompletion !== void 0 && (n.preventsCompletion = e.preventsCompletion), e.childRelationship !== void 0 && (n.childRelationship = e.childRelationship), e.allowSelfLink !== void 0 && (n.allowSelfLink = e.allowSelfLink), e.options && Array.isArray(e.options) && (n.options = e.options.map((r) => {
      if (typeof r == "string")
        return {
          value: r.toLowerCase().replace(/\s+/g, "-"),
          label: r
        };
      if (typeof r == "object")
        return {
          value: r.value,
          label: r.label,
          icon: r.icon,
          color: r.color,
          ...fr(r.category) ? { category: r.category } : {}
        };
      throw new Error(`Invalid option format in field '${e.name}'`);
    })), e.schema && Array.isArray(e.schema) && (n.schema = e.schema.map((r) => ({
      name: r.name,
      type: r.type,
      required: r.required || !1
    }))), n;
  });
}
function gi(t, e) {
  return {
    type: t.type,
    displayName: t.displayName,
    displayNamePlural: t.displayNamePlural,
    icon: t.icon,
    color: t.color,
    modes: {
      inline: t.modes.inline !== !1,
      fullDocument: t.modes.fullDocument === !0
    },
    idPrefix: t.idPrefix,
    idFormat: t.idFormat || "ulid",
    fields: e
  };
}
function Vn(t, e, n = !1) {
  const r = t;
  if (e.statusBarLayout && (r.statusBarLayout = e.statusBarLayout), e.inlineTemplate && (r.inlineTemplate = e.inlineTemplate), e.creatable !== void 0 && (r.creatable = e.creatable), typeof e.hiddenUntilType == "string" && (r.hiddenUntilType = e.hiddenUntilType), e.listed === !1 && (r.listed = !1), e.primaryCapable !== void 0 && (r.primaryCapable = e.primaryCapable), e.supportsTags !== void 0 && (r.supportsTags = e.supportsTags), e.tableView && (r.tableView = {
    defaultColumns: e.tableView.defaultColumns || [],
    sortable: e.tableView.sortable !== !1,
    filterable: e.tableView.filterable !== !1,
    exportable: e.tableView.exportable !== !1
  }), e.roles && typeof e.roles == "object") {
    const d = [
      "title",
      "workflowStatus",
      "priority",
      "assignee",
      "reporter",
      "tags",
      "startDate",
      "dueDate",
      "progress",
      "externalKey",
      "prMergedStatus"
    ], u = {};
    for (const [g, p] of Object.entries(e.roles))
      d.includes(g) && typeof p == "string" && (u[g] = p);
    Object.keys(u).length > 0 && (r.roles = u);
  }
  const i = ["personal", "team"], a = ["local", "shared", "hybrid"].includes(e.sync?.mode) ? e.sync.mode : null, l = a ? On(a) : null, c = i.includes(e.sharing) ? e.sharing : l?.sharing;
  return c || !n ? (r.sharing = c ?? "personal", r.draftByDefault = r.sharing === "team" ? typeof e.draftByDefault == "boolean" ? e.draftByDefault : l?.draftByDefault ?? !1 : !1) : typeof e.draftByDefault == "boolean" && (r.draftByDefault = e.draftByDefault), e.archived === !0 && (r.archived = !0), e.localNumbers === !0 && (r.localNumbers = !0), (e.storage === "pages" || e.storage === "table") && (r.storage = e.storage), t;
}
function Vo(t) {
  const e = tt.load(t);
  if (!e) throw new Error("Empty YAML document");
  if (typeof e.extends != "string" || e.extends.length === 0)
    return Bn(t);
  if (!e.type) throw new Error("Missing required field: type");
  if (e.type === e.extends)
    throw new Error(`Tracker type '${e.type}' cannot extend itself`);
  if (e.fields !== void 0 && !Array.isArray(e.fields))
    throw new Error("Invalid field: fields (must be an array)");
  const n = {
    type: e.type,
    extends: e.extends
  };
  return e.fields && (n.fields = jn(e.fields)), e.displayName && (n.displayName = e.displayName), e.displayNamePlural && (n.displayNamePlural = e.displayNamePlural), e.icon && (n.icon = e.icon), e.color && (n.color = e.color), e.idPrefix && (n.idPrefix = e.idPrefix), e.idFormat && (n.idFormat = e.idFormat), e.modes && (n.modes = {
    inline: e.modes.inline !== !1,
    fullDocument: e.modes.fullDocument === !0
  }), Vn(n, e, !0);
}
function bi(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function Kn(t) {
  return bi(t) && typeof t.type == "string";
}
function Ko(t) {
  const e = tt.load(t);
  if (!e) throw new Error("Empty patch document");
  if (!Kn(e))
    throw new Error("Tracker schema patch is missing a string 'type'");
  return e.sync?.mode && e.sharing === void 0 && (e.sharing = e.sync.mode === "local" ? "personal" : "team", e.draftByDefault = e.sync.mode === "hybrid"), delete e.sync, e;
}
function zo(t) {
  const { sync: e, ...n } = t;
  return tt.dump(n, { indent: 2, lineWidth: 120, noRefs: !0 });
}
function vi(t, e) {
  const n = /* @__PURE__ */ new Map();
  for (const i of t ?? []) n.set(i.value, i);
  if (e.set)
    for (const i of e.set) {
      const s = n.get(i.value);
      n.set(i.value, s ? { ...s, ...i } : { ...i });
    }
  if (e.remove)
    for (const i of e.remove) n.delete(i);
  let r = Array.from(n.values());
  if (e.order && e.order.length > 0) {
    const i = new Map(e.order.map((s, a) => [s, a]));
    r = r.map((s, a) => ({ opt: s, idx: a })).sort((s, a) => {
      const l = i.has(s.opt.value) ? i.get(s.opt.value) : Number.POSITIVE_INFINITY, c = i.has(a.opt.value) ? i.get(a.opt.value) : Number.POSITIVE_INFINITY;
      return l - c || s.idx - a.idx;
    }).map(({ opt: s }) => s);
  }
  return r;
}
function wi(t, e) {
  if (e.remove) return;
  let n;
  if (t)
    n = { ...t, ...e.set ?? {} };
  else {
    const r = e.set ?? {};
    if (!r.type)
      throw new Error(
        `Schema patch adds field '${e.name}' without a 'type'`
      );
    n = { name: e.name, type: r.type, ...r };
  }
  return n.name = e.name, e.options && (n.options = vi(n.options, e.options)), n;
}
function xi(t, e) {
  if (e.type !== t.type)
    throw new Error(
      `Schema patch type '${e.type}' does not match seed type '${t.type}'`
    );
  const n = {
    ...t,
    // Shallow-clone nested structures we may mutate below.
    fields: t.fields.map((r) => ({ ...r }))
  };
  if (e.displayName !== void 0 && (n.displayName = e.displayName), e.displayNamePlural !== void 0 && (n.displayNamePlural = e.displayNamePlural), e.icon !== void 0 && (n.icon = e.icon), e.color !== void 0 && (n.color = e.color), e.inlineTemplate !== void 0 && (n.inlineTemplate = e.inlineTemplate), e.creatable !== void 0 && (n.creatable = e.creatable), e.primaryCapable !== void 0 && (n.primaryCapable = e.primaryCapable), e.supportsTags !== void 0 && (n.supportsTags = e.supportsTags), e.statusBarLayout !== void 0 && (n.statusBarLayout = e.statusBarLayout), e.sharing !== void 0 && (n.sharing = e.sharing), e.draftByDefault !== void 0 && (n.draftByDefault = e.draftByDefault), e.archived !== void 0 && (n.archived = e.archived), e.activity !== void 0 && (n.activity = [...e.activity]), e.roles && (n.roles = { ...t.roles ?? {}, ...e.roles }), e.fields && e.fields.length > 0) {
    const r = new Map(n.fields.map((i, s) => [i.name, s]));
    for (const i of e.fields) {
      const s = r.get(i.name), a = s !== void 0 ? n.fields[s] : void 0, l = wi(a, i);
      s !== void 0 ? l === void 0 ? (n.fields.splice(s, 1), r.clear(), n.fields.forEach((c, d) => r.set(c.name, d))) : n.fields[s] = l : l !== void 0 && (n.fields.push(l), r.set(l.name, n.fields.length - 1));
    }
  }
  return n;
}
function ki(t, e) {
  const n = new Map(t.fields.map((i) => [i.name, i])), r = new Set(e.fields.map((i) => i.name));
  return {
    entries: e.fields.map((i) => ({ seed: n.get(i.name), target: i })),
    removed: t.fields.filter((i) => !r.has(i.name))
  };
}
function qo(t, e) {
  const n = { type: e.type }, r = [
    "displayName",
    "displayNamePlural",
    "icon",
    "color",
    "inlineTemplate",
    "creatable",
    "primaryCapable",
    "supportsTags",
    "sharing",
    "draftByDefault",
    "archived"
  ], i = n;
  for (const u of r)
    t[u] !== e[u] && (i[u] = e[u]);
  const s = e.activity, a = t.activity;
  JSON.stringify(a) !== JSON.stringify(s) && s && (n.activity = [...s]), JSON.stringify(t.statusBarLayout) !== JSON.stringify(e.statusBarLayout) && (n.statusBarLayout = e.statusBarLayout), JSON.stringify(t.roles) !== JSON.stringify(e.roles) && e.roles && (n.roles = e.roles);
  const l = [], { entries: c, removed: d } = ki(t, e);
  for (const { seed: u, target: g } of c)
    if (u) {
      if (JSON.stringify(u) !== JSON.stringify(g)) {
        const { name: p, options: f, ...h } = g, b = { name: p, set: h };
        JSON.stringify(u.options) !== JSON.stringify(f) && (b.options = { set: f ?? [], order: (f ?? []).map((w) => w.value) }), l.push(b);
      }
    } else {
      const { name: p, options: f, ...h } = g, b = { name: p, set: h };
      f && (b.options = { set: f, order: f.map((w) => w.value) }), l.push(b);
    }
  for (const u of d)
    l.push({ name: u.name, remove: !0 });
  return l.length > 0 && (n.fields = l), n;
}
const Ii = /* @__PURE__ */ new Set([
  "string",
  "text",
  "number",
  "select",
  "date",
  "datetime",
  "boolean",
  "user",
  "url"
]);
function Ti(t) {
  return t.type === "relationship" || t.type === "reference" ? !t.multiValue && !t.predicate : Ii.has(t.type);
}
const zn = "declaredForm", Si = "trackerSchemaPatch", qn = "__predicates__", Ni = "trackerPredicateRegistry", Un = "__labels__", Ei = "trackerLabelRegistry";
function Ai(t, e) {
  return JSON.stringify(e ? { ...t, [zn]: e } : t);
}
function vt(t, e) {
  let n;
  try {
    n = JSON.parse(e);
  } catch {
    return null;
  }
  if (!n || typeof n != "object") return null;
  const r = n;
  if (r.payloadKind === Ni) {
    if (t !== qn) return null;
    const l = qr(r.predicates);
    return l.valid ? { kind: "predicates", predicates: l.predicates } : null;
  }
  if (r.payloadKind === Ei) {
    if (t !== Un) return null;
    const l = oi(r.registry);
    return l.valid ? { kind: "labels", registry: l.registry } : null;
  }
  if (r.payloadKind === Si) {
    const l = r.patch;
    return !Kn(l) || l.type !== t ? null : { kind: "patch", patch: l };
  }
  if (r.type !== t || !Array.isArray(r.fields)) return null;
  const { [zn]: i, ...s } = r, a = s;
  return Ci(i, t) ? { kind: "model", model: a, declared: i } : { kind: "model", model: a };
}
function Ci(t, e) {
  if (!t || typeof t != "object") return !1;
  const n = t;
  return n.type === e && typeof n.extends == "string" && n.extends.length > 0 && (n.fields === void 0 || Array.isArray(n.fields));
}
const Li = `type: plan
displayName: Plan
displayNamePlural: Plans
icon: flag
color: "#3b82f6"

modes:
  inline: true
  fullDocument: true

sharing: team
draftByDefault: true

idPrefix: pln
idFormat: ulid

fields:
  - name: planId
    type: string
    required: true
    displayInline: false

  - name: title
    type: string
    required: true
    displayInline: true

  - name: status
    type: select
    required: true
    default: draft
    options:
      - value: draft
        label: Draft
        icon: edit_note
        color: "#64748b"
        category: backlog
      - value: ready-for-development
        label: Ready
        icon: check_circle
        color: "#22c55e"
        category: unstarted
      - value: in-development
        label: In Development
        icon: construction
        color: "#f59e0b"
        category: started
      - value: in-review
        label: In Review
        icon: rate_review
        color: "#3b82f6"
        category: started
      - value: changes-requested
        label: Changes Requested
        icon: edit_note
        color: "#f97316"
        category: started
      - value: approved
        label: Approved
        icon: verified
        color: "#22c55e"
        category: started
      - value: completed
        label: Completed
        icon: task_alt
        color: "#10b981"
        category: done
      - value: rejected
        label: Rejected
        icon: cancel
        color: "#ef4444"
        category: cancelled
      - value: blocked
        label: Blocked
        icon: block
        color: "#dc2626"
        category: started

  - name: planType
    type: select
    required: false
    default: feature
    options:
      - value: system-design
        label: System Design
      - value: feature
        label: Feature
      - value: bug-fix
        label: Bug Fix
      - value: refactor
        label: Refactor
      - value: documentation
        label: Documentation
      - value: research
        label: Research

  - name: priority
    type: select
    required: false
    default: medium
    options:
      - value: low
        label: Low
        icon: arrow_downward
      - value: medium
        label: Medium
        icon: remove
      - value: high
        label: High
        icon: arrow_upward
      - value: critical
        label: Critical
        icon: priority_high

  - name: progress
    type: number
    min: 0
    max: 100
    displayInline: false

  - name: owner
    type: user
    displayInline: true

  - name: stakeholders
    type: array
    itemType: string
    displayInline: false

  # Dependency pair. \`dependsOn\` records work this item waits on; \`blocks\` records
  # work waiting on this item. Writing either side materializes the other.
  - name: dependsOn
    type: relationship
    relationshipTypeKey: depends-on
    inverseRelationshipTypeKey: blocks
    inverseFieldId: blocks
    targetTrackerTypes: "*"
    multiValue: true

  - name: blocks
    type: relationship
    relationshipTypeKey: blocks
    inverseRelationshipTypeKey: depends-on
    inverseFieldId: dependsOn
    targetTrackerTypes: "*"
    multiValue: true

  # Collection membership. Written directly, or by inverse propagation when an
  # item is added to a milestone/release from the collection side.
  - name: collection
    type: relationship
    relationshipTypeKey: in-collection
    inverseRelationshipTypeKey: has-item
    inverseFieldId: items
    targetTrackerTypes:
      - milestone
      - release
    multiValue: true

  # Goal membership. Written directly, or by inverse propagation when an item
  # is added from a goal's \`contributes\` field.
  - name: goal
    type: relationship
    relationshipTypeKey: contributed-by
    inverseRelationshipTypeKey: contributes-to
    inverseFieldId: contributes
    targetTrackerTypes:
      - goal
    multiValue: true

  - name: tags
    type: array
    itemType: string
    displayInline: false

  - name: created
    type: datetime
    displayInline: false
    readOnly: true

  - name: updated
    type: datetime
    displayInline: false
    readOnly: true

  - name: startDate
    type: date
    displayInline: false

  - name: agentSessions
    type: array
    itemType: object
    displayInline: false

statusBarLayout:
  - row:
    - field: status
      width: 200
    - field: priority
      width: 150
    - field: progress
      width: 100
  - row:
    - field: owner
      width: 200
    - field: tags
      width: auto

inlineTemplate: "{icon} {title} {status} {priority}"

roles:
  title: title
  workflowStatus: status
  priority: priority
  assignee: owner
  tags: tags
  progress: progress
  startDate: startDate
`, Pi = `type: decision
displayName: Decision
displayNamePlural: Decisions
icon: gavel
color: "#8b5cf6"

modes:
  inline: true
  fullDocument: true

sharing: team
draftByDefault: false

idPrefix: dec
idFormat: ulid

fields:
  - name: decisionId
    type: string
    required: true
    displayInline: false

  - name: title
    type: string
    required: true
    displayInline: true

  - name: status
    type: select
    default: to-do
    options:
      - value: to-do
        label: To Decide
        icon: help
        category: unstarted
      - value: in-progress
        label: Evaluating
        icon: psychology
        category: started
      - value: decided
        label: Decided
        icon: check_circle
        category: done
      - value: implemented
        label: Implemented
        icon: done_all
        category: done

  - name: chosen
    type: string
    displayInline: true

  - name: priority
    type: select
    required: false
    default: medium
    options:
      - value: low
        label: Low
      - value: medium
        label: Medium
      - value: high
        label: High
      - value: critical
        label: Critical

  - name: owner
    type: user
    displayInline: false

  - name: stakeholders
    type: array
    itemType: string
    displayInline: false

  # Dependency pair. \`dependsOn\` records work this item waits on; \`blocks\` records
  # work waiting on this item. Writing either side materializes the other.
  - name: dependsOn
    type: relationship
    relationshipTypeKey: depends-on
    inverseRelationshipTypeKey: blocks
    inverseFieldId: blocks
    targetTrackerTypes: "*"
    multiValue: true

  - name: blocks
    type: relationship
    relationshipTypeKey: blocks
    inverseRelationshipTypeKey: depends-on
    inverseFieldId: dependsOn
    targetTrackerTypes: "*"
    multiValue: true

  # Collection membership. Written directly, or by inverse propagation when an
  # item is added to a milestone/release from the collection side.
  - name: collection
    type: relationship
    relationshipTypeKey: in-collection
    inverseRelationshipTypeKey: has-item
    inverseFieldId: items
    targetTrackerTypes:
      - milestone
      - release
    multiValue: true

  - name: tags
    type: array
    itemType: string
    displayInline: false

  - name: created
    type: datetime
    displayInline: false
    readOnly: true

  - name: updated
    type: datetime
    displayInline: false
    readOnly: true

statusBarLayout:
  - row:
    - field: status
      width: 200
    - field: chosen
      width: 300
    - field: priority
      width: 150

inlineTemplate: "{icon} {title} {status}"

roles:
  title: title
  workflowStatus: status
  priority: priority
  assignee: owner
  tags: tags
`, Di = `type: bug
displayName: Bug
displayNamePlural: Bugs
icon: bug_report
color: "#dc2626"

modes:
  inline: true
  fullDocument: false

sharing: team
draftByDefault: false

idPrefix: bug
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: to-do
    options:
      - value: to-do
        label: To Do
        icon: circle
        category: unstarted
      - value: in-progress
        label: In Progress
        icon: motion_photos_on
        category: started
      - value: in-review
        label: In Review
        icon: rate_review
        color: "#3b82f6"
        category: started
      - value: changes-requested
        label: Changes Requested
        icon: edit_note
        color: "#f97316"
        category: started
      - value: approved
        label: Approved
        icon: verified
        color: "#22c55e"
        category: started
      - value: done
        label: Done
        icon: check_circle
        category: done
      - value: wont-do
        label: Won't Do
        icon: do_not_disturb_on
        color: "#64748b"
        category: cancelled
      - value: duplicate
        label: Duplicate
        icon: content_copy
        color: "#64748b"
        category: cancelled

  - name: priority
    type: select
    default: medium
    options:
      - value: low
        label: Low
      - value: medium
        label: Medium
      - value: high
        label: High
      - value: critical
        label: Critical

  - name: owner
    type: user

  - name: description
    type: text

  # Dependency pair. \`dependsOn\` records work this item waits on; \`blocks\` records
  # work waiting on this item. Writing either side materializes the other.
  - name: dependsOn
    type: relationship
    relationshipTypeKey: depends-on
    inverseRelationshipTypeKey: blocks
    inverseFieldId: blocks
    targetTrackerTypes: "*"
    multiValue: true

  - name: blocks
    type: relationship
    relationshipTypeKey: blocks
    inverseRelationshipTypeKey: depends-on
    inverseFieldId: dependsOn
    targetTrackerTypes: "*"
    multiValue: true

  # Collection membership. Written directly, or by inverse propagation when an
  # item is added to a milestone/release from the collection side.
  - name: collection
    type: relationship
    relationshipTypeKey: in-collection
    inverseRelationshipTypeKey: has-item
    inverseFieldId: items
    targetTrackerTypes:
      - milestone
      - release
    multiValue: true

  # Goal membership. Written directly, or by inverse propagation when an item
  # is added from a goal's \`contributes\` field.
  - name: goal
    type: relationship
    relationshipTypeKey: contributed-by
    inverseRelationshipTypeKey: contributes-to
    inverseFieldId: contributes
    targetTrackerTypes:
      - goal
    multiValue: true

  - name: tags
    type: array
    itemType: string
    displayInline: false

inlineTemplate: "{icon} {title} {status} {priority}"

roles:
  title: title
  workflowStatus: status
  priority: priority
  assignee: owner
  tags: tags
`, _i = `type: task
displayName: Task
displayNamePlural: Tasks
icon: task_alt
color: "#2563eb"

modes:
  inline: true
  fullDocument: false

sharing: team
draftByDefault: false

idPrefix: tsk
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: to-do
    options:
      - value: to-do
        label: To Do
        icon: circle
        category: unstarted
      - value: in-progress
        label: In Progress
        icon: motion_photos_on
        category: started
      - value: in-review
        label: In Review
        icon: rate_review
        color: "#3b82f6"
        category: started
      - value: changes-requested
        label: Changes Requested
        icon: edit_note
        color: "#f97316"
        category: started
      - value: approved
        label: Approved
        icon: verified
        color: "#22c55e"
        category: started
      - value: done
        label: Done
        icon: check_circle
        category: done
      - value: wont-do
        label: Won't Do
        icon: do_not_disturb_on
        color: "#64748b"
        category: cancelled
      - value: duplicate
        label: Duplicate
        icon: content_copy
        color: "#64748b"
        category: cancelled

  - name: priority
    type: select
    default: medium
    options:
      - value: low
        label: Low
      - value: medium
        label: Medium
      - value: high
        label: High
      - value: critical
        label: Critical

  - name: owner
    type: user

  - name: description
    type: text

  # Dependency pair. \`dependsOn\` records work this item waits on; \`blocks\` records
  # work waiting on this item. Writing either side materializes the other.
  - name: dependsOn
    type: relationship
    relationshipTypeKey: depends-on
    inverseRelationshipTypeKey: blocks
    inverseFieldId: blocks
    targetTrackerTypes: "*"
    multiValue: true

  - name: blocks
    type: relationship
    relationshipTypeKey: blocks
    inverseRelationshipTypeKey: depends-on
    inverseFieldId: dependsOn
    targetTrackerTypes: "*"
    multiValue: true

  # Collection membership. Written directly, or by inverse propagation when an
  # item is added to a milestone/release from the collection side.
  - name: collection
    type: relationship
    relationshipTypeKey: in-collection
    inverseRelationshipTypeKey: has-item
    inverseFieldId: items
    targetTrackerTypes:
      - milestone
      - release
    multiValue: true

  # Goal membership. Written directly, or by inverse propagation when an item
  # is added from a goal's \`contributes\` field.
  - name: goal
    type: relationship
    relationshipTypeKey: contributed-by
    inverseRelationshipTypeKey: contributes-to
    inverseFieldId: contributes
    targetTrackerTypes:
      - goal
    multiValue: true

  - name: tags
    type: array
    itemType: string
    displayInline: false

inlineTemplate: "{icon} {title} {status} {owner}"

roles:
  title: title
  workflowStatus: status
  priority: priority
  assignee: owner
  tags: tags
`, Ri = `type: idea
displayName: Idea
displayNamePlural: Ideas
icon: lightbulb
color: "#ca8a04"

modes:
  inline: true
  fullDocument: false

sharing: personal
draftByDefault: false

idPrefix: id
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: new
    options:
      - value: new
        label: New
        icon: fiber_new
        category: backlog
      - value: considering
        label: Considering
        icon: psychology
        category: started
      - value: accepted
        label: Accepted
        icon: thumb_up
        category: started
      - value: rejected
        label: Rejected
        icon: thumb_down
        category: cancelled

  # Dependency pair. \`dependsOn\` records work this item waits on; \`blocks\` records
  # work waiting on this item. Writing either side materializes the other.
  - name: dependsOn
    type: relationship
    relationshipTypeKey: depends-on
    inverseRelationshipTypeKey: blocks
    inverseFieldId: blocks
    targetTrackerTypes: "*"
    multiValue: true

  - name: blocks
    type: relationship
    relationshipTypeKey: blocks
    inverseRelationshipTypeKey: depends-on
    inverseFieldId: dependsOn
    targetTrackerTypes: "*"
    multiValue: true

  # Collection membership. Written directly, or by inverse propagation when an
  # item is added to a milestone/release from the collection side.
  - name: collection
    type: relationship
    relationshipTypeKey: in-collection
    inverseRelationshipTypeKey: has-item
    inverseFieldId: items
    targetTrackerTypes:
      - milestone
      - release
    multiValue: true

  - name: tags
    type: array
    itemType: string
    displayInline: false

inlineTemplate: "{icon} {title} {status}"

roles:
  title: title
  workflowStatus: status
  tags: tags
`, $i = `type: milestone
displayName: Milestone
displayNamePlural: Milestones
icon: flag
color: "#8b5cf6"

modes:
  inline: false
  fullDocument: true

sharing: team
draftByDefault: false

idPrefix: mst
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: planned
    options:
      - value: planned
        label: Planned
        icon: schedule
        color: "#6b7280"
        category: unstarted
      - value: active
        label: Active
        icon: play_circle
        color: "#eab308"
        category: started
      - value: done
        label: Done
        icon: check_circle
        color: "#22c55e"
        category: done
      - value: cancelled
        label: Cancelled
        icon: cancel
        color: "#ef4444"
        category: cancelled

  - name: owner
    type: user

  - name: startDate
    type: date

  - name: targetDate
    type: date

  - name: description
    type: text

  # Membership edge. The inverse (\`collection\` on each member) is written by
  # inverse-relationship propagation, so adding an item here is a single write.
  - name: items
    type: relationship
    relationshipTypeKey: has-item
    inverseRelationshipTypeKey: in-collection
    inverseFieldId: collection
    targetTrackerTypes: "*"
    multiValue: true
    childRelationship: true

  - name: tags
    type: array
    itemType: string
    displayInline: false

roles:
  title: title
  workflowStatus: status
  assignee: owner
  startDate: startDate
  dueDate: targetDate
  tags: tags

tableView:
  defaultColumns:
    - title
    - status
    - owner
    - targetDate
  sortable: true
  filterable: true
  exportable: true
`, Mi = `type: release
displayName: Release
displayNamePlural: Releases
icon: rocket_launch
color: "#0ea5e9"

modes:
  inline: false
  fullDocument: true

sharing: team
draftByDefault: false

idPrefix: rel
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  # A release exists before it is built, so it starts with no version or tag --
  # the release scripts fill those in and flip the status at build time.
  - name: status
    type: select
    default: planned
    options:
      - value: planned
        label: Planned
        icon: schedule
        color: "#6b7280"
        category: unstarted
      - value: in-progress
        label: In Progress
        icon: play_circle
        color: "#eab308"
        category: started
      - value: released
        label: Released
        icon: rocket_launch
        color: "#22c55e"
        category: done
      - value: cancelled
        label: Cancelled
        icon: cancel
        color: "#ef4444"
        category: cancelled

  - name: version
    type: string

  - name: gitTag
    type: string

  - name: channel
    type: select
    options:
      - value: alpha
        label: Alpha
      - value: stable
        label: Stable

  - name: releasedAt
    type: datetime

  - name: owner
    type: user

  - name: description
    type: text

  # Same membership edge as \`milestone\`, so both collection types share the
  # rollup and add-to-collection machinery.
  - name: items
    type: relationship
    relationshipTypeKey: has-item
    inverseRelationshipTypeKey: in-collection
    inverseFieldId: collection
    targetTrackerTypes: "*"
    multiValue: true
    childRelationship: true

  - name: tags
    type: array
    itemType: string
    displayInline: false

roles:
  title: title
  workflowStatus: status
  assignee: owner
  tags: tags

tableView:
  defaultColumns:
    - title
    - status
    - version
    - channel
    - releasedAt
  sortable: true
  filterable: true
  exportable: true
`, Oi = `# Builtin knowledge evidence kind.
# A source is the IDENTITY of an original document, not a copy of it and not one
# retrieval of it. Retrievals are \`capture\` items pointing here, so a document
# fetched ten times over a year is one source with ten captures, and a citation
# can say which retrieval it rests on.
type: source
displayName: Source
displayNamePlural: Sources
icon: menu_book
color: "#0891b2"

modes:
  inline: true
  # A source carries no argument, so it has no body worth a document view.
  fullDocument: false

sharing: personal
draftByDefault: false
# Not offered in type lists until the workspace defines \`claim\`.
hiddenUntilType: claim

idPrefix: src
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: active
    options:
      - value: active
        label: Active
        icon: check_circle
        category: started
      - value: superseded
        label: Superseded
        icon: history
        category: done
      - value: unavailable
        label: Unavailable
        icon: link_off
        category: cancelled

  # The canonical address of the source. A capture records the URL that actually
  # answered, which is often not this one.
  - name: url
    type: url
    displayInline: true

  - name: publisher
    type: string
    displayInline: true

  - name: sourceKind
    type: select
    default: web-page
    options:
      - value: web-page
        label: Web page
        icon: language
      - value: document
        label: Document
        icon: description
      - value: repository
        label: Repository
        icon: code
      - value: dataset
        label: Dataset
        icon: dataset
      - value: media
        label: Audio or video
        icon: play_circle
      - value: conversation
        label: Conversation
        icon: forum
      - value: test-result
        label: Test result
        icon: fact_check

  # Other names the same source is known by. Alias resolution is what keeps two
  # people citing one document from creating two sources.
  - name: aliases
    type: array
    itemType: string
    displayInline: false

  - name: tags
    type: array
    itemType: string
    displayInline: false

  - name: created
    type: datetime
    displayInline: false
    readOnly: true

  - name: updated
    type: datetime
    displayInline: false
    readOnly: true

statusBarLayout:
  - row:
    - field: status
      width: 160
    - field: sourceKind
      width: 160
    - field: publisher
      width: 220

inlineTemplate: "{icon} {title}"

roles:
  title: title
  workflowStatus: status
  tags: tags
`, Fi = `# Builtin knowledge evidence kind.
# One retrieval of one source, at one time, with one outcome. A capture is what
# makes a citation checkable later: \`digest\` and \`capturedAt\` are what a recheck
# compares against, and a recheck appends to the capture rather than rewriting
# the citation (contract 4.4).
type: capture
displayName: Capture
displayNamePlural: Captures
icon: photo_camera
color: "#0d9488"

modes:
  inline: true
  # A capture is a record of an event, not a place to write.
  fullDocument: false

sharing: personal
draftByDefault: false
# Not offered in type lists until the workspace defines \`claim\`.
hiddenUntilType: claim

idPrefix: cap
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: recorded
    options:
      - value: recorded
        label: Recorded
        icon: check_circle
        category: done
      - value: stale
        label: Stale
        icon: schedule
        category: started
      - value: unresolvable
        label: Unresolvable
        icon: link_off
        category: cancelled

  - name: source
    type: relationship
    relationshipTypeKey: captured-from
    targetTrackerTypes:
      - source
    multiValue: false

  - name: capturedAt
    type: datetime
    displayInline: true

  # What actually answered, which is frequently not the source's canonical URL:
  # redirects, mirrors, and archive copies all land here.
  - name: resolvedUrl
    type: url
    displayInline: false

  - name: contentType
    type: string
    displayInline: false

  # Content hash of what was retrieved. The only thing that can tell a recheck
  # "the page changed" from "the page is the same and my locator broke".
  - name: digest
    type: string
    displayInline: false

  - name: outcome
    type: select
    default: retrieved
    options:
      - value: retrieved
        label: Retrieved
        icon: download_done
      - value: partial
        label: Partial
        icon: hourglass_bottom
      - value: not-found
        label: Not found
        icon: search_off
      - value: forbidden
        label: Forbidden
        icon: block
      - value: error
        label: Error
        icon: error

  - name: tags
    type: array
    itemType: string
    displayInline: false

  - name: created
    type: datetime
    displayInline: false
    readOnly: true

  - name: updated
    type: datetime
    displayInline: false
    readOnly: true

statusBarLayout:
  - row:
    - field: status
      width: 160
    - field: outcome
      width: 160
    - field: capturedAt
      width: 200

inlineTemplate: "{icon} {title}"

roles:
  title: title
  workflowStatus: status
  tags: tags
`, Bi = `# Builtin knowledge evidence kind.
# A passage supporting or challenging an exact revision of a claim. The three
# fields that make it more than a link: \`locator\` addresses the passage,
# \`capture\` says which retrieval the passage was read from, and \`claim\` pins the
# revision it was read against.
type: citation
displayName: Citation
displayNamePlural: Citations
icon: format_quote
color: "#7c3aed"

modes:
  inline: true
  # A citation is evidence about something else; its content is the excerpt.
  fullDocument: false

sharing: personal
draftByDefault: false
# Not offered in type lists until the workspace defines \`claim\`.
hiddenUntilType: claim

idPrefix: cit
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: asserted
    options:
      - value: asserted
        label: Asserted
        icon: check_circle
        category: started
      - value: verified
        label: Verified
        icon: verified
        category: done
      - value: stale
        label: Stale
        icon: schedule
        category: started
      - value: broken
        label: Broken
        icon: link_off
        category: cancelled

  # What this citation is evidence about, pinned to an exact revision via the
  # relationship value's \`revisionId\` (contract 4.2).
  #
  # \`*\` rather than \`[claim]\` deliberately: citations can refer to a decision,
  # a plan, or a bug even without a custom \`claim\` type.
  - name: claim
    type: relationship
    relationshipTypeKey: cites
    targetTrackerTypes: "*"
    multiValue: false

  - name: capture
    type: relationship
    relationshipTypeKey: read-from
    targetTrackerTypes:
      - capture
    multiValue: false

  - name: relation
    type: select
    default: supports
    options:
      - value: supports
        label: Supports
        icon: thumb_up
      - value: challenges
        label: Challenges
        icon: thumb_down
      - value: context
        label: Context
        icon: info

  # The address of the passage. Validated by \`validateCitationLocator\` against
  # contract 4.4 -- the \`objectShape\` marker is what routes it there instead of
  # letting it through as opaque JSON.
  - name: locator
    type: object
    objectShape: citation-locator
    displayInline: false

  - name: excerpt
    type: text
    displayInline: false

  # Why the excerpt supports or challenges the claim. The excerpt rarely says so
  # on its own, and without this a reader has to re-derive the argument.
  - name: explanation
    type: text
    displayInline: false

  - name: tags
    type: array
    itemType: string
    displayInline: false

  - name: created
    type: datetime
    displayInline: false
    readOnly: true

  - name: updated
    type: datetime
    displayInline: false
    readOnly: true

statusBarLayout:
  - row:
    - field: status
      width: 160
    - field: relation
      width: 160

inlineTemplate: "{icon} {title} {relation}"

roles:
  title: title
  workflowStatus: status
  tags: tags
`, ji = `# Local overlay for a GitHub issue. The Issues panel creates one when you
# triage an issue or start an investigation session from it, and adoption
# records the tracker item the issue became. Unlisted: these items are written
# by the panel and the GitHub tools, not made by hand. A workspace schema of the
# same name replaces this one wholesale.
type: github-issue
displayName: GitHub Issue
displayNamePlural: GitHub Issues
icon: adjust
color: "#f97316"

modes:
  inline: false
  fullDocument: false

sharing: personal
draftByDefault: false
listed: false

idPrefix: ghi
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: needs-triage
    options:
      - value: needs-triage
        label: Needs Triage
        icon: inbox
        category: unstarted
      - value: investigating
        label: Investigating
        icon: search
        color: "#eab308"
        category: started
      - value: needs-info
        label: Needs Info
        icon: help
        color: "#eab308"
        category: started
      - value: keep-accept
        label: Keep / Accept
        icon: check_circle
        color: "#22c55e"
        category: started
      - value: adopted
        label: Adopted
        icon: move_item
        color: "#3b82f6"
        category: done
      - value: close-fixed
        label: "Close: Already Fixed"
        icon: verified
        color: "#3b82f6"
        category: done
      - value: close-duplicate
        label: "Close: Duplicate"
        icon: content_copy
        color: "#8b5cf6"
        category: cancelled
      - value: close-wontfix
        label: "Close: Won't Do"
        icon: do_not_disturb_on
        color: "#64748b"
        category: cancelled

  - name: priority
    type: select
    default: medium
    options:
      - value: low
        label: Low
      - value: medium
        label: Medium
      - value: high
        label: High
      - value: critical
        label: Critical

  - name: issueUrl
    type: url
    required: true

  - name: issueNumber
    type: number

  - name: repo
    type: string

  - name: author
    type: string

  - name: adoptedItemId
    type: string

  - name: notes
    type: text

  - name: ghLabels
    type: array
    itemType: string
    displayInline: false

tableView:
  defaultColumns:
    - issueNumber
    - title
    - status
    - priority
    - author
  sortable: true
  filterable: true
  exportable: false

roles:
  title: title
  workflowStatus: status
  priority: priority
  tags: ghLabels
`, Vi = `# Local overlay for a GitHub pull request. The Pull Requests panel creates one
# when you start a review session, so the session stays attached to the PR.
# Unlisted: these items are written by the panel and the GitHub tools, not made
# by hand. A workspace schema of the same name replaces this one wholesale.
type: github-pr
displayName: GitHub PR
displayNamePlural: GitHub PRs
icon: merge_type
color: "#8b5cf6"

modes:
  inline: false
  fullDocument: false

sharing: personal
draftByDefault: false
listed: false

idPrefix: ghp
idFormat: ulid

fields:
  - name: title
    type: string
    required: true

  - name: status
    type: select
    default: to-review
    options:
      - value: to-review
        label: To Review
        icon: inbox
        category: unstarted
      - value: reviewing
        label: Reviewing
        icon: search
        color: "#eab308"
        category: started
      - value: approved
        label: Approved
        icon: verified
        color: "#22c55e"
        category: started
      - value: merged
        label: Merged
        icon: merge
        color: "#8b5cf6"
        category: done
      - value: closed
        label: Closed
        icon: cancel
        color: "#64748b"
        category: cancelled

  - name: prUrl
    type: url
    required: true

  - name: prNumber
    type: number

  - name: repo
    type: string

  - name: author
    type: string

  - name: headBranch
    type: string

  - name: baseBranch
    type: string

  - name: notes
    type: text

  - name: tags
    type: array
    itemType: string
    displayInline: false

tableView:
  defaultColumns:
    - prNumber
    - title
    - status
    - author
  sortable: true
  filterable: true
  exportable: false

roles:
  title: title
  workflowStatus: status
  tags: tags
`, Ki = [
  { type: "plan", yaml: Li },
  { type: "decision", yaml: Pi },
  { type: "bug", yaml: Di },
  { type: "task", yaml: _i },
  { type: "idea", yaml: Ri },
  { type: "milestone", yaml: $i },
  { type: "release", yaml: Mi },
  // Load order matters for readability only, but it follows the evidence chain:
  // a capture points at a source, a citation points at a capture.
  { type: "source", yaml: Oi },
  { type: "capture", yaml: Fi },
  { type: "citation", yaml: Bi },
  { type: "github-issue", yaml: ji },
  { type: "github-pr", yaml: Vi }
  // { type: 'feature', yaml: featureYaml },
  // { type: 'automation', yaml: automationYaml },
];
function Uo() {
  return Ki.map(({ type: t, yaml: e }) => {
    const n = Bn(e);
    if (n.type !== t)
      throw new Error(
        `Builtin tracker YAML for '${t}' declares mismatched type '${n.type}'`
      );
    return n;
  });
}
const zi = [
  "workflowStatus",
  "priority",
  "assignee",
  "reporter",
  "tags",
  "startDate",
  "dueDate",
  "progress"
], qi = {
  workflowStatus: "status",
  priority: "priority",
  assignee: "owner",
  reporter: "reporterEmail",
  tags: "tags",
  startDate: "startDate",
  dueDate: "dueDate",
  progress: "progress"
}, Ui = /* @__PURE__ */ new Set(["title", "description", "created", "updated"]), Yi = /* @__PURE__ */ new Set(["multiselect", "object"]);
function Wi(t, e = [], n = {}) {
  const r = ue.get(t);
  if (!r) return [];
  const i = new Map(r.fields.map((c) => [c.name, c])), s = [], a = /* @__PURE__ */ new Set(), l = (c) => {
    !c || a.has(c.name) || Ui.has(c.name) || c.readOnly || Yi.has(c.type) || n.singleValuedOnly && !Ti(c) || (a.add(c.name), s.push(c));
  };
  for (const c of zi) {
    const d = r.roles?.[c] ?? qi[c];
    l(d ? i.get(d) : void 0);
  }
  for (const c of r.fields) l(c);
  for (const c of e) l(c);
  return s;
}
function wt(t) {
  const e = t.displayLabel;
  return typeof e == "string" && e ? e : Hi(t.name);
}
function Hi(t) {
  return t.replace(/([A-Z])/g, " $1").replace(/^./, (e) => e.toUpperCase()).trim();
}
const Ji = /* @__PURE__ */ new Set([
  "date",
  "datetime",
  "url",
  "user",
  "relationship",
  "reference",
  "citation"
]);
function Gi(t, e, n = !1) {
  return At(e) ? !1 : Ji.has(t.type) ? !0 : n ? t.type !== "select" || !t.options?.find((r) => r.value === e)?.icon : !1;
}
function At(t) {
  if (t == null || t === "") return !0;
  if (Array.isArray(t)) return t.length === 0;
  if (t instanceof Date) return Number.isNaN(t.getTime());
  if (typeof t == "object") {
    const e = t;
    return "url" in e || "label" in e || "itemId" in e ? !e.url && !e.label && !e.itemId : Object.keys(e).length === 0;
  }
  return !1;
}
function Yn(t) {
  return t.issueKey ?? t.id;
}
function Jt(t) {
  return {
    referenceKey: Yn(t),
    id: t.id,
    issueKey: t.issueKey,
    title: t.title,
    status: t.status,
    type: t.type
  };
}
function Qi(t, e) {
  const n = e.toLowerCase();
  return t.type?.toLowerCase() === n ? !0 : (t.typeTags ?? []).some((r) => r.toLowerCase() === n);
}
function Wn(t, e = /* @__PURE__ */ new Set()) {
  for (const n of t) {
    n.type && e.add(n.type.toLowerCase());
    for (const r of n.typeTags ?? []) e.add(r.toLowerCase());
  }
  return e;
}
function Xi(t, e) {
  const n = t ?? "", r = n.indexOf(":");
  if (r > 0) {
    const i = n.slice(0, r).toLowerCase();
    if (e.has(i))
      return { typeFilter: i, searchQuery: n.slice(r + 1) };
  }
  return { typeFilter: null, searchQuery: n };
}
function Zi(t, e, n = {}) {
  const { typeFilter: r = null, limit: i = 25 } = n;
  let s = [...t].filter((c) => !c.archived);
  r && (s = s.filter((c) => Qi(c, r)));
  const a = e?.trim().toLowerCase() ?? "";
  if (!a)
    return s.sort((c, d) => (d.issueNumber ?? 0) - (c.issueNumber ?? 0)).slice(0, i).map(Jt);
  const l = [];
  for (const c of s) {
    const d = Yn(c).toLowerCase(), u = c.issueKey?.toLowerCase() ?? "", g = (c.title ?? "").toLowerCase(), p = (c.description ?? "").toLowerCase();
    let f = -1;
    d.startsWith(a) || u.startsWith(a) ? f = 0 : d.includes(a) || u.includes(a) ? f = 1 : g.startsWith(a) ? f = 2 : g.includes(a) ? f = 3 : p.includes(a) && (f = 4), f >= 0 && l.push({ candidate: c, score: f });
  }
  return l.sort((c, d) => c.score !== d.score ? c.score - d.score : (d.candidate.issueNumber ?? 0) - (c.candidate.issueNumber ?? 0)).slice(0, i).map(({ candidate: c }) => Jt(c));
}
function es(t, e, n = {}) {
  const r = n.knownTypes ?? Wn(t), { typeFilter: i, searchQuery: s } = Xi(e, r);
  return {
    options: Zi(t, s, { typeFilter: i, limit: n.limit }),
    typeFilter: i,
    searchQuery: s
  };
}
function ts(t, e) {
  return e?.title || t.title || e?.issueKey || t.issueKey || t.itemId;
}
const ns = ({
  field: t,
  value: e,
  onChange: n,
  candidates: r = [],
  onOpenItem: i,
  readOnly: s
}) => {
  const [a, l] = O(""), [c, d] = O(!1), u = ce(null);
  pe(() => {
    c && u.current?.focus();
  }, [c]);
  const g = Q(() => Qe(e), [e]), p = Q(() => new Set(g.map((T) => T.itemId)), [g]), f = Q(() => new Map(r.map((T) => [T.itemId, T])), [r]), h = Q(() => hr(t.relationshipTypeKey), [t.relationshipTypeKey]), b = h?.color, w = `rel-cand-${t.name}`, L = (T) => {
    n(xn(t, T));
  }, N = (T) => {
    const $ = T.trim();
    if (!$) return null;
    const F = $.toLowerCase(), z = r.find(
      (k) => k.issueKey?.toLowerCase() === F || k.itemId.toLowerCase() === F || k.title?.toLowerCase() === F
    );
    return z || null;
  }, E = () => {
    const T = N(a);
    if (!T || p.has(T.itemId)) {
      l("");
      return;
    }
    const $ = wn(t, g, {
      itemId: T.itemId,
      title: T.title,
      issueKey: T.issueKey,
      trackerType: T.trackerType
    });
    L($), l(""), t.multiValue || d(!1);
  }, A = () => {
    l(""), d(!1);
  }, j = (T) => {
    L(vn(g, T));
  };
  return /* @__PURE__ */ m("div", { className: "relationship-field-editor flex flex-col gap-1.5", "data-testid": `relationship-field-${t.name}`, children: [
    h && /* @__PURE__ */ m(
      "span",
      {
        className: "relationship-type-badge inline-flex w-fit items-center gap-1 text-[10px] uppercase tracking-[0.5px] text-[var(--nim-text-faint)]",
        title: h.description || h.displayName,
        children: [
          h.icon && /* @__PURE__ */ o("span", { className: "material-symbols-outlined text-[12px]", children: h.icon }),
          h.displayName,
          h.symmetric && /* @__PURE__ */ o("span", { className: "normal-case tracking-normal", children: "(both ways)" })
        ]
      }
    ),
    /* @__PURE__ */ m("div", { className: "flex flex-wrap gap-1", children: [
      g.length === 0 && /* @__PURE__ */ o("span", { className: "text-[12px] text-[var(--nim-text-faint)] italic", children: "No links" }),
      g.map((T) => {
        const $ = f.get(T.itemId), F = ts(T, $);
        return /* @__PURE__ */ m(
          "span",
          {
            className: "relationship-pill inline-flex items-center gap-1 rounded-full bg-[var(--nim-bg-tertiary)] px-2 py-0.5 text-[12px] text-[var(--nim-text)]",
            style: b ? { backgroundColor: `${b}22`, color: b } : void 0,
            children: [
              /* @__PURE__ */ o(
                "button",
                {
                  type: "button",
                  className: "relationship-pill-open hover:underline",
                  title: $?.title || T.title || T.itemId,
                  onClick: () => i?.(T.itemId),
                  children: F
                }
              ),
              !s && /* @__PURE__ */ o(
                "button",
                {
                  type: "button",
                  className: "relationship-pill-remove text-[var(--nim-text-faint)] hover:text-[var(--nim-error)]",
                  title: "Remove link",
                  "aria-label": `Remove ${F}`,
                  onClick: () => j(T.itemId),
                  children: "×"
                }
              )
            ]
          },
          T.itemId
        );
      })
    ] }),
    !s && !c && /* @__PURE__ */ o(
      "button",
      {
        type: "button",
        className: "relationship-add-toggle inline-flex w-fit items-center text-[var(--nim-text-faint)] hover:text-[var(--nim-text)]",
        title: "Add link",
        "aria-label": "Add link",
        onClick: () => d(!0),
        children: /* @__PURE__ */ o("span", { className: "material-symbols-outlined text-[16px]", children: "add" })
      }
    ),
    !s && c && /* @__PURE__ */ m("div", { className: "flex gap-1", children: [
      /* @__PURE__ */ o(
        "input",
        {
          ref: u,
          type: "text",
          list: w,
          value: a,
          placeholder: "Link an item…",
          className: "flex-1 py-1 px-2 border border-[var(--nim-border)] rounded bg-[var(--nim-bg)] text-[var(--nim-text)] text-[12px] focus:outline-none focus:border-[var(--nim-primary)]",
          onChange: (T) => l(T.target.value),
          onKeyDown: (T) => {
            T.key === "Enter" ? (T.preventDefault(), E()) : T.key === "Escape" && (T.preventDefault(), A());
          }
        }
      ),
      /* @__PURE__ */ o("datalist", { id: w, children: r.filter((T) => !p.has(T.itemId)).map((T) => /* @__PURE__ */ o("option", { value: T.issueKey || T.title || T.itemId, children: T.title || T.itemId }, T.itemId)) }),
      /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          className: "relationship-add px-2 py-1 rounded text-[12px] bg-[var(--nim-primary)] text-[var(--nim-on-primary)] disabled:opacity-40",
          disabled: !a.trim(),
          onClick: E,
          children: "Add"
        }
      ),
      /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          className: "relationship-add-cancel px-1.5 py-1 rounded text-[12px] text-[var(--nim-text-faint)] hover:text-[var(--nim-text)]",
          title: "Cancel",
          "aria-label": "Cancel adding link",
          onClick: A,
          children: "×"
        }
      )
    ] })
  ] });
}, rs = Pe.lazy(
  () => import("./CitationFieldEditor-DVKZmKgp.js").then((t) => ({ default: t.CitationFieldEditor }))
), is = Pe.lazy(
  () => import("./LabelRefPicker-DtkArwxL.js").then((t) => ({ default: t.LabelRefPicker }))
), Gt = "text-[11px] font-medium text-[var(--nim-text-muted)] uppercase tracking-[0.5px]", Ae = "py-1.5 px-2 border border-[var(--nim-border)] rounded bg-[var(--nim-bg)] text-[var(--nim-text)] text-[13px] font-inherit transition-colors duration-200 focus:outline-none focus:border-[var(--nim-primary)] focus:shadow-[0_0_0_2px_rgba(59,130,246,0.1)]";
function ss(t) {
  return t.replace(/([A-Z])/g, " $1").replace(/^./, (e) => e.toUpperCase()).trim();
}
function Hn(t) {
  if (!t) return { display: "--", title: "" };
  const e = yr(t);
  if (!e) return { display: String(t), title: "" };
  const n = e.toLocaleDateString(void 0, {
    month: "short",
    day: "numeric",
    year: "numeric"
  }), r = e.toLocaleString(void 0, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
  return { display: n, title: r };
}
const Ct = ({
  field: t,
  value: e,
  onChange: n,
  layout: r = "vertical",
  teamMembers: i,
  relationshipCandidates: s,
  onOpenRelationship: a,
  citationHost: l,
  showLabel: c = !0
}) => {
  const d = `field-${t.name}`, u = t.displayLabel || ss(t.name), g = t.type, p = (h) => c ? /* @__PURE__ */ o("label", { htmlFor: h, className: Gt, children: u }) : null, f = r === "horizontal" ? "flex flex-row items-center gap-2 min-w-[120px]" : "flex flex-col gap-1 min-w-[120px]";
  if (t.readOnly && (g === "datetime" || g === "date")) {
    const { display: h, title: b } = Hn(e);
    return /* @__PURE__ */ m("div", { className: f, children: [
      p(),
      /* @__PURE__ */ o(
        "span",
        {
          className: "text-[13px] text-[var(--nim-text-muted)] py-1.5",
          title: b,
          children: h
        }
      )
    ] });
  }
  switch (g) {
    case "select":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          jr,
          {
            value: e || t.default || "",
            options: t.options || [],
            onChange: n,
            required: t.required
          }
        )
      ] });
    case "number":
      return t.min !== void 0 && t.max !== void 0 ? /* @__PURE__ */ m("div", { className: `${f} status-bar-field-slider`, children: [
        /* @__PURE__ */ m("div", { className: "slider-header flex justify-between items-center gap-2 mb-1 w-full", children: [
          c && /* @__PURE__ */ o("label", { htmlFor: d, className: `${Gt} flex-1 mb-0`, children: u }),
          /* @__PURE__ */ o(
            "input",
            {
              type: "number",
              className: "w-[60px] py-1 px-2 border border-[var(--nim-border)] rounded bg-[var(--nim-bg)] text-[var(--nim-text)] text-[13px] font-semibold font-inherit text-center transition-colors duration-200 focus:outline-none focus:border-[var(--nim-primary)] focus:shadow-[0_0_0_2px_rgba(59,130,246,0.1)]",
              value: e ?? t.default ?? t.min,
              min: t.min,
              max: t.max,
              onChange: (b) => {
                const w = Number(b.target.value);
                isNaN(w) || n(w);
              }
            }
          )
        ] }),
        /* @__PURE__ */ o(
          "input",
          {
            id: d,
            type: "range",
            className: "w-full",
            value: e ?? t.default ?? t.min,
            min: t.min,
            max: t.max,
            onChange: (b) => n(Number(b.target.value))
          }
        )
      ] }) : /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          "input",
          {
            id: d,
            type: "number",
            className: Ae,
            value: e ?? t.default ?? "",
            min: t.min,
            max: t.max,
            onChange: (b) => n(Number(b.target.value))
          }
        )
      ] });
    case "date":
    case "datetime": {
      let h = e || "";
      return e instanceof Date && !isNaN(e.getTime()) && (h = gr(e)), /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          "input",
          {
            id: d,
            type: "date",
            className: Ae,
            value: h,
            onChange: (b) => n(b.target.value)
          }
        )
      ] });
    }
    case "text":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          "textarea",
          {
            id: d,
            className: `${Ae} min-h-[80px] resize-y`,
            value: e || "",
            onChange: (h) => n(h.target.value),
            placeholder: t.required ? "Required" : "Optional"
          }
        )
      ] });
    case "user":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          os,
          {
            value: e || "",
            onChange: n,
            placeholder: t.required ? "Required" : "Optional",
            teamMembers: i
          }
        )
      ] });
    case "string":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          "input",
          {
            id: d,
            type: "text",
            className: Ae,
            value: e || "",
            onChange: (h) => n(h.target.value),
            placeholder: t.required ? "Required" : "Optional"
          }
        )
      ] });
    case "array":
      if (t.itemType === "object" || Array.isArray(e) && e.some((h) => h !== null && typeof h == "object")) {
        const h = Array.isArray(e) && e.length > 0 ? e.map((b) => b !== null && typeof b == "object" ? JSON.stringify(b) : String(b)).join(", ") : "--";
        return /* @__PURE__ */ m("div", { className: f, children: [
          p(),
          /* @__PURE__ */ o("span", { className: "text-[13px] text-[var(--nim-text-muted)] py-1.5", children: h })
        ] });
      }
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          as,
          {
            value: Array.isArray(e) ? e : [],
            onChange: n
          }
        )
      ] });
    case "url":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(d),
        /* @__PURE__ */ o(
          cs,
          {
            id: d,
            value: e,
            onChange: n,
            placeholder: t.required ? "Required" : "https://..."
          }
        )
      ] });
    case "boolean":
      return /* @__PURE__ */ o("div", { className: r === "horizontal" ? "flex flex-row items-center gap-2 min-w-[120px]" : "flex flex-row items-center min-w-[120px]", children: /* @__PURE__ */ m("label", { htmlFor: d, className: "flex items-center gap-1.5 normal-case tracking-normal text-[13px] cursor-pointer text-[var(--nim-text)]", children: [
        /* @__PURE__ */ o(
          "input",
          {
            id: d,
            type: "checkbox",
            className: "cursor-pointer w-4 h-4",
            checked: e || !1,
            onChange: (h) => n(h.target.checked)
          }
        ),
        u
      ] }) });
    case "relationship":
    case "reference":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(),
        /* @__PURE__ */ o(
          ns,
          {
            field: t,
            value: e,
            onChange: n,
            candidates: s,
            onOpenItem: a,
            readOnly: t.readOnly
          }
        )
      ] });
    case "citation":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(),
        /* @__PURE__ */ o(Pe.Suspense, { fallback: /* @__PURE__ */ o("span", { className: "citation-field-loading text-[12px] text-[var(--nim-text-muted)]", children: "Loading citations..." }), children: /* @__PURE__ */ o(
          rs,
          {
            field: t,
            value: e,
            onChange: n,
            host: l ?? { lookupItem: () => null },
            candidates: s,
            onOpenItem: a,
            readOnly: t.readOnly || !l
          }
        ) })
      ] });
    case "label-ref":
      return /* @__PURE__ */ m("div", { className: f, children: [
        p(),
        /* @__PURE__ */ o(Pe.Suspense, { fallback: null, children: /* @__PURE__ */ o(is, { value: e, onChange: n, readOnly: t.readOnly }) })
      ] });
    default:
      return null;
  }
}, as = ({ value: t, onChange: e }) => {
  const [n, r] = O(""), i = ce(null), s = () => {
    const c = n.trim();
    c && !t.includes(c) && e([...t, c]), r("");
  }, a = (c) => {
    e(t.filter((d) => d !== c));
  }, l = (c) => {
    c.key === "Enter" || c.key === "," ? (c.preventDefault(), s()) : c.key === "Backspace" && !n && t.length > 0 && e(t.slice(0, -1));
  };
  return /* @__PURE__ */ m(
    "div",
    {
      className: "flex flex-wrap items-center gap-1 p-1.5 border border-[var(--nim-border)] rounded bg-[var(--nim-bg)] min-h-[32px] cursor-text",
      onClick: () => i.current?.focus(),
      children: [
        t.map((c) => /* @__PURE__ */ m(
          "span",
          {
            className: "inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-[var(--nim-bg-tertiary)] text-[var(--nim-text)] text-[11px]",
            children: [
              c,
              /* @__PURE__ */ o(
                "button",
                {
                  className: "text-[var(--nim-text-faint)] hover:text-[var(--nim-text)] ml-0.5",
                  onClick: (d) => {
                    d.stopPropagation(), a(c);
                  },
                  children: /* @__PURE__ */ o("span", { className: "material-symbols-outlined", style: { fontSize: "10px" }, children: "close" })
                }
              )
            ]
          },
          c
        )),
        /* @__PURE__ */ o(
          "input",
          {
            ref: i,
            type: "text",
            className: "flex-1 min-w-[60px] bg-transparent border-none text-[var(--nim-text)] text-[12px] outline-none p-0",
            value: n,
            onChange: (c) => r(c.target.value),
            onKeyDown: l,
            onBlur: s,
            placeholder: t.length === 0 ? "Add tag..." : ""
          }
        )
      ]
    }
  );
}, os = ({ value: t, onChange: e, placeholder: n, teamMembers: r }) => {
  const [i, s] = O(!1), [a, l] = O(""), c = ce(null);
  pe(() => {
    if (!i) return;
    const p = (f) => {
      c.current && !c.current.contains(f.target) && s(!1);
    };
    return document.addEventListener("mousedown", p), () => document.removeEventListener("mousedown", p);
  }, [i]);
  const d = t || "", u = r && r.length > 0, g = u ? r.filter((p) => {
    const f = a.toLowerCase();
    return p.name?.toLowerCase().includes(f) || p.email.toLowerCase().includes(f);
  }) : [];
  return /* @__PURE__ */ m("div", { ref: c, className: "relative", children: [
    /* @__PURE__ */ m("div", { className: "flex items-center gap-1.5", children: [
      d && /* @__PURE__ */ o(ht, { identity: d, size: 18 }),
      /* @__PURE__ */ o(
        "input",
        {
          type: "text",
          className: `${Ae} flex-1 min-w-0`,
          value: d,
          onChange: (p) => {
            e(p.target.value), l(p.target.value), u && !i && s(!0);
          },
          onFocus: () => {
            u && s(!0);
          },
          onMouseDown: (p) => {
            p.stopPropagation(), u && s(!0);
          },
          placeholder: n
        }
      ),
      d && /* @__PURE__ */ o(
        "button",
        {
          className: "text-[var(--nim-text-faint)] hover:text-[var(--nim-text)] p-0.5",
          onClick: () => {
            e(""), l("");
          },
          title: "Clear",
          children: /* @__PURE__ */ o("span", { className: "material-symbols-outlined text-sm", children: "close" })
        }
      )
    ] }),
    i && g.length > 0 && /* @__PURE__ */ o(
      "div",
      {
        className: "absolute top-full left-0 right-0 mt-1 bg-[var(--nim-bg-secondary)] border border-[var(--nim-border)] rounded-md shadow-lg z-30 max-h-[200px] overflow-auto py-1",
        onMouseDown: (p) => p.stopPropagation(),
        children: g.map((p) => /* @__PURE__ */ m(
          "button",
          {
            className: "w-full flex items-center gap-2 px-2 py-1.5 text-left hover:bg-[var(--nim-bg-hover)] text-xs text-[var(--nim-text)]",
            onMouseDown: (f) => {
              f.preventDefault(), f.stopPropagation(), e(p.email), s(!1), l("");
            },
            children: [
              /* @__PURE__ */ o(ht, { identity: p.name || p.email, size: 18 }),
              /* @__PURE__ */ m("div", { className: "flex flex-col min-w-0", children: [
                p.name && /* @__PURE__ */ o("span", { className: "truncate", children: p.name }),
                /* @__PURE__ */ o("span", { className: "text-[var(--nim-text-faint)] truncate", children: p.email })
              ] })
            ]
          },
          p.email
        ))
      }
    )
  ] });
};
function ls(t) {
  if (typeof t == "string") return { url: t };
  if (t && typeof t == "object") {
    const e = t;
    return { url: typeof e.url == "string" ? e.url : "", label: e.label };
  }
  return { url: "" };
}
const cs = ({ id: t, value: e, onChange: n, placeholder: r }) => {
  const i = ls(e), s = (l) => {
    if (!l.url && !l.label) {
      n(void 0);
      return;
    }
    n({ url: l.url, label: l.label || void 0 });
  }, a = (() => {
    if (!i.url) return !1;
    try {
      return new URL(i.url), !0;
    } catch {
      return !1;
    }
  })();
  return /* @__PURE__ */ m("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ m("div", { className: "flex items-center gap-1.5", children: [
      /* @__PURE__ */ o(
        "input",
        {
          id: t,
          type: "url",
          className: `${Ae} flex-1 min-w-0`,
          value: i.url,
          onChange: (l) => s({ ...i, url: l.target.value }),
          placeholder: r,
          spellCheck: !1
        }
      ),
      a && /* @__PURE__ */ o(
        "a",
        {
          href: i.url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "text-[var(--nim-text-faint)] hover:text-[var(--nim-primary)] p-1",
          title: "Open link",
          children: /* @__PURE__ */ o("span", { className: "material-symbols-outlined text-sm", children: "open_in_new" })
        }
      )
    ] }),
    /* @__PURE__ */ o(
      "input",
      {
        type: "text",
        className: `${Ae} text-[12px]`,
        value: i.label || "",
        onChange: (l) => s({ ...i, label: l.target.value }),
        placeholder: "Display label (optional)"
      }
    )
  ] });
}, ds = "collection-picker";
function ot(t) {
  return t.title || t.issueKey || t.itemId;
}
function us(t, e) {
  return e?.title || t.title || e?.issueKey || t.issueKey || t.itemId;
}
function ps(t, e) {
  if (!e) return !0;
  const n = e.toLowerCase();
  return (t.title?.toLowerCase().includes(n) ?? !1) || (t.issueKey?.toLowerCase().includes(n) ?? !1);
}
const ms = ({
  field: t,
  value: e,
  candidates: n = [],
  onChange: r,
  onCreateCollection: i,
  onOpenItem: s,
  onRequestClose: a,
  testIdBase: l = ds
}) => {
  const [c, d] = O(""), [u, g] = O(0), [p, f] = O(null), [h, b] = O(!1), [w, L] = O(null), N = ce(null), E = ce(null);
  pe(() => {
    N.current?.focus();
  }, []);
  const A = Q(() => Qe(e), [e]), j = Q(() => new Set(A.map((x) => x.itemId)), [A]), T = Q(
    () => new Map(n.map((x) => [x.itemId, x])),
    [n]
  ), $ = Q(() => br(t), [t]), F = c.trim(), z = Q(() => n.filter((V) => ps(V, F)).sort((V, le) => {
    const me = j.has(V.itemId) ? 0 : 1, te = j.has(le.itemId) ? 0 : 1;
    return me !== te ? me - te : ot(V).localeCompare(ot(le));
  }), [n, j, F]), k = Q(() => {
    if (!F) return !1;
    const x = F.toLowerCase();
    return n.some(
      (V) => V.title?.toLowerCase() === x || V.issueKey?.toLowerCase() === x
    );
  }, [n, F]), D = !!i && F.length > 0 && !k, _ = z.length + (D ? 1 : 0), U = D ? z.length : -1;
  pe(() => {
    g((x) => x < _ ? x : Math.max(0, _ - 1));
  }, [_]);
  const ee = Z((x) => {
    r(xn(t, x));
  }, [t, r]), X = Z((x) => {
    ee(wn(t, A, {
      itemId: x.itemId,
      title: x.title,
      issueKey: x.issueKey,
      trackerType: x.trackerType
    })), d(""), t.multiValue || a?.();
  }, [ee, A, t, a]), oe = Z((x) => {
    ee(vn(A, x));
  }, [ee, A]), P = Z((x) => {
    j.has(x.itemId) ? oe(x.itemId) : X(x);
  }, [X, j, oe]), K = Z(() => {
    L(null), f($[0] ?? null);
  }, [$]), J = Z(async (x) => {
    if (!(!i || !F || h)) {
      b(!0), L(null);
      try {
        const V = await i(F, x);
        if (!V) {
          L("Could not create the collection.");
          return;
        }
        f(null), X(V);
      } catch (V) {
        L(V instanceof Error ? V.message : String(V));
      } finally {
        b(!1);
      }
    }
  }, [X, h, i, F]), G = Z(() => {
    f(null), L(null), N.current?.focus();
  }, []), B = Z((x) => {
    if (x === U) {
      K();
      return;
    }
    const V = z[x];
    V && P(V);
  }, [K, U, z, P]), se = Z((x) => {
    if (p !== null) {
      if (x.key === "Escape")
        x.preventDefault(), x.stopPropagation(), G();
      else if (x.key === "ArrowRight" || x.key === "ArrowLeft") {
        x.preventDefault();
        const V = $.indexOf(p), le = x.key === "ArrowRight" ? 1 : $.length - 1;
        f($[(V + le) % $.length] ?? p);
      } else x.key === "Enter" && (x.preventDefault(), J(p));
      return;
    }
    x.key === "ArrowDown" ? (x.preventDefault(), _ > 0 && g((V) => (V + 1) % _)) : x.key === "ArrowUp" ? (x.preventDefault(), _ > 0 && g((V) => (V - 1 + _) % _)) : x.key === "Enter" ? (x.preventDefault(), B(u)) : x.key === "Escape" && (x.preventDefault(), x.stopPropagation(), a?.());
  }, [
    B,
    u,
    G,
    J,
    $,
    a,
    p,
    _
  ]);
  return pe(() => {
    const x = E.current?.querySelector('[data-active="true"]');
    x instanceof HTMLElement && typeof x.scrollIntoView == "function" && x.scrollIntoView({ block: "nearest" });
  }, [u]), /* @__PURE__ */ m("div", { className: "collection-picker", "data-testid": l, children: [
    /* @__PURE__ */ o(
      "input",
      {
        ref: N,
        type: "text",
        className: "collection-picker-search",
        placeholder: "Search collections…",
        "aria-label": "Search collections",
        value: c,
        disabled: h,
        onChange: (x) => {
          d(x.target.value), g(0);
        },
        onKeyDown: se,
        "data-testid": `${l}-search`
      }
    ),
    A.length > 0 && /* @__PURE__ */ o("div", { className: "collection-picker-current", "data-testid": `${l}-current`, children: A.map((x) => {
      const V = us(x, T.get(x.itemId));
      return /* @__PURE__ */ m("span", { className: "collection-picker-chip", children: [
        /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            className: "collection-picker-chip-open",
            title: V,
            onClick: () => s?.(x.itemId),
            children: V
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            className: "collection-picker-chip-remove",
            "aria-label": `Remove from ${V}`,
            title: `Remove from ${V}`,
            onClick: () => oe(x.itemId),
            "data-testid": `${l}-remove-${x.itemId}`,
            children: /* @__PURE__ */ o(R, { icon: "close", size: 13 })
          }
        )
      ] }, x.itemId);
    }) }),
    p !== null ? /* @__PURE__ */ m("div", { className: "collection-picker-create-panel", "data-testid": `${l}-create-panel`, children: [
      /* @__PURE__ */ m("div", { className: "collection-picker-create-prompt", children: [
        "Create “",
        F,
        "” as"
      ] }),
      /* @__PURE__ */ o("div", { className: "collection-picker-type-toggle", role: "radiogroup", "aria-label": "Collection type", children: $.map((x) => {
        const V = Ot(x), le = x === p;
        return /* @__PURE__ */ m(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": le,
            disabled: h,
            className: le ? "collection-picker-type-option collection-picker-type-option-selected" : "collection-picker-type-option",
            onClick: () => {
              f(x), J(x);
            },
            "data-testid": `${l}-type-${x}`,
            children: [
              /* @__PURE__ */ o(R, { icon: V.icon, size: 15 }),
              /* @__PURE__ */ o("span", { children: V.label })
            ]
          },
          x
        );
      }) }),
      w && /* @__PURE__ */ o("div", { className: "collection-picker-error", role: "alert", children: w }),
      /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          className: "collection-picker-create-cancel",
          onClick: G,
          disabled: h,
          children: "Cancel"
        }
      )
    ] }) : /* @__PURE__ */ m(
      "div",
      {
        ref: E,
        className: "collection-picker-list",
        role: "listbox",
        "aria-label": "Collections",
        "data-testid": `${l}-list`,
        children: [
          z.length === 0 && !D && /* @__PURE__ */ o("div", { className: "collection-picker-empty", "data-testid": `${l}-empty`, children: n.length === 0 ? "No collections yet" : "No matches" }),
          z.map((x, V) => {
            const le = j.has(x.itemId), me = V === u;
            return /* @__PURE__ */ m(
              "button",
              {
                type: "button",
                role: "option",
                "aria-selected": le,
                "data-active": me,
                className: me ? "collection-picker-option collection-picker-option-active" : "collection-picker-option",
                onMouseEnter: () => g(V),
                onClick: () => P(x),
                "data-testid": `${l}-option-${x.itemId}`,
                children: [
                  /* @__PURE__ */ o(
                    R,
                    {
                      icon: Ot(x.trackerType ?? "").icon,
                      size: 15,
                      className: "collection-picker-option-icon"
                    }
                  ),
                  /* @__PURE__ */ o("span", { className: "collection-picker-option-label", children: ot(x) }),
                  le && /* @__PURE__ */ o(R, { icon: "check", size: 15 })
                ]
              },
              x.itemId
            );
          }),
          D && /* @__PURE__ */ m(
            "button",
            {
              type: "button",
              role: "option",
              "aria-selected": !1,
              "data-active": u === U,
              className: u === U ? "collection-picker-option collection-picker-option-create collection-picker-option-active" : "collection-picker-option collection-picker-option-create",
              onMouseEnter: () => g(U),
              onClick: K,
              "data-testid": `${l}-create`,
              children: [
                /* @__PURE__ */ o(R, { icon: "add", size: 15, className: "collection-picker-option-icon" }),
                /* @__PURE__ */ m("span", { className: "collection-picker-option-label", children: [
                  "Create “",
                  F,
                  "”"
                ] })
              ]
            }
          )
        ]
      }
    )
  ] });
};
function fs(t) {
  const e = Array.isArray(t) ? t : t == null || t === "" ? [] : [t], n = [];
  for (const r of e)
    typeof r == "string" && r && !n.includes(r) && n.push(r);
  return n;
}
function hs(t, e = ue.getLabelRegistry()) {
  const n = new Map(e.labels.map((r) => [r.id, r.label]));
  return fs(t).map((r) => n.get(r) ?? r);
}
const Jn = "tracker-field", ys = 500;
function gs(t, e) {
  const n = Array.isArray(t) ? t : t ? [t] : [], r = new Map((e ?? []).map((s) => [s.itemId, s])), i = n.map((s) => {
    if (!s || typeof s != "object") {
      const c = r.get(String(s));
      return String(c?.title ?? c?.issueKey ?? s);
    }
    const a = s, l = r.get(String(a.itemId ?? ""));
    return String(
      l?.title ?? a.title ?? l?.issueKey ?? a.issueKey ?? a.itemId ?? ""
    );
  }).filter(Boolean);
  return i.length <= 2 ? i.join(", ") : `${i.slice(0, 2).join(", ")} +${i.length - 2}`;
}
function bs(t, e, n, r) {
  if (At(e)) return wt(t);
  if (t.type === "label-ref") {
    const i = hs(e);
    return i.length <= 2 ? i.join(", ") : `${i.slice(0, 2).join(", ")} +${i.length - 2}`;
  }
  if (t.type === "select")
    return t.options?.find((i) => i.value === e)?.label ?? String(e);
  if (t.type === "user") {
    const i = String(e);
    return n.find((s) => s.email === i)?.name ?? i;
  }
  if (t.type === "array") {
    const i = e;
    return i.length <= 2 ? i.join(", ") : `${i.slice(0, 2).join(", ")} +${i.length - 2}`;
  }
  if (t.type === "relationship" || t.type === "reference")
    return gs(e, r);
  if (t.type === "citation") {
    const i = Array.isArray(e) ? e : [e];
    return i.length === 1 ? "1 citation" : `${i.length} citations`;
  }
  if (t.type === "date" || t.type === "datetime")
    return Hn(e).display;
  if (t.type === "boolean") return e ? "Yes" : "No";
  if (t.type === "url" && typeof e == "object") {
    const i = e;
    return String(i.label ?? i.url ?? wt(t));
  }
  return String(e);
}
function vs(t, e) {
  return kn(t) ? "inventory_2" : t.type === "select" ? t.options?.find((n) => n.value === e)?.icon ?? "tune" : t.type === "user" ? "person" : t.type === "array" ? "label" : t.type === "label-ref" ? "sell" : t.type === "relationship" || t.type === "reference" ? "link" : t.type === "citation" ? "format_quote" : t.type === "date" || t.type === "datetime" ? "calendar_today" : t.type === "boolean" ? e ? "check_box" : "check_box_outline_blank" : t.type === "number" ? "numbers" : t.type === "url" ? "link" : "short_text";
}
const ws = ({ label: t, testId: e }) => /* @__PURE__ */ o("div", { className: "tracker-field-popover-header", "data-testid": e, children: t }), xs = ({
  labelFields: t = !1,
  field: e,
  value: n,
  editable: r,
  teamMembers: i,
  relationshipCandidates: s,
  citationHost: a,
  onOpenItem: l,
  onCreateCollection: c,
  onSave: d,
  carried: u = !1,
  testIdBase: g = Jn
}) => {
  const [p, f] = O(!1), [h, b] = O(n), w = ce(null), L = ce(n), N = ce(!1), E = i ?? [], A = At(h), j = e.type === "select" ? e.options?.find((B) => B.value === h) : void 0, T = e.type === "select" || e.type === "user" && E.length > 0, $ = e.type === "boolean", F = kn(e), z = wt(e), k = bs(e, h, E, s), D = Gi(e, h, t);
  pe(() => {
    N.current || (b(n), L.current = n);
  }, [n]), pe(() => () => {
    w.current && (clearTimeout(w.current), d(e.name, L.current));
  }, [e.name, d]);
  const _ = Cn({
    open: p,
    onOpenChange: f,
    placement: "bottom-start",
    whileElementsMounted: Ln,
    middleware: [
      Pn(5),
      Dn({ padding: 8 }),
      _n({ padding: 8 }),
      Qr(),
      Wr({
        padding: 8,
        apply({ availableHeight: B, elements: se, middlewareData: x }) {
          const V = x.windowControlsClearance?.pushed ?? 0;
          se.floating.style.maxHeight = `${Math.max(0, B - V)}px`;
        }
      })
    ]
  }), U = Hr(_.context, {
    outsidePress: (B) => {
      const se = B.target;
      return !(se instanceof Element && se.closest(".custom-select-dropdown"));
    }
  }), ee = Jr(_.context, {
    role: T ? "listbox" : "dialog"
  }), { getReferenceProps: X, getFloatingProps: oe } = Gr([U, ee]), P = Z((B) => {
    if (b(B), L.current = B, e.type === "string" || e.type === "text" || e.type === "user") {
      N.current = !0, w.current && clearTimeout(w.current), w.current = setTimeout(() => {
        w.current = null, N.current = !1, d(e.name, L.current);
      }, ys);
      return;
    }
    d(e.name, B);
  }, [e.name, e.type, d]), K = Z((B) => {
    w.current && (clearTimeout(w.current), w.current = null), N.current = !1, b(B), L.current = B, f(!1), d(e.name, B);
  }, [e.name, d]), J = Q(() => e.type === "select" ? (e.options ?? []).map((B) => ({
    value: B.value,
    label: B.label,
    icon: B.icon,
    color: B.color
  })) : e.type === "user" ? Cr(E) : [], [e.options, e.type, E]), G = r ? A ? `Set ${z}` : `${z}: ${k}` : `${z} is read-only`;
  return /* @__PURE__ */ m(Le, { children: [
    /* @__PURE__ */ m(
      "button",
      {
        ref: _.refs.setReference,
        ...X(),
        type: "button",
        className: `tracker-field-pill ${A ? "tracker-field-pill-empty" : "tracker-field-pill-set"}${D ? " tracker-field-pill-labeled" : ""}${u ? " tracker-field-pill-carried" : ""}`,
        disabled: !r,
        onClick: () => {
          if ($) {
            K(!h);
            return;
          }
          f((B) => !B);
        },
        onKeyDown: (B) => {
          B.key !== "Escape" || !p || (B.preventDefault(), B.stopPropagation(), f(!1));
        },
        "aria-expanded": $ ? void 0 : p,
        "aria-haspopup": $ ? void 0 : T ? "listbox" : "dialog",
        "aria-label": `${z}: ${A ? "Not set" : k}`,
        title: G,
        "data-testid": `${g}-pill-${e.name}`,
        "data-field": e.name,
        "data-empty": A,
        children: [
          e.type === "user" && !A ? /* @__PURE__ */ o("span", { className: "tracker-field-pill-icon", children: /* @__PURE__ */ o(ht, { identity: k, size: 14 }) }) : /* @__PURE__ */ o(
            R,
            {
              icon: vs(e, h),
              size: 14,
              className: "tracker-field-pill-icon",
              style: j?.color ? { color: j.color } : void 0
            }
          ),
          D && /* @__PURE__ */ o("span", { className: "tracker-field-pill-label", children: z }),
          /* @__PURE__ */ o("span", { className: "tracker-field-pill-value", children: k })
        ]
      }
    ),
    p && r && !$ && /* @__PURE__ */ o(Rn, { children: /* @__PURE__ */ m(
      "div",
      {
        ref: _.refs.setFloating,
        style: _.floatingStyles,
        ...oe(),
        className: "tracker-field-popover",
        "data-testid": `${g}-popover-${e.name}`,
        children: [
          /* @__PURE__ */ o(
            ws,
            {
              label: z,
              testId: `${g}-popover-header-${e.name}`
            }
          ),
          F ? /* @__PURE__ */ o(
            ms,
            {
              field: e,
              value: h,
              candidates: s,
              onChange: P,
              onCreateCollection: c,
              onOpenItem: l,
              onRequestClose: () => f(!1),
              testIdBase: `${g}-collection-picker`
            }
          ) : T ? /* @__PURE__ */ o(
            Lr,
            {
              choices: J,
              value: h,
              allowNone: !e.required,
              onPick: K,
              testId: `${g}-choices-${e.name}`
            }
          ) : /* @__PURE__ */ o(
            Ct,
            {
              field: e,
              value: h,
              onChange: P,
              teamMembers: E,
              relationshipCandidates: s,
              citationHost: a,
              onOpenRelationship: l,
              showLabel: !1
            }
          )
        ]
      }
    ) })
  ] });
}, ks = ({
  labelFields: t = !1,
  fields: e,
  values: n,
  editable: r = !0,
  teamMembers: i,
  relationshipCandidates: s,
  citationHost: a,
  onSave: l,
  onOpenItem: c,
  onCreateCollection: d,
  carriedFieldNames: u,
  className: g,
  testIdBase: p = Jn
}) => e.length === 0 ? null : /* @__PURE__ */ o(
  "div",
  {
    className: g ? `tracker-field-pills ${g}` : "tracker-field-pills",
    "data-testid": `${p}-pills`,
    children: e.map((f) => /* @__PURE__ */ o(
      xs,
      {
        labelFields: t,
        field: f,
        value: n[f.name],
        editable: r,
        teamMembers: i,
        relationshipCandidates: s?.get(f.name),
        citationHost: a,
        onOpenItem: c,
        onCreateCollection: d,
        onSave: l,
        carried: u?.has(f.name) ?? !1,
        testIdBase: p
      },
      f.name
    ))
  }
);
function Is(t) {
  return !(t.type === "array" && t.itemType === "object");
}
const Ts = /* @__PURE__ */ new Set(["title", "description", "created", "updated"]);
function Yo(t) {
  const e = ue.get(t);
  if (!e) return null;
  const n = e.roles?.tags ?? "tags";
  return e.fields.find((r) => r.name === n) ?? null;
}
function Ss(t, e = [], n = [], r = {}) {
  const i = new Set(e), s = Wi(t, n, r).filter(
    (c) => !i.has(c.name) && Is(c)
  ), a = new Set(s.map((c) => c.name)), l = [...ue.get(t)?.fields ?? [], ...n].filter(
    (c) => !Ts.has(c.name) && !i.has(c.name) && !a.has(c.name)
  );
  return { chipFields: s, overflowFields: l };
}
function Ns(t, e = [], n = Es, r = !1) {
  const i = e.join("\0");
  return Q(
    () => Ss(
      t,
      i ? i.split("\0") : [],
      n,
      { singleValuedOnly: r }
    ),
    [t, i, n, r]
  );
}
const Es = [], Gn = { fields: [], unknown: [] };
function Lt(t) {
  return "labelProperty" in t;
}
function As(t, e) {
  const n = {
    name: t.id,
    labelProperty: t,
    viaLabel: e,
    displayLabel: t.label
  };
  switch (t.type) {
    case "select":
    case "multiselect":
      return {
        ...n,
        type: t.type,
        options: (t.options ?? []).map((r) => typeof r == "string" ? { value: r, label: r } : { value: r.value, label: r.label ?? r.value, icon: r.icon, color: r.color })
      };
    case "relationship":
      return { ...n, type: "relationship", multiValue: t.multiValue === !0, targetTrackerTypes: "*" };
    case "array":
      return { ...n, type: "array", itemType: "string" };
    default:
      return { ...n, type: t.type };
  }
}
function Cs(t, e, n = ue) {
  if (!e || !n.acceptsLabels(t) || Et(e).length === 0) return Gn;
  const r = new Set((n.get(t)?.fields ?? []).map((s) => s.name)), i = { fields: [], unknown: [] };
  for (const s of n.effectiveProperties(e))
    r.has(s.id) || s.storage === "base-field" || (s.storage === "field" && s.definition ? i.fields.push(As(s.definition, s.viaLabel)) : s.storage !== "claim" && i.unknown.push(s));
  return i;
}
function xt(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function Ls(t, e) {
  return !Lt(t) || !Nt(t.labelProperty) ? e : xt(e) && "value" in e ? e.value : e;
}
function Ps(t) {
  return xt(t) && xt(t.qualifiers) ? t.qualifiers : {};
}
function Ds(t, e, n) {
  return !Lt(t) || !Nt(t.labelProperty) ? e : e == null || e === "" ? null : { value: e, qualifiers: Ps(n) };
}
function _s(t, e) {
  const n = t.filter((i) => Lt(i) && Nt(i.labelProperty));
  if (n.length === 0) return e;
  const r = { ...e };
  for (const i of n) r[i.name] = Ls(i, e[i.name]);
  return r;
}
function Rs(t = ue) {
  const [e, n] = O(0);
  return pe(() => t.onChange(() => n((r) => r + 1)), [t]), e;
}
function $s(t) {
  return t ? Et(t).join("") : "";
}
function Ms(t, e) {
  const n = Rs(), r = $s(e);
  return Q(() => r ? Cs(t, { labels: r.split("") }) : Gn, [t, r, n]);
}
const Wo = ({
  labelFields: t = !1,
  model: e,
  data: n,
  onChange: r,
  onClose: i,
  trackerItemLink: s,
  teamMembers: a,
  relationshipCandidates: l,
  onOpenItem: c,
  onCreateCollection: d
}) => {
  const [u, g] = O(!1), [p, f] = O(n), h = Ms(e.type, p), { chipFields: b } = Ns(e.type, void 0, h.fields), w = Q(() => _s(h.fields, p), [h.fields, p]);
  pe(() => {
    f(n);
  }, [n]);
  const L = ce(p);
  L.current = p;
  const N = Z((A, j) => {
    const T = h.fields.find((F) => F.name === A), $ = T ? Ds(T, j, L.current[A]) : j;
    f((F) => ({ ...F, [A]: $ })), r({ [A]: $ });
  }, [h.fields, r]), E = Z(() => g((A) => !A), []);
  return /* @__PURE__ */ m(
    "div",
    {
      className: `status-bar bg-[var(--nim-bg-secondary)] px-3 py-2 shadow-[0_1px_3px_rgba(0,0,0,0.1)] relative z-[1] ${u ? "status-bar-collapsed" : ""}`,
      "data-testid": "tracker-status-bar",
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: "status-bar-header flex justify-between items-center gap-3 p-1 px-2 -m-1 -mx-2 rounded transition-colors duration-150 cursor-pointer hover:bg-[var(--nim-bg-hover)]",
            role: "button",
            tabIndex: 0,
            "aria-expanded": !u,
            "aria-label": u ? "Expand status bar" : "Collapse status bar",
            onClick: E,
            onKeyDown: (A) => {
              A.key !== "Enter" && A.key !== " " || (A.preventDefault(), E());
            },
            children: [
              /* @__PURE__ */ m("div", { className: "status-bar-title flex items-center gap-2 font-semibold text-[var(--nim-text)] text-sm", children: [
                /* @__PURE__ */ o(R, { icon: u ? "chevron_right" : "expand_more", size: 18 }),
                /* @__PURE__ */ o(R, { icon: e.icon, size: 18 }),
                /* @__PURE__ */ o("span", { children: e.displayName }),
                s && /* @__PURE__ */ m(
                  "button",
                  {
                    type: "button",
                    className: "status-bar-tracker-item-link inline-flex items-center gap-1 rounded-full border border-[var(--nim-border)] bg-[var(--nim-bg-tertiary)] px-2 py-0.5 font-mono text-[11px] font-medium text-[var(--nim-text-muted)] transition-colors hover:bg-[var(--nim-bg-hover)] hover:text-[var(--nim-text)]",
                    title: `Open tracker item: ${s.title}`,
                    "aria-label": `Open tracker item ${s.label}`,
                    onClick: (A) => {
                      A.stopPropagation(), s.onOpen();
                    },
                    children: [
                      /* @__PURE__ */ o(R, { icon: "tag", size: 13 }),
                      s.label
                    ]
                  }
                )
              ] }),
              i && /* @__PURE__ */ o(
                "button",
                {
                  className: "status-bar-close-btn bg-transparent border-none p-1 cursor-pointer rounded text-[var(--nim-text-muted)] flex items-center gap-1 transition-all duration-200 relative z-[1] hover:bg-[var(--nim-bg-tertiary)] hover:text-[var(--nim-text)]",
                  onClick: (A) => {
                    A.stopPropagation(), i();
                  },
                  "aria-label": "Remove tracker",
                  children: /* @__PURE__ */ o(R, { icon: "close", size: 18 })
                }
              )
            ]
          }
        ),
        !u && /* @__PURE__ */ o("div", { className: "status-bar-content mt-2", children: /* @__PURE__ */ o(
          ks,
          {
            labelFields: t,
            fields: b,
            values: w,
            teamMembers: a,
            relationshipCandidates: l,
            onSave: N,
            onOpenItem: c,
            onCreateCollection: d,
            className: "status-bar-field-pills",
            testIdBase: "tracker-status-bar-field"
          }
        ) })
      ]
    }
  );
};
function nt(t) {
  const e = t?.customFields;
  return e && typeof e == "object" && !Array.isArray(e) ? e : void 0;
}
function Os(t, e) {
  const n = nt(t);
  return n && e in n && n[e] !== void 0 ? n[e] : t?.[e];
}
function Ho(t, e, n) {
  const r = nt(t);
  if (r && e in r) {
    r[e] = n, delete t[e];
    return;
  }
  t[e] = n;
}
function Jo(t, e, n = {}) {
  let r = nt(t);
  const i = n.writtenFields ? new Set(n.writtenFields) : void 0;
  for (const s of e) {
    if (!In(s) || !(s.name in t)) continue;
    const a = r && s.name in r && r[s.name] !== void 0, l = i?.has(s.name) ?? !1;
    if (a && !l) {
      delete t[s.name];
      continue;
    }
    r || (r = {}, t.customFields = r), t[s.name] !== void 0 && (r[s.name] = t[s.name]), delete t[s.name];
  }
}
function Go(t) {
  if (!t) return {};
  const e = nt(t);
  if (!e) return { ...t };
  const n = { ...t };
  delete n.customFields;
  for (const [r, i] of Object.entries(e))
    i !== void 0 && (n[r] = i);
  return n;
}
const Fs = "var(--nim-text-muted)", Bs = 500, js = {
  backlog: "var(--nim-text-faint)",
  unstarted: "var(--nim-text-faint)",
  started: "var(--nim-primary)",
  done: "var(--nim-success)",
  cancelled: "var(--nim-text-disabled)"
}, Vs = {
  blocked: "var(--nim-error)",
  disputed: "var(--nim-warning)",
  "in-review": "var(--nim-info)"
};
function Me(t) {
  return t.split(/[-_\s]+/).filter(Boolean).map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function qe(t, e) {
  return t?.fields.find((n) => n.name === e);
}
function Qt(t, e) {
  return t?.options?.find((n) => n.value === e);
}
function Oe(t) {
  return typeof t == "string" && t.trim() !== "" ? t : null;
}
function Ks(t, e) {
  if (t.length !== e.length) return !1;
  for (let n = 0; n < t.length; n += 1) if (t[n] !== e[n]) return !1;
  return !0;
}
function Qo(t, e = {}) {
  const n = e.schema ?? ue, r = /* @__PURE__ */ new Set();
  let i = /* @__PURE__ */ new Map(), s = !1, a = !1, l = !1, c = !1, d = !1, u = 0, g = 0, p = null, f = [], h = !1;
  const b = /* @__PURE__ */ new Map(), w = /* @__PURE__ */ new Map(), L = /* @__PURE__ */ new Map(), N = () => {
    u += 1;
    for (const v of [...r]) v();
  }, E = (v) => {
    if (v.size !== 0) {
      for (const [S, y] of b)
        y.value.state === "resolved" && v.has(y.value.item.id) && b.delete(S);
      for (const S of v)
        w.delete(S), L.delete(S);
    }
  }, A = (v) => {
    const S = i;
    i = new Map(v.map((y) => [y.id, y])), E(new Set([...S.keys()].filter((y) => !i.has(y))));
  }, j = (v) => {
    switch (v.type) {
      case "items-replaced":
        return A(v.items), !0;
      case "items-upserted":
        i = new Map(i);
        for (const S of v.items) i.set(S.id, S);
        return !0;
      case "items-removed":
        i = new Map(i);
        for (const S of v.itemIds) i.delete(S);
        return E(new Set(v.itemIds)), !0;
      default:
        return !1;
    }
  }, T = (v) => {
    A(v), s = !0, l = !1;
    const S = f;
    f = [], h = !1;
    for (const y of S) j(y);
    N();
  }, $ = () => {
    d || s || a || (a = !0, l = !1, t.snapshot().then(
      (v) => {
        if (a = !1, !(d || s)) {
          if (h) {
            f = [], h = !1, $();
            return;
          }
          v.sync?.status === "connected" && (c = !0), T(v.items);
        }
      },
      () => {
        a = !1, l = !0;
      }
    ));
  }, F = (v) => {
    if (!d) {
      if (v.type === "status") {
        const S = c;
        v.sync.status === "connected" && (c = !0), !s && l && v.sync.status === "connected" && $(), S !== c && N();
        return;
      }
      if (s) {
        j(v) && N();
        return;
      }
      if (v.type === "items-replaced") {
        T(v.items);
        return;
      }
      if (!(v.type !== "items-upserted" && v.type !== "items-removed")) {
        if (f.length >= Bs) {
          f = [], h = !0;
          return;
        }
        h || f.push(v);
      }
    }
  };
  t.status()?.status === "connected" && (c = !0);
  const z = t.subscribe(F), k = n.onChange(() => {
    d || (g += 1, N());
  });
  $();
  const D = (v) => {
    const S = n.get(v);
    return {
      type: v,
      displayName: S?.displayName ?? Me(v),
      color: S?.color ?? Fs,
      icon: S?.icon ?? ""
    };
  }, _ = (v) => v?.roles?.workflowStatus ?? "status", U = (v) => {
    const S = Oe(v.status);
    if (!S) return null;
    const y = n.get(v.type), M = Qt(qe(y, _(y)), S), C = M?.category;
    return {
      value: S,
      label: M?.label ?? Me(S),
      color: M?.color ?? Vs[S] ?? (C ? js[C] : "var(--nim-text-faint)"),
      ...C ? { category: C } : {}
    };
  }, ee = (v, S) => Os(v, S), X = (v, S) => Qe(ee(v, S)).map((y) => y.itemId).filter((y) => typeof y == "string" && y !== ""), oe = (v, S, y) => Qt(qe(n.get(v), S), y)?.label ?? Me(y), P = (v) => n.getPredicate(v)?.label ?? Me(v), K = (v) => {
    const S = n.get(v.type);
    if (S) return S.fields.filter(In).map((M) => M.name);
    const y = v.customFields ?? {};
    return Object.keys(y).filter((M) => {
      const C = y[M], Y = Array.isArray(C) ? C : [C];
      return Y.length > 0 && Y.every(
        (W) => W && typeof W == "object" && typeof W.itemId == "string"
      );
    });
  }, J = () => {
    if (p && p.version === u) return p.value;
    const v = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), M = /* @__PURE__ */ new Map(), C = [];
    for (const W of i.values()) {
      C.push({
        id: W.id,
        issueKey: W.issueKey,
        issueNumber: W.issueNumber,
        title: W.title,
        description: W.description,
        status: W.status,
        type: W.type,
        typeTags: W.typeTags,
        archived: W.archived
      }), W.issueKey && v.set(W.issueKey.toUpperCase(), W);
      for (const de of [W.authorIdentity, W.lastModifiedBy])
        de?.email && de.displayName && M.set(de.email.toLowerCase(), de.displayName);
      if (W.type === "claim")
        for (const de of X(W, "subject")) {
          const ve = S.get(de) ?? [];
          ve.push(W), S.set(de, ve);
        }
      const ke = n.get(W.type);
      for (const de of K(W))
        for (const ve of Qe(ee(W, de))) {
          if (!ve.itemId || ve.itemId === W.id) continue;
          const st = y.get(ve.itemId) ?? [];
          if (st.some((Mt) => Mt.source === W && Mt.fieldName === de)) continue;
          const $t = ve.relationshipTypeKey ?? qe(ke, de)?.relationshipTypeKey;
          st.push({ source: W, fieldName: de, ...$t ? { relationshipTypeKey: $t } : {} }), y.set(ve.itemId, st);
        }
    }
    const Y = {
      byId: i,
      candidates: C,
      candidateTypes: Wn(C),
      byIssueKey: v,
      claimsBySubject: S,
      backlinksByTarget: y,
      namesByEmail: M
    };
    return p = { version: u, value: Y }, Y;
  };
  function G(v, S, y, M) {
    const C = v.get(S);
    if (C && C.version === u) return C.value;
    const Y = y();
    return C && C.schemaVersion === g && Ks(C.deps, Y.deps) && M(C.value, Y.value) ? (C.version = u, C.value) : (v.set(S, { version: u, value: Y.value, deps: Y.deps, schemaVersion: g }), Y.value);
  }
  const B = (v) => G(
    b,
    v,
    () => {
      const { byId: S, byIssueKey: y } = J(), M = S.get(v) ?? y.get(v.trim().toUpperCase());
      return M ? {
        value: { state: "resolved", key: v, item: M, typeInfo: D(M.type), status: U(M) },
        deps: [M]
      } : {
        value: { state: s && c ? "missing" : "loading", key: v },
        deps: []
      };
    },
    (S, y) => S.state === y.state
  ), se = (v) => {
    const S = Oe(ee(v, "predicate")), y = Oe(ee(v, "basis")), M = ee(v, "citations");
    return {
      claim: v,
      predicateId: S,
      objectItemId: X(v, "object")[0] ?? null,
      valueText: Oe(ee(v, "valueText")),
      basis: y,
      basisLabel: y ? oe(v.type, "basis", y) : null,
      applicability: Oe(ee(v, "applicability")),
      citationCount: Array.isArray(M) ? M.length : M ? 1 : 0,
      status: U(v)
    };
  }, x = (v) => G(
    w,
    v,
    () => {
      const S = (J().claimsBySubject.get(v) ?? []).slice().sort((C, Y) => C.title.localeCompare(Y.title)), y = /* @__PURE__ */ new Map();
      for (const C of S) {
        const Y = se(C), W = Y.predicateId ?? "";
        let ke = y.get(W);
        ke || (ke = {
          predicateId: Y.predicateId,
          label: Y.predicateId ? P(Y.predicateId) : "Unspecified",
          statements: []
        }, y.set(W, ke)), ke.statements.push(Y);
      }
      return { value: [...y.values()].sort((C, Y) => C.predicateId === null ? 1 : Y.predicateId === null ? -1 : C.label.localeCompare(Y.label)), deps: S };
    },
    () => !0
  ), V = (v) => G(
    L,
    v,
    () => {
      const S = (J().backlinksByTarget.get(v) ?? []).slice().sort((y, M) => y.source.title.localeCompare(M.source.title) || y.fieldName.localeCompare(M.fieldName));
      return { value: S, deps: S.map((y) => y.source) };
    },
    (S, y) => S.every((M, C) => M.fieldName === y[C]?.fieldName)
  ), le = (v, S = {}) => {
    const { candidates: y, candidateTypes: M } = J();
    return es(y, v, { knownTypes: M, limit: S.limit });
  }, me = (v) => {
    const S = n.get(v);
    return (qe(S, _(S))?.options ?? []).map((y) => ({
      value: y.value,
      label: y.label ?? Me(y.value),
      ...y.color ? { color: y.color } : {},
      ...y.category ? { category: y.category } : {}
    }));
  }, te = () => e.currentActor?.() ?? null, ge = (v) => {
    const S = e.personName?.(v);
    if (S) return S;
    const y = te();
    return y?.name && y.email.toLowerCase() === v.toLowerCase() ? y.name : J().namesByEmail.get(v.toLowerCase()) ?? null;
  }, I = async (v, S) => {
    await t.command({ type: "update-item", input: { itemId: v, updates: S, sharing: "team" } });
  }, q = async (v, S) => {
    await t.command({ type: "archive-item", itemId: v, archive: S });
  };
  return {
    subscribe(v) {
      return r.add(v), () => {
        r.delete(v);
      };
    },
    resolve: B,
    statementsAbout: x,
    backlinks: V,
    typeInfo: D,
    statusInfo: U,
    fieldValue: ee,
    optionLabel: oe,
    relationshipTargets: X,
    predicateLabel: P,
    search: le,
    ...e.onOpenItem ? { openItem: e.onOpenItem } : {},
    statusOptions: me,
    updateItem: I,
    archiveItem: q,
    currentActor: te,
    personName: ge,
    dispose() {
      d || (d = !0, z(), k(), r.clear(), i = /* @__PURE__ */ new Map(), p = null, f = [], b.clear(), w.clear(), L.clear());
    }
  };
}
const zs = ye(() => import("./TrackerStateMenu-Bx0EOzXF.js").then((t) => ({ default: t.TrackerStateMenu })));
function Xo(t) {
  const e = t.resolver.statusInfo(t.item);
  if (!e) return null;
  const n = /* @__PURE__ */ o("span", { className: "tracker-state-word", "data-tone": Or(t.item.type, e), "data-status": e.value, children: e.label });
  return /* @__PURE__ */ o(he, { fallback: n, children: /* @__PURE__ */ o(zs, { ...t }) });
}
function qs(t) {
  return `tracker-content/${t}`;
}
class Zo extends Error {
  constructor(e, n, r) {
    super(r ?? `Tracker item '${e}' has no revision ${JSON.stringify(n)}`), this.itemId = e, this.ref = n, this.name = "TrackerRevisionUnavailableError";
  }
  itemId;
  ref;
}
class Us extends Error {
  constructor(e) {
    super(`${e} does not keep a tracker revision log`), this.host = e, this.name = "TrackerRevisionsUnsupportedError";
  }
  host;
}
const we = {
  "=": "is",
  "!=": "is-not",
  contains: "contains",
  "not-contains": "not-contains",
  in: "any-of",
  "not-in": "none-of",
  ">": "gt",
  ">=": "gte",
  "<": "lt",
  "<=": "lte",
  between: "between",
  "in-last": "in-last",
  "not-in-last": "not-in-last",
  "is-current-user": "me",
  "is-not-current-user": "not-me",
  "is-empty": "empty",
  "is-not-empty": "not-empty"
}, Ys = new Set(
  Object.keys(we).filter((t) => Se.has(t)).map((t) => we[t])
), Ws = /* @__PURE__ */ new Set(["in", "not-in", "between"]), Hs = (() => {
  const t = {};
  for (const [e, n] of Object.entries(we))
    t[n] = e, t[e] = e;
  return t.isnt = "!=", t.not = "!=", t.has = "contains", t;
})();
function Pt(t) {
  return Ws.has(t);
}
function De(t) {
  return t.trim().replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}
function Qn(t) {
  const e = [De(t.label), t.id.toLowerCase(), De(t.id)];
  return Array.from(new Set(e.filter(Boolean)));
}
function He(t, e) {
  const n = De(t.label);
  return n ? e.some(
    (i) => i.id !== t.id && De(i.label) === n
  ) ? t.id.toLowerCase() : n : t.id.toLowerCase();
}
function Js(t, e) {
  const n = De(t);
  if (n)
    return e.find((r) => Qn(r).includes(n));
}
function Gs(t, e) {
  const n = De(t);
  if (!n) return e;
  const r = [], i = [];
  for (const s of e) {
    const a = Qn(s);
    a.some((l) => l.startsWith(n)) ? r.push(s) : a.some((l) => l.includes(n)) && i.push(s);
  }
  return [...r, ...i];
}
function Xn(t, e) {
  const n = Hs[t.trim().toLowerCase()];
  if (n && !(e && !St(e.type).includes(n)))
    return n;
}
function rt(t) {
  switch (t?.type) {
    case "multiselect":
    case "array":
    case "relationship":
    case "reference":
      return "contains";
    case "select":
    case "user":
    case "boolean":
    case "number":
    case "date":
    case "datetime":
      return "=";
    default:
      return "contains";
  }
}
function Qs(t) {
  const e = [];
  let n = "", r = null;
  for (const i of t) {
    if (r) {
      i === r && (r = null), n += i;
      continue;
    }
    if (i === '"' || i === "'") {
      r = i, n += i;
      continue;
    }
    if (i === ",") {
      e.push(n), n = "";
      continue;
    }
    n += i;
  }
  return e.push(n), e;
}
function Xs(t) {
  return t.trim().replace(/^["']/, "").replace(/["']$/, "");
}
function Xe(t) {
  const e = t.trim();
  return e.length >= 2 && (e[0] === '"' || e[0] === "'") && e.at(-1) === e[0] ? e.slice(1, -1) : e;
}
function Zn(t) {
  return /[\s,:]/.test(t) ? `"${t}"` : t;
}
function Xt(t) {
  return t?.type === "number";
}
function Ke(t, e, n) {
  if (Se.has(e)) return { field: t.id, op: e };
  const r = n.map((i) => Xe(i)).filter((i) => i !== "");
  if (r.length === 0) return null;
  if (e === "in" || e === "not-in")
    return { field: t.id, op: e, value: r };
  if (e === "between") {
    if (r.length < 2) return null;
    const i = r.slice(0, 2).map((s) => Xt(t) ? Number(s) : s);
    return i.some((s) => typeof s == "number" && Number.isNaN(s)) ? null : { field: t.id, op: e, value: i };
  }
  if (e === "in-last" || e === "not-in-last") {
    const i = Number(r[0]);
    return !Number.isFinite(i) || i < 0 ? null : { field: t.id, op: e, value: i };
  }
  if (Xt(t)) {
    const i = Number(r[0]);
    return Number.isFinite(i) ? { field: t.id, op: e, value: i } : null;
  }
  return { field: t.id, op: e, value: r[0] };
}
function Zs(t) {
  let e = null, n = 0;
  for (let r = 0; r < t.length; r += 1) {
    const i = t[r];
    if (e) {
      i === e && (e = null);
      continue;
    }
    if (i === '"' || i === "'") {
      e = i;
      continue;
    }
    (i === " " || i === "	") && (n = r + 1);
  }
  return n;
}
function kt(t, e) {
  const n = Zs(t), r = t.slice(n);
  if (r.startsWith("#"))
    return {
      searchText: t.slice(0, n),
      tokenStart: n,
      draft: {
        raw: r,
        stage: "tag",
        tagQuery: r.slice(1),
        fieldToken: "",
        values: [],
        valueQuery: ""
      }
    };
  const i = r.indexOf(":");
  if (i < 0)
    return {
      searchText: t,
      tokenStart: n,
      draft: {
        raw: r,
        stage: "field",
        tagQuery: "",
        fieldToken: r,
        values: [],
        valueQuery: ""
      }
    };
  const s = t.slice(0, n), a = r.slice(0, i), l = Js(a, e), c = r.slice(i + 1), d = c.startsWith('"') || c.startsWith("'") ? -1 : c.indexOf(":"), u = d >= 0 ? c.slice(0, d) : "", g = d >= 0 ? Xn(u, l) : void 0, p = g ? c.slice(d + 1) : c, f = Qs(p), h = f.at(-1) ?? "", b = f.slice(0, -1);
  return {
    searchText: s,
    tokenStart: n,
    draft: {
      raw: r,
      stage: g ? "value" : "op-or-value",
      tagQuery: "",
      fieldToken: a,
      field: l,
      op: g,
      values: b,
      valueQuery: h
    }
  };
}
function ea(t) {
  if (t.op) return t.op;
  if (t.field)
    return t.values.length === 0 && Ys.has(t.valueQuery.trim().toLowerCase()) ? Xn(t.valueQuery, t.field) : rt(t.field);
}
function Dt(t) {
  if (!t.field) return null;
  const e = ea(t);
  if (!e) return null;
  const n = Ke(t.field, e, [...t.values, t.valueQuery]);
  return n && Te(n) ? n : null;
}
function el(t, e) {
  return Dt(kt(t, e).draft);
}
function Zt(t, e) {
  const n = e.find((a) => a.id === t.field), r = n ? He(n, e) : De(t.field), i = we[t.op];
  if (Se.has(t.op)) return `${r}:${i}`;
  const s = (Array.isArray(t.value) ? t.value : [t.value]).map((a) => Zn(String(a ?? ""))).join(",");
  return n && t.op === rt(n) && !Pt(t.op) ? `${r}:${s}` : `${r}:${i}:${s}`;
}
function er(t, ...e) {
  const n = t.trim().toLowerCase();
  return n ? e.some((r) => r.toLowerCase().includes(n)) : !0;
}
function en(t, e, n, r, i) {
  const s = e.type === "boolean" && !e.options?.length ? [{ value: "true", label: "True" }, { value: "false", label: "False" }] : e.options ?? [], a = Pt(n), l = n === rt(e) && !a ? `${r}:` : `${r}:${we[n]}:`, c = new Set(t.values.map((d) => Xe(d)));
  return s.filter((d) => !c.has(d.value)).filter((d) => er(Xs(t.valueQuery), d.label, d.value)).slice(0, i).map((d) => {
    const u = d.count === void 0 ? void 0 : `${d.count} item${d.count === 1 ? "" : "s"}`;
    if (a) {
      const g = [...t.values, Zn(d.value)].join(",");
      return {
        id: `value:${d.value}`,
        label: d.label,
        detail: u,
        section: "Values",
        kind: "value",
        insertText: `${l}${g},`
      };
    }
    return {
      id: `value:${d.value}`,
      label: d.label,
      detail: u,
      section: "Values",
      kind: "value",
      clause: Ke(e, n, [d.value]) ?? void 0
    };
  }).filter((d) => d.kind !== "value" || d.insertText || d.clause);
}
function tn(t, e, n, r, i) {
  return St(e.type).filter((s) => er(r, we[s], xe[s])).slice(0, i).map((s) => Se.has(s) ? {
    id: `op:${s}`,
    label: `${e.label} ${xe[s]}`,
    detail: `${n}:${we[s]}`,
    section: "Operators",
    kind: "op",
    clause: { field: e.id, op: s }
  } : {
    id: `op:${s}`,
    label: xe[s],
    detail: `${n}:${we[s]}:…`,
    section: "Operators",
    kind: "op",
    insertText: `${n}:${we[s]}:`
  });
}
function ta(t, e, { limit: n = 8, tagOptions: r = [] } = {}) {
  if (t.stage === "tag") {
    const g = t.tagQuery.trim().toLowerCase();
    return r.filter((p) => !g || p.name.toLowerCase().includes(g)).slice(0, n).map((p) => ({
      id: `tag:${p.name}`,
      label: `#${p.name}`,
      detail: String(p.count),
      section: "Tags",
      kind: "tag",
      tag: p.name
    }));
  }
  if (t.stage === "field" || !t.field)
    return Gs(t.fieldToken, e).slice(0, n).map((g) => ({
      id: `field:${g.id}`,
      label: g.label,
      detail: `${He(g, e)}:`,
      section: "Filter by field",
      kind: "field",
      insertText: `${He(g, e)}:`
    }));
  const i = t.field, s = He(i, e), a = [];
  if (t.stage === "value" && t.op) {
    const g = t.op;
    if (Pt(g)) {
      const f = [...t.values, t.valueQuery], h = Ke(i, g, f);
      if (h && Te(h)) {
        const b = h.value.length;
        a.push({
          id: "apply",
          label: `Apply ${b} value${b === 1 ? "" : "s"}`,
          detail: xe[g],
          section: "Apply",
          kind: "apply",
          clause: h
        });
      }
    }
    a.push(...en(t, i, g, s, n));
    const p = t.valueQuery.trim();
    if (p && !a.some((f) => f.kind === "value")) {
      const f = Ke(i, g, [...t.values, p]);
      f && a.push({
        id: "free-text",
        label: `${i.label} ${xe[g]} "${Xe(p)}"`,
        section: "Apply",
        kind: "free-text",
        clause: f
      });
    }
    return a;
  }
  const l = rt(i), c = Dt(t), d = c && Se.has(c.op) ? tn(t, i, s, t.valueQuery, n).find((g) => g.clause?.op === c.op) : void 0;
  d && a.push(d), a.push(...en(t, i, l, s, n));
  const u = t.valueQuery.trim();
  if (u && !a.some((g) => g.kind === "value")) {
    const g = Ke(i, l, [u]);
    g && a.push({
      id: "free-text",
      label: `${i.label} ${xe[l]} "${Xe(u)}"`,
      section: "Apply",
      kind: "free-text",
      clause: g
    });
  }
  return a.push(
    ...tn(t, i, s, t.valueQuery, n).filter((g) => g.id !== d?.id)
  ), a;
}
function na(t) {
  if (!t || typeof t != "object") return !1;
  const e = t;
  return typeof e.entryId != "string" || typeof e.sortKey != "string" || !e.sortKey ? !1 : e.kind === "folder" ? e.entryId.startsWith("folder:") && typeof e.folderId == "string" && e.folderId.length > 0 && e.entryId === `folder:${e.folderId}` && typeof e.name == "string" && e.name.trim().length > 0 && // Absent is legal — a legacy row predates the field and is coerced on read.
  (e.ownership === void 0 || e.ownership === "personal" || e.ownership === "team") : e.kind === "type-placement" ? e.entryId.startsWith("type:") && typeof e.trackerType == "string" && e.trackerType.length > 0 && e.entryId === `type:${e.trackerType}` && (e.folderId === null || typeof e.folderId == "string" && e.folderId.length > 0) : !1;
}
function Ze(t, e) {
  return t.sortKey < e.sortKey ? -1 : t.sortKey > e.sortKey ? 1 : t.entryId < e.entryId ? -1 : t.entryId > e.entryId ? 1 : 0;
}
function ra(t) {
  return t.sharing === "team" ? "team" : "personal";
}
function tl(t, e) {
  if (!e.hasTeam) return null;
  const n = [];
  for (const r of ["team", "personal"]) {
    const i = (c) => ra(c.tracker) === r, s = [], a = [];
    for (const c of t.folders)
      ia(c.folder) === r ? s.push({ folder: c.folder, trackerTypes: c.trackerTypes.filter(i) }) : a.push(...c.trackerTypes.filter(i));
    const l = [...t.rootTypes.filter(i), ...a].sort((c, d) => Ze(c.placement, d.placement));
    n.push({ ownership: r, tree: { folders: s, rootTypes: l } });
  }
  return n;
}
function ia(t) {
  return t.ownership === "team" ? "team" : "personal";
}
function sa(t, e) {
  const n = e.filter((u) => u.kind === "folder").sort(Ze), r = new Set(n.map((u) => u.folderId)), i = /* @__PURE__ */ new Map();
  for (const u of e)
    u.kind === "type-placement" && !i.has(u.trackerType) && i.set(u.trackerType, u);
  const s = (u, g) => ({
    entryId: `type:${u}`,
    kind: "type-placement",
    trackerType: u,
    folderId: null,
    sortKey: `z${String(g).padStart(8, "0")}`
  }), a = t.map((u, g) => {
    const p = i.get(u.type) ?? s(u.type, g);
    return {
      tracker: u,
      placement: p.folderId !== null && !r.has(p.folderId) ? { ...p, folderId: null } : p
    };
  }), l = /* @__PURE__ */ new Map(), c = [];
  for (const u of a)
    if (u.placement.folderId === null) c.push(u);
    else {
      const g = l.get(u.placement.folderId) ?? [];
      g.push(u), l.set(u.placement.folderId, g);
    }
  const d = (u, g) => Ze(u.placement, g.placement);
  return c.sort(d), {
    folders: n.map((u) => ({
      folder: u,
      trackerTypes: (l.get(u.folderId) ?? []).sort(d)
    })),
    rootTypes: c
  };
}
function nl(t) {
  return Array.isArray(t) ? [...new Set(t.filter((e) => e === "personal" || e === "team"))] : [];
}
function rl(t) {
  return Array.isArray(t) ? [...new Set(t.filter((e) => typeof e == "string"))] : [];
}
function il(t, e, n) {
  const r = t.filter((i) => i !== e);
  return n ? [...r, e] : r;
}
function tr(t, e) {
  return `org:${t}:tracker:${e}`;
}
const aa = ["linkedSessions"];
function oa(t) {
  const e = {
    ...t,
    fields: { ...t.fields },
    system: { ...t.system }
  };
  for (const n of aa)
    delete e.fields[n], delete e.system[n];
  return e;
}
class la extends Error {
  constructor(e, n, r = $e) {
    super(`Tracker item ${e} is too large to share (${n} bytes, limit ${r}).`), this.itemId = e, this.bytes = n, this.limitBytes = r, this.code = "payloadTooLarge", this.name = "TrackerPayloadTooLargeError";
  }
}
const ca = new TextEncoder(), et = (t) => ca.encode(t).length;
function da(t) {
  const e = (t.activity ?? []).map((l) => ({
    ...l,
    oldValue: Ht(l.oldValue),
    newValue: Ht(l.newValue)
  })), n = (l) => JSON.stringify({ ...t, activity: l }), r = et(n([])), i = e.map((l) => et(JSON.stringify(l)));
  let s = r, a = e.length;
  for (; a > 0 && s + i[a - 1] + (a < e.length ? 1 : 0) <= $e; )
    s += i[a - 1] + (a < e.length ? 1 : 0), a--;
  return n(e.slice(a));
}
function Ue(t) {
  const e = oa(t);
  let n = JSON.stringify(e);
  if (et(n) > $e) {
    n = da(e);
    const i = et(n);
    if (i > $e)
      throw new la(t.itemId, i);
  }
  const r = $n(n, t.itemId);
  if (!r.success)
    throw new Error(`Invalid tracker item payload: ${r.error}`);
  return n;
}
function ua(t) {
  if (t.encryptedPayload === null)
    throw new Error("decodeTrackerEnvelopePlaintext called on a tombstone (encryptedPayload=null)");
  const e = $n(t.encryptedPayload, t.itemId);
  if (!e.success)
    throw new Error(`Invalid tracker item payload: ${e.error}`);
  return e.value;
}
function pa(t) {
  if (t.encryptedPayload === null)
    throw new Error("decodeTrackerSchemaEnvelopePlaintext called on a tombstone (encryptedPayload=null)");
  return t.encryptedPayload;
}
function ma(t) {
  if (t.encryptedPayload === null)
    throw new Error("decodeTrackerSavedViewEnvelopePlaintext called on a tombstone");
  return t.encryptedPayload;
}
function fa(t) {
  if (t.encryptedPayload === null)
    throw new Error("decodeTrackerNavigationEnvelopePlaintext called on a tombstone");
  return t.encryptedPayload;
}
function ha(t, e) {
  return t === 4002 ? {
    reason: "removed-from-org",
    closeCode: 4002,
    message: e || "You were removed from this team."
  } : t === 4003 ? {
    reason: "tracker-access-revoked",
    closeCode: 4003,
    message: e || "Your access to this tracker was revoked."
  } : t === 4004 ? {
    reason: "removed-from-org",
    closeCode: 4004,
    message: e || "This account was deleted."
  } : null;
}
class ya {
  constructor(e) {
    this.deps = e, this.inFlight = /* @__PURE__ */ new Map(), this.running = null, this.rerun = !1;
  }
  /** Push what the host has queued. Concurrent calls coalesce into one follow-up run. */
  push() {
    return this.running ? (this.rerun = !0, this.running) : (this.running = (async () => {
      try {
        do
          this.rerun = !1, await this.pushOnce();
        while (this.rerun);
      } finally {
        this.running = null;
      }
    })(), this.running);
  }
  /** The room answered this mutation, either way. Returns what it carried, if it was ours. */
  settle(e) {
    const n = this.inFlight.get(e);
    return this.inFlight.delete(e), n;
  }
  /** A new socket means nothing sent on the old one will be acked. */
  reset() {
    this.inFlight.clear();
  }
  /** Forget every unanswered mutation and return them, for a caller that has to answer for the room. */
  drain() {
    const e = [...this.inFlight].map(([n, r]) => ({ clientMutationId: n, ...r }));
    return this.inFlight.clear(), e;
  }
  isInFlight(e, n) {
    for (const r of this.inFlight.values())
      if (r.type === e && r.model === n) return !0;
    return !1;
  }
  async pushOnce() {
    const e = this.deps.hooks();
    if (!e || !this.deps.isOpen()) return;
    const n = await e.listUnsynced();
    if (!this.deps.isOpen()) return;
    const r = this.deps.createOnlySupported(), i = [];
    for (const s of n) {
      const a = s.deleted ? null : s.model;
      if (!this.isInFlight(s.type, a)) {
        if (s.createOnly === "required" && a !== null && !r) {
          console.warn(`[TrackerSchemaSync] not sending create-only type=${s.type}: room cannot refuse an existing type`);
          try {
            e.onSettled?.({
              type: s.type,
              model: a,
              accepted: !1,
              error: {
                code: "createOnlyUnsupported",
                message: "This team's server must be updated before new types can be created here."
              }
            });
          } catch (l) {
            console.error("[TrackerSchemaSync] onSettled threw", l);
          }
          continue;
        }
        i.push({ type: s.type, model: a, createOnly: s.createOnly !== void 0 && a !== null && r });
      }
    }
    i.length > 0 && console.info(`[TrackerSchemaSync] pushing ${i.length} unsynced schema mutation(s)`);
    for (const s of i) {
      const a = this.deps.newMutationId();
      this.deps.pendingLaneIds.set(a, s.type), this.inFlight.set(a, { type: s.type, model: s.model }), console.info(
        `[TrackerSchemaSync] -> mutation (${s.model === null ? "delete" : "upsert"}) type=${s.type} cmid=${a}`
      ), this.deps.send({
        type: "trackerSchemaMutation",
        clientMutationId: a,
        schemaType: s.type,
        encryptedPayload: s.model,
        ...s.createOnly ? { createOnly: !0 } : {}
      });
    }
  }
}
function Ee() {
  return `cm-${crypto.randomUUID()}`;
}
function Fe(t) {
  const e = typeof t == "string" ? t : typeof t == "object" && t && "toString" in t ? String(t) : null;
  if (e === null) return null;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function ga(t) {
  if (t.alreadyAttempted) return { action: "none", reason: "already-attempted" };
  if (t.strandedCount <= 0) return { action: "none", reason: "no-stranded-rows" };
  if (t.minStrandedSyncId >= t.localMaxSyncId)
    return { action: "none", reason: "cursor-not-ahead" };
  const e = Math.max(0, Number(t.minStrandedSyncId) - 1);
  return {
    action: "resync",
    sinceSyncId: e,
    strandedCount: t.strandedCount,
    rewindDistance: Number(t.localMaxSyncId) - e
  };
}
function ba(t) {
  if (!t) return [];
  const e = /* @__PURE__ */ new Set(), n = [];
  for (const r of Object.values(t))
    !r || typeof r != "object" || typeof r.value == "string" && (r.tombstone || e.has(r.value) || (e.add(r.value), n.push(r.value)));
  return n;
}
function va(t, e, n = xa) {
  const r = { ...t ?? {} }, i = new Set((e ?? []).filter((a) => typeof a == "string")), s = /* @__PURE__ */ new Map();
  for (const [a, l] of Object.entries(r)) {
    if (l.tombstone) continue;
    const c = s.get(l.value);
    c ? c.push(a) : s.set(l.value, [a]);
  }
  for (const [a, l] of s.entries())
    if (!i.has(a))
      for (const c of l)
        r[c] = { ...r[c], tombstone: !0 };
  for (const a of i) {
    if (s.has(a)) continue;
    const l = n();
    r[l] = { id: l, value: a };
  }
  return r;
}
function wa(t, e) {
  if (!t && !e) return {};
  if (!t) return { ...e };
  if (!e) return { ...t };
  const n = { ...t };
  for (const [r, i] of Object.entries(e)) {
    const s = n[r];
    if (!s) {
      n[r] = i;
      continue;
    }
    (i.tombstone || s.tombstone) && (n[r] = { ...s, tombstone: !0 });
  }
  return n;
}
function xa() {
  const t = typeof globalThis < "u" ? globalThis.crypto : void 0;
  return t?.randomUUID ? t.randomUUID() : `lbl_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
}
function Ce(t) {
  return t === "recoveryConflict" || t === "forbidden" || t === "legacy_encryption_retired" || t === "issueKeyPrefixConflict" || t === "adminRequired" || t === "schemaExists" || t === "malformed";
}
function ka(t, e) {
  return e ? t.owner?.orgId === e.orgId && t.owner.teamProjectId === e.teamProjectId && t.owner.teamMemberId === e.teamMemberId : !0;
}
function Ia(t) {
  return !t.confirmedSyncId && !t.terminalRejection && !(t.lastRejection && Ce(t.lastRejection.code));
}
const Ta = 1, ne = "items", ie = "transactions", fe = "savedViews";
function ae(t) {
  return new Promise((e, n) => {
    t.addEventListener("success", () => e(t.result), { once: !0 }), t.addEventListener("error", () => n(t.error ?? new Error("IndexedDB request failed")), {
      once: !0
    });
  });
}
function re(t) {
  return new Promise((e, n) => {
    t.addEventListener("complete", () => e(), { once: !0 }), t.addEventListener(
      "abort",
      () => n(t.error ?? new Error("IndexedDB transaction aborted")),
      { once: !0 }
    ), t.addEventListener(
      "error",
      () => n(t.error ?? new Error("IndexedDB transaction failed")),
      { once: !0 }
    );
  });
}
function _e(t) {
  return t ? {
    payload: t.payload,
    syncId: t.envelope.syncId,
    isTombstone: t.envelope.encryptedPayload === null
  } : { payload: null, syncId: null, isTombstone: !1 };
}
function lt(t, e, n) {
  const r = {
    itemId: t,
    syncId: n?.envelope.syncId ?? 0,
    encryptedPayload: e === null ? null : "optimistic",
    iv: e === null ? void 0 : "optimistic-iv",
    updatedAt: Date.now(),
    deletedAt: e === null ? Date.now() : null,
    orgKeyFingerprint: n?.envelope.orgKeyFingerprint ?? null,
    issueNumber: n?.envelope.issueNumber,
    issueKey: n?.envelope.issueKey
  };
  return { itemId: t, syncId: r.syncId, envelope: r, payload: e };
}
class _t {
  constructor(e, n = globalThis.indexedDB) {
    if (this.databaseName = e, this.closed = !1, !e.trim()) throw new Error("IndexedDB tracker persistence requires a database name");
    if (!n) throw new Error("IndexedDB is not available in this environment");
    const r = n.open(e, Ta);
    r.addEventListener("upgradeneeded", () => {
      const i = r.result;
      i.objectStoreNames.contains(ne) || i.createObjectStore(ne, { keyPath: "itemId" }).createIndex("syncId", "syncId"), i.objectStoreNames.contains(ie) || i.createObjectStore(ie, {
        keyPath: "clientMutationId"
      }).createIndex("enqueuedAt", "enqueuedAt"), i.objectStoreNames.contains(fe) || i.createObjectStore(fe, { keyPath: "viewId" }).createIndex("syncId", "syncId");
    }), this.databasePromise = ae(r);
  }
  async openTransaction(e, n) {
    const r = await this.databasePromise;
    if (this.closed) return null;
    try {
      return r.transaction(e, n);
    } catch (i) {
      if (this.closed) return null;
      throw i;
    }
  }
  async getMaxSyncId() {
    const e = await this.openTransaction(ne, "readonly");
    if (!e) return 0;
    const n = await ae(e.objectStore(ne).index("syncId").openCursor(null, "prev"));
    return await re(e), n?.value?.syncId ?? 0;
  }
  async applyRemoteItem(e, n) {
    const r = await this.openTransaction(ne, "readwrite");
    if (!r) return;
    const i = r.objectStore(ne), s = await ae(i.get(e.itemId));
    if (!s || s.envelope.syncId <= e.syncId) {
      let a = n;
      n && s?.payload && (a = {
        ...n,
        labels: wa(s.payload.labels, n.labels)
      }), i.put({
        itemId: e.itemId,
        syncId: e.syncId,
        envelope: e,
        payload: a
      });
    }
    await re(r);
  }
  async applyOptimistic(e, n) {
    const r = await this.openTransaction(ne, "readwrite");
    if (!r) return _e(void 0);
    const i = r.objectStore(ne), s = await ae(i.get(e)), a = _e(s);
    return i.put(lt(e, n, s)), await re(r), a;
  }
  async rollbackOptimistic(e, n) {
    const r = await this.openTransaction(ne, "readwrite");
    if (!r) return;
    const i = r.objectStore(ne);
    if (n.payload === null && !n.isTombstone && n.syncId === null)
      i.delete(e);
    else {
      const s = {
        itemId: e,
        syncId: n.syncId ?? 0,
        encryptedPayload: n.isTombstone ? null : "restored",
        iv: n.isTombstone ? void 0 : "restored-iv",
        updatedAt: Date.now(),
        deletedAt: n.isTombstone ? Date.now() : null,
        orgKeyFingerprint: null
      };
      i.put({ itemId: e, syncId: s.syncId, envelope: s, payload: n.payload });
    }
    await re(r);
  }
  async enqueueTransaction(e) {
    const n = await this.openTransaction(ie, "readwrite");
    n && (n.objectStore(ie).put(e), await re(n));
  }
  async applyAndEnqueueAtomically(e, n, r) {
    const i = await this.openTransaction([ne, ie], "readwrite");
    if (!i) return _e(void 0);
    const s = i.objectStore(ne), a = i.objectStore(ie), l = await ae(s.get(e)), c = _e(l);
    return a.put({ ...r, state: "pendingApply", rollbackSnapshot: c }), s.put(lt(e, n, l)), a.put({ ...r, state: "persistedEnqueue", rollbackSnapshot: c }), await re(i), c;
  }
  async applyAndEnqueueBatchAtomically(e) {
    const n = await this.openTransaction([ne, ie], "readwrite");
    if (!n) return e.map(() => _e(void 0));
    const r = n.objectStore(ne), i = n.objectStore(ie), s = [];
    for (const a of e) {
      const l = await ae(r.get(a.itemId)), c = _e(l);
      s.push(c), i.put({ ...a.row, state: "pendingApply", rollbackSnapshot: c }), r.put(lt(a.itemId, a.payload, l)), i.put({ ...a.row, state: "persistedEnqueue", rollbackSnapshot: c });
    }
    return await re(n), s;
  }
  async markTransactionStates(e, n, r) {
    const i = await this.openTransaction(ie, "readwrite");
    if (!i) return;
    const s = i.objectStore(ie);
    for (const a of e) {
      const l = await ae(s.get(a));
      l && s.put({ ...l, state: n, ...r === void 0 ? {} : { startedAt: r } });
    }
    await re(i);
  }
  async markTransactionState(e, n, r) {
    const i = await this.openTransaction(ie, "readwrite");
    if (!i) return;
    const s = i.objectStore(ie), a = await ae(s.get(e));
    a && s.put({ ...a, state: n, ...r === void 0 ? {} : { startedAt: r } }), await re(i);
  }
  async ackTransaction(e, n) {
    const r = await this.openTransaction(ie, "readwrite");
    r && (r.objectStore(ie).delete(e), await re(r));
  }
  async rejectTransaction(e, n, r = Ce(n.code)) {
    const i = await this.openTransaction(ie, "readwrite");
    if (!i) return;
    const s = i.objectStore(ie), a = await ae(s.get(e));
    a && s.put({ ...a, lastRejection: n, terminalRejection: r }), await re(i);
  }
  async loadPendingTransactions(e) {
    const n = await this.openTransaction(ie, "readonly");
    if (!n) return [];
    const r = await ae(n.objectStore(ie).getAll());
    return await re(n), r.filter((i) => ka(i, e) && Ia(i)).sort((i, s) => i.enqueuedAt - s.enqueuedAt);
  }
  async getItem(e) {
    const n = await this.openTransaction(ne, "readonly");
    if (!n) return;
    const r = await ae(n.objectStore(ne).get(e));
    return await re(n), r ? { envelope: r.envelope, payload: r.payload } : void 0;
  }
  async getItems(e) {
    const n = await this.openTransaction(ne, "readonly");
    if (!n) return e.map(() => {
    });
    const r = n.objectStore(ne), i = [];
    for (const s of e) {
      const a = await ae(r.get(s));
      i.push(a ? { envelope: a.envelope, payload: a.payload } : void 0);
    }
    return await re(n), i;
  }
  async listItems() {
    const e = await this.openTransaction(ne, "readonly");
    if (!e) return [];
    const n = await ae(e.objectStore(ne).getAll());
    return await re(e), n.map(({ envelope: r, payload: i }) => ({ envelope: r, payload: i }));
  }
  async putItem(e) {
    const n = await this.openTransaction(ne, "readwrite");
    n && (n.objectStore(ne).put({
      itemId: e.envelope.itemId,
      syncId: e.envelope.syncId,
      ...e
    }), await re(n));
  }
  async getTransaction(e) {
    const n = await this.openTransaction(ie, "readonly");
    if (!n) return;
    const r = await ae(n.objectStore(ie).get(e));
    return await re(n), r;
  }
  async getMaxSavedViewSyncId() {
    const e = await this.openTransaction(fe, "readonly");
    if (!e) return 0;
    const n = await ae(e.objectStore(fe).index("syncId").openCursor(null, "prev"));
    return await re(e), n?.value?.syncId ?? 0;
  }
  async listSavedViews() {
    const e = await this.openTransaction(fe, "readonly");
    if (!e) return [];
    const n = await ae(e.objectStore(fe).getAll());
    return await re(e), n;
  }
  async putLocalSavedView(e, n, r) {
    const i = await this.openTransaction(fe, "readwrite");
    if (!i) return;
    const s = i.objectStore(fe), a = await ae(s.get(e));
    s.put({
      viewId: e,
      payload: n,
      syncId: a?.syncId ?? 0,
      unsynced: !0,
      deleted: n === null,
      owner: r
    }), await re(i);
  }
  async applyRemoteSavedView(e, n, r) {
    const i = await this.openTransaction(fe, "readwrite");
    if (!i) return;
    const s = i.objectStore(fe), a = await ae(s.get(e));
    if (a && a.syncId > r) {
      await re(i);
      return;
    }
    const l = a?.unsynced && a.payload === n;
    s.put({
      viewId: e,
      payload: a?.unsynced && !l ? a.payload : n,
      syncId: r,
      unsynced: !!a?.unsynced && !l,
      deleted: a?.unsynced && !l ? a.deleted : n === null,
      ...a?.unsynced && !l ? { owner: a.owner } : {}
    }), await re(i);
  }
  async markSavedViewRejected(e, n) {
    const r = await this.openTransaction(fe, "readwrite");
    if (!r) return;
    const i = r.objectStore(fe), s = await ae(i.get(e));
    s && i.put({
      ...s,
      unsynced: !1,
      lastRejection: { code: n, occurredAt: Date.now() }
    }), await re(r);
  }
  /** Purge every plaintext projection and member outbox row for this room. */
  async purgeAll() {
    const e = await this.openTransaction(
      [ne, ie, fe],
      "readwrite"
    );
    e && (e.objectStore(ne).clear(), e.objectStore(ie).clear(), e.objectStore(fe).clear(), await re(e));
  }
  async close() {
    this.closed || (this.closed = !0, (await this.databasePromise).close());
  }
}
const Sa = 1e3, Na = 3e4, Ea = 3e4, Aa = 15e3;
class nn extends Error {
}
class Ca {
  constructor(e) {
    this.ws = null, this.status = "disconnected", this.accessTermination = null, this.destroyed = !1, this.synced = !1, this.connecting = !1, this.suppressReconnect = !1, this.reconnectAttempt = 0, this.reconnectTimer = null, this.pingTimer = null, this.presence = /* @__PURE__ */ new Map(), this.pendingLaneIds = /* @__PURE__ */ new Map(), this.schemaApplyChain = Promise.resolve(), this.schemaOutbox = new ya({
      hooks: () => this.config.schemaSync,
      isOpen: () => this.ws?.readyState === WebSocket.OPEN,
      send: (n) => this.send(n),
      newMutationId: Ee,
      pendingLaneIds: this.pendingLaneIds,
      createOnlySupported: () => this.schemaCreateOnlySupported
    }), this.schemaCreateOnlySupported = !1, this.rollbackSnapshots = /* @__PURE__ */ new Map(), this.outboxConsolidated = !1, this.pendingConfigChanges = /* @__PURE__ */ new Map(), this.config = e, this.persistence = e.persistence;
  }
  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------
  /**
   * Open the WebSocket and run the bootstrap loop. Idempotent: calling
   * `connect()` while already connected is a no-op.
   */
  async connect() {
    if (this.destroyed || this.accessTermination || this.ws || this.connecting) return;
    this.suppressReconnect = !1, this.connecting = !0, this.setStatus("connecting");
    const e = tr(this.config.orgId, this.config.teamProjectId);
    let n;
    try {
      if (this.config.buildUrl)
        n = this.config.buildUrl(e);
      else {
        const a = await this.config.getJwt(), l = await this.config.authorizeConnection?.(a) ?? null;
        if (l) {
          this.connecting = !1, this.recordAccessTermination(l);
          return;
        }
        n = Vr(`${this.config.serverUrl}/sync/${e}?token=${encodeURIComponent(a)}`);
      }
    } catch (a) {
      throw this.connecting = !1, this.setStatus("error"), this.accessTermination || this.scheduleReconnect(), a;
    }
    if (this.destroyed || this.ws) {
      this.connecting = !1;
      return;
    }
    const r = this.config.createWebSocket ? this.config.createWebSocket(n) : new WebSocket(n);
    this.ws = r, this.connecting = !1;
    let i = !1, s = !1;
    r.addEventListener("open", () => {
      this.ws === r && (i = !0, this.config.onAuthorized?.(), this.suppressReconnect = !1, this.reconnectAttempt = 0, this.setStatus("syncing"), this.startPing(), this.runBootstrap());
    }), r.addEventListener("message", (a) => {
      this.ws === r && this.handleMessage(a);
    }), r.addEventListener("close", (a) => {
      if (this.ws !== r) return;
      const l = a, c = ha(l?.code ?? 0, l?.reason ?? "");
      if (c) {
        this.handleDisconnect(c);
        return;
      }
      if (!i && this.config.authorizeConnection) {
        if (s) return;
        s = !0, this.revalidateFailedUpgrade(r);
        return;
      }
      this.handleDisconnect();
    }), r.addEventListener("error", () => {
      if (this.ws === r) {
        if (!i && this.config.authorizeConnection) {
          if (s) return;
          s = !0, this.revalidateFailedUpgrade(r);
          return;
        }
        this.handleDisconnect();
      }
    });
  }
  /** Re-run the room gate when the browser hides a failed upgrade's HTTP status. */
  async revalidateFailedUpgrade(e) {
    try {
      const n = await this.config.getJwt(), r = await this.config.authorizeConnection?.(n) ?? null;
      if (this.ws !== e) return;
      this.handleDisconnect(r);
    } catch {
      this.ws === e && !this.accessTermination && this.handleDisconnect();
    }
  }
  /** Disconnect without scheduling a reconnect. */
  disconnect() {
    this.closeSocket(), this.accessTermination || this.setStatus("disconnected");
  }
  /**
   * Stop for good, because this client may not be in this room.
   *
   * Called by the engine itself for a terminal close code, and by a host that
   * learned the same thing before a socket existed -- notably a team JWT that
   * cannot be minted because the browser session expired, which otherwise
   * retries silently forever and presents as an empty tracker rather than as
   * being signed out.
   */
  terminateAccess(e) {
    this.accessTermination || (this.refuseInFlightSchemaMutations("accessEnded", e.message), this.closeSocket(), this.recordAccessTermination(e));
  }
  /** The refusal that stopped this engine, or null while it is still trying. */
  getAccessTermination() {
    return this.accessTermination;
  }
  /** Teardown shared by an ordinary disconnect and a terminal refusal. */
  closeSocket() {
    if (this.suppressReconnect = !0, this.cancelReconnect(), this.stopPing(), this.ws) {
      try {
        this.ws.close();
      } catch {
      }
      this.ws = null;
    }
    this.connecting = !1, this.synced = !1, this.schemaOutbox.reset(), this.presence.size > 0 && (this.presence.clear(), this.notifyPresenceChange()), this.resolvePendingConfigChanges({
      success: !1,
      code: "disconnected",
      message: "Tracker sync disconnected before the prefix change was confirmed."
    });
  }
  /** Destroy the engine. Cannot be reused after this. */
  destroy() {
    this.destroyed = !0, this.refuseInFlightSchemaMutations("closed", "The tracker connection closed before the room answered."), this.disconnect(), this.rollbackSnapshots.clear(), this.pendingLaneIds.clear();
  }
  /** Current connection status. */
  getStatus() {
    return this.status;
  }
  /** Current remote-viewer roster. Returns a defensive snapshot. */
  getPresence() {
    return [...this.presence.values()];
  }
  /** Flush locally-pending shared saved views while connected. */
  async flushSavedViews() {
    await this.pushPendingSavedViews();
  }
  /** Flush locally-pending tracker navigation entries while connected. */
  async flushNavigation() {
    await this.pushPendingNavigation();
  }
  /** Push a schema saved mid-session; before bootstrap finishes, bootstrap pushes it (NIM-6654). */
  async flushSchemas() {
    this.synced && await this.schemaOutbox.push();
  }
  // --------------------------------------------------------------------------
  // Mutation API
  // --------------------------------------------------------------------------
  /**
   * Optimistically apply an upsert locally and enqueue it for upload.
   *
   * @param payload The full decrypted item payload. Device-local fields
   *   (`linkedSessions` etc.) are stripped at encryption time, not here.
   * @param options.persistedEnqueue When true, the apply + enqueue happen
   *   in a single SQL transaction (`TrackerPersistence.applyAndEnqueueAtomically`).
   */
  async upsertItem(e, n = {}) {
    return this.enqueueMutation(e.itemId, e, "update", n);
  }
  /** Optimistically apply and send an update-many command as one coherent batch. */
  async upsertItems(e) {
    if (e.length === 0) return { clientMutationIds: [] };
    if (e.length > 100) throw new Error("Tracker mutation batches are limited to 100 items");
    if (new Set(e.map((c) => c.itemId)).size !== e.length) throw new Error("Tracker mutation batches require unique item ids");
    const r = this.persistence.applyAndEnqueueBatchAtomically;
    if (!r) throw new Error("Tracker persistence does not support atomic mutation batches");
    for (const c of e) Ue(c);
    const i = Date.now(), s = Ee(), a = e.map((c, d) => ({
      clientMutationId: Ee(),
      itemId: c.itemId,
      workspacePath: "",
      state: "persistedEnqueue",
      kind: "update",
      payload: c,
      enqueuedAt: i + d,
      batchId: s,
      owner: {
        orgId: this.config.orgId,
        teamProjectId: this.config.teamProjectId,
        teamMemberId: this.config.teamMemberId
      }
    })), l = await r.call(
      this.persistence,
      a.map((c, d) => ({ itemId: c.itemId, payload: e[d], row: c }))
    );
    return a.forEach((c, d) => {
      this.rollbackSnapshots.set(c.clientMutationId, {
        itemId: c.itemId,
        snapshot: l[d]
      });
    }), await this.driveTransactionBatch(a), { clientMutationIds: a.map((c) => c.clientMutationId) };
  }
  /**
   * Optimistically apply a delete (tombstone) and enqueue it for upload.
   */
  async deleteItem(e, n = {}) {
    return this.enqueueMutation(e, null, "delete", n);
  }
  /**
   * Push a room-level config change (currently: issue-key prefix). Server
   * broadcasts the change to all connections including the originator
   * via `trackerConfigBroadcast` -- the engine surfaces it through
   * `onConfigChange`.
   */
  setIssueKeyPrefix(e, n = "explicit") {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN)
      return Promise.resolve({
        success: !1,
        code: "disconnected",
        message: "Tracker sync must be connected before changing the issue-key prefix."
      });
    const r = Ee();
    return new Promise((i) => {
      const s = setTimeout(() => {
        this.pendingConfigChanges.delete(r), i({
          success: !1,
          code: "timeout",
          message: "Timed out waiting for the server to confirm the issue-key prefix."
        });
      }, 5e3);
      s.unref?.(), this.pendingConfigChanges.set(r, { requestedPrefix: e, resolve: i, timer: s });
      try {
        this.send({
          type: "trackerSetConfig",
          key: "issueKeyPrefix",
          value: e,
          clientMutationId: r,
          assignmentMode: n
        });
      } catch (a) {
        clearTimeout(s), this.pendingConfigChanges.delete(r), i({ success: !1, code: "sendFailed", message: a instanceof Error ? a.message : String(a) });
      }
    });
  }
  // --------------------------------------------------------------------------
  // Bootstrap loop + replay
  // --------------------------------------------------------------------------
  async runBootstrap() {
    try {
      !this.outboxConsolidated && this.persistence.consolidatePendingUpdates && (await this.persistence.consolidatePendingUpdates().catch((l) => this.config.onBootstrapError?.(l)), this.outboxConsolidated = !0), await this.runSchemaBootstrap();
      let e = await this.persistence.getMaxSyncId(), n = e === zt;
      const r = n;
      let i = !1, s;
      for (; ; ) {
        const l = await this.requestSync(e);
        if (i ||= l.items.length > 0, await this.applyBootstrapBatch(l), n && l.config && (s = l.config, this.config.onConfigChange?.(l.config)), n = !1, e = l.cursorSyncId, !l.hasMore) break;
      }
      const a = this.config.initializeIssueKeyPrefix;
      if (r && !i && a && s?.issueKeyPrefix === "NIM" && a !== s.issueKeyPrefix) {
        const l = await this.setIssueKeyPrefix(a, "auto");
        l.success || console.warn(`[TrackerSync] automatic issue-key prefix assignment failed: ${l.message ?? l.code}`);
      }
      await this.runIdentityRecovery(e), await this.runNavigationBootstrap(), await this.runSavedViewBootstrap(), this.synced = !0, this.setStatus("connected"), this.announcePresence(), await this.replayPending().catch((l) => this.config.onBootstrapError?.(l)), await this.schemaOutbox.push(), await this.pushPendingNavigation(), await this.pushPendingSavedViews();
    } catch (e) {
      this.config.onBootstrapError?.(e);
    }
  }
  /**
   * Re-request a span of the changelog for rows the old collision branch
   * stranded without an issue key.
   *
   * Those rows are `synced` and carry a `sync_id`, so the ordinary bootstrap
   * -- which starts at `MAX(sync_id)` -- can never reach them again. See
   * `trackerIdentityRecovery.ts` for why, and for the pure decision this only
   * executes.
   *
   * The attempt is marked whether or not it succeeds. The alternative, marking
   * only on success, retries a multi-thousand-row rewind on every launch for
   * any workspace whose rows the room cannot re-assert, which is a worse
   * failure than one repair that did not take. A workspace stuck that way is
   * diagnosable from the warning below.
   */
  async runIdentityRecovery(e) {
    const n = this.config.identityRecovery;
    if (!n) return;
    let r;
    try {
      r = ga({ ...await n.getFacts(), localMaxSyncId: e });
    } catch (i) {
      this.config.onBootstrapError?.(i);
      return;
    }
    if (r.action !== "none") {
      console.warn(
        `[TrackerSync] ${r.strandedCount} synced item(s) carry no issue key; re-requesting`,
        `the changelog from sync_id ${r.sinceSyncId} (${r.rewindDistance} entries behind`,
        "the cursor) so the room can re-assert their identity"
      );
      try {
        let i = r.sinceSyncId;
        for (; ; ) {
          const s = await this.requestSync(i);
          if (await this.applyBootstrapBatch(s), i = s.cursorSyncId, !s.hasMore) break;
        }
      } catch (i) {
        this.config.onBootstrapError?.(i);
      } finally {
        await n.markAttempted().catch((i) => this.config.onBootstrapError?.(i));
      }
    }
  }
  requestSync(e) {
    return new Promise((n, r) => {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        r(new Error("WebSocket not open"));
        return;
      }
      const i = (s) => {
        const a = Fe(s.data);
        !a || a.type !== "trackerSyncResponse" || (this.ws?.removeEventListener("message", i), n(a));
      };
      this.ws.addEventListener("message", i), this.send({
        type: "trackerSync",
        sinceSyncId: e,
        ...e === zt && this.config.initializeIssueKeyPrefix ? { initializeIssueKeyPrefix: this.config.initializeIssueKeyPrefix } : {}
      });
    });
  }
  /**
   * Bootstrap schemas from ZERO, not from the local cursor.
   *
   * Items page from `MAX(sync_id)` because there can be tens of thousands of
   * them. Schemas are a handful of rows, and an incremental cursor makes the
   * client unrepairable: one workspace-wide MAX means any type whose version
   * sits BELOW the cursor is never re-sent, so a row that was clobbered or
   * never applied stays stale forever with no way back (#1178). A full snapshot
   * every connect is cheap and makes the server's definition self-healing --
   * `applyRemote` is version-gated and content-gated, so re-delivering what we
   * already have is a no-op.
   */
  async runSchemaBootstrap() {
    if (!this.config.schemaSync) return;
    let n = 0;
    this.schemaCreateOnlySupported = !1, console.info("[TrackerSchemaSync] bootstrap start (full snapshot since sync_id=0)");
    try {
      for (; ; ) {
        const r = await this.requestSchemaSync(n);
        if (console.info(
          `[TrackerSchemaSync] bootstrap batch: ${r.schemas.length} schema(s), cursor=${r.cursorSyncId}, hasMore=${r.hasMore}`
        ), r.schemaCreateOnly === !0 && (this.schemaCreateOnlySupported = !0), await this.applySchemaBootstrapBatch(r), n = r.cursorSyncId, !r.hasMore) break;
      }
    } catch (r) {
      if (!(r instanceof nn)) throw r;
      console.warn(
        `[TrackerSchemaSync] ${r.message}; continuing with locally-known schemas`
      );
      return;
    }
    console.info(`[TrackerSchemaSync] bootstrap complete at sync_id=${n}`);
  }
  requestSchemaSync(e) {
    const n = this.config.schemaBootstrapTimeoutMs ?? Aa;
    return new Promise((r, i) => {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        i(new Error("WebSocket not open"));
        return;
      }
      const s = (l) => {
        const c = Fe(l.data);
        !c || c.type !== "trackerSchemaSyncResponse" || (clearTimeout(a), this.ws?.removeEventListener("message", s), r(c));
      }, a = setTimeout(() => {
        this.ws?.removeEventListener("message", s), i(new nn(
          `schema bootstrap timed out after ${n}ms waiting for trackerSchemaSyncResponse`
        ));
      }, n);
      a.unref?.(), this.ws.addEventListener("message", s), this.send({ type: "trackerSchemaSync", sinceSyncId: e });
    });
  }
  async applySchemaBootstrapBatch(e) {
    for (const n of e.schemas)
      try {
        await this.applySchemaEnvelope(n);
      } catch (r) {
        this.config.onBootstrapError?.(r);
      }
  }
  async runNavigationBootstrap() {
    const e = this.config.navigationSync;
    if (!e) return;
    let n = await e.getMaxSyncId();
    for (; ; ) {
      const r = await this.requestNavigationSync(n);
      for (const i of r.entries)
        try {
          await this.applyNavigationEnvelope(i);
        } catch (s) {
          this.config.onBootstrapError?.(s);
        }
      if (n = r.cursorSyncId, !r.hasMore) break;
    }
  }
  async runSavedViewBootstrap() {
    const e = this.config.savedViewSync;
    if (!e) return;
    let n = await e.getMaxSyncId();
    for (; ; ) {
      const r = await this.requestSavedViewSync(n);
      for (const i of r.views)
        try {
          await this.applySavedViewEnvelope(i);
        } catch (s) {
          this.config.onBootstrapError?.(s);
        }
      if (n = r.cursorSyncId, !r.hasMore) break;
    }
  }
  requestSavedViewSync(e) {
    return new Promise((n, r) => {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        r(new Error("WebSocket not open"));
        return;
      }
      const i = (s) => {
        const a = Fe(s.data);
        !a || a.type !== "trackerSavedViewSyncResponse" || (this.ws?.removeEventListener("message", i), n(a));
      };
      this.ws.addEventListener("message", i), this.send({ type: "trackerSavedViewSync", sinceSyncId: e });
    });
  }
  requestNavigationSync(e) {
    return new Promise((n, r) => {
      if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
        r(new Error("WebSocket not open"));
        return;
      }
      const i = (s) => {
        const a = Fe(s.data);
        !a || a.type !== "trackerNavigationSyncResponse" || (this.ws?.removeEventListener("message", i), n(a));
      };
      this.ws.addEventListener("message", i), this.send({ type: "trackerNavigationSync", sinceSyncId: e });
    });
  }
  async applyBootstrapBatch(e) {
    for (const n of e.items)
      try {
        await this.applyEnvelope(n);
      } catch (r) {
        this.config.onBootstrapError?.(r);
      }
  }
  async replayPending() {
    const e = {
      orgId: this.config.orgId,
      teamProjectId: this.config.teamProjectId,
      teamMemberId: this.config.teamMemberId
    }, n = (await this.persistence.loadPendingTransactions(e)).filter((i) => !(i.lastRejection && Ce(i.lastRejection.code))), r = /* @__PURE__ */ new Set();
    for (const i of n)
      try {
        if (i.batchId && !r.has(i.batchId)) {
          r.add(i.batchId);
          const s = n.filter((a) => a.batchId === i.batchId);
          for (const a of s)
            a.rollbackSnapshot && this.rollbackSnapshots.set(a.clientMutationId, {
              itemId: a.itemId,
              snapshot: a.rollbackSnapshot
            });
          await this.driveTransactionBatch(s);
          continue;
        }
        if (i.batchId) continue;
        if (i.rollbackSnapshot && this.rollbackSnapshots.set(i.clientMutationId, {
          itemId: i.itemId,
          snapshot: i.rollbackSnapshot
        }), i.state === "pendingApply") {
          const s = await this.persistence.applyOptimistic(i.itemId, i.payload ?? null);
          i.rollbackSnapshot || this.rollbackSnapshots.set(i.clientMutationId, { itemId: i.itemId, snapshot: s }), await this.persistence.markTransactionState(i.clientMutationId, "persistedEnqueue"), i.state = "persistedEnqueue";
        }
        await this.driveTransaction(i);
      } catch {
      }
  }
  // --------------------------------------------------------------------------
  // Message dispatch
  // --------------------------------------------------------------------------
  async handleMessage(e) {
    if (this.destroyed) return;
    const n = Fe(e.data);
    if (n)
      switch (n.type) {
        case "trackerDelta":
          await this.handleDelta(n);
          break;
        case "trackerMutationAck":
          await this.handleAck(n);
          break;
        case "trackerMutationBatchAck":
          await this.handleBatchAck(n);
          break;
        case "trackerSchemaDelta":
          await this.handleSchemaDelta(n);
          break;
        case "trackerSchemaMutationAck":
          await this.handleSchemaAck(n);
          break;
        case "trackerSavedViewDelta":
          await this.handleSavedViewDelta(n);
          break;
        case "trackerSavedViewMutationAck":
          await this.handleSavedViewAck(n);
          break;
        case "trackerNavigationDelta":
          await this.handleNavigationDelta(n);
          break;
        case "trackerNavigationMutationAck":
          await this.handleNavigationAck(n);
          break;
        case "trackerConfigBroadcast":
          this.handleConfigBroadcast(n);
          break;
        case "trackerPresenceRoster":
          this.handlePresenceRoster(n);
          break;
        case "trackerPresenceDelta":
          this.handlePresenceDelta(n);
          break;
        case "trackerPong":
          break;
        case "trackerRoomMoved":
          this.handleRoomMoved(n);
          break;
        case "trackerError":
          this.handleServerError(n);
          break;
      }
  }
  /**
   * Epic H3 P1: the server reports this room was relocated to another org. The
   * old room is frozen/tombstoned, so stop reconnecting and hand the
   * destination to the host, which re-resolves routing (the project now lives
   * at a new org-scoped room) and spins up a fresh engine pointed there.
   */
  handleRoomMoved(e) {
    this.disconnect(), this.config.onRoomMoved?.({ destOrgId: e.destOrgId, destTeamProjectId: e.destTeamProjectId });
  }
  async handleDelta(e) {
    await this.applyEnvelope(e.item);
  }
  async handleAck(e) {
    if (this.destroyed) return;
    const { clientMutationId: n, accepted: r } = e;
    if (r && e.syncId !== void 0 && e.item) {
      if (await this.applyEnvelope(e.item), this.destroyed || (await this.persistence.ackTransaction(n, e.syncId), this.destroyed)) return;
      this.rollbackSnapshots.delete(n);
      return;
    }
    if (!r && e.error) {
      const i = this.rollbackSnapshots.get(n), s = {
        code: e.error.code,
        message: e.error.message,
        occurredAt: Date.now()
      };
      if (await this.persistence.rejectTransaction(
        n,
        s,
        Ce(s.code)
      ), this.destroyed) return;
      if (i) {
        if (s.code !== "recoveryConflict" && await this.persistence.rollbackOptimistic(i.itemId, i.snapshot), this.destroyed) return;
        this.rollbackSnapshots.delete(n), this.config.onRejection?.({
          clientMutationId: n,
          itemId: i.itemId,
          rejection: s
        });
      }
    }
  }
  async handleBatchAck(e) {
    if (!this.destroyed) {
      if (e.accepted) {
        for (const n of e.entries)
          if (n.syncId !== void 0 && n.item) {
            if (await this.applyEnvelope(n.item), this.destroyed || (await this.persistence.ackTransaction(n.clientMutationId, n.syncId), this.destroyed)) return;
            this.rollbackSnapshots.delete(n.clientMutationId);
          }
        return;
      }
      if (e.error)
        for (const n of e.entries) {
          const r = this.rollbackSnapshots.get(n.clientMutationId), i = {
            code: e.error.code,
            message: e.error.message,
            occurredAt: Date.now()
          };
          if (await this.persistence.rejectTransaction(
            n.clientMutationId,
            i,
            Ce(i.code)
          ), this.destroyed) return;
          if (r) {
            if (i.code !== "recoveryConflict" && await this.persistence.rollbackOptimistic(r.itemId, r.snapshot), this.destroyed) return;
            this.rollbackSnapshots.delete(n.clientMutationId), this.config.onRejection?.({
              clientMutationId: n.clientMutationId,
              itemId: r.itemId,
              rejection: i
            });
          }
        }
    }
  }
  async handleSchemaDelta(e) {
    console.info(
      `[TrackerSchemaSync] delta type=${e.schema.schemaType} sync_id=${e.schema.syncId} tombstone=${e.schema.encryptedPayload === null}`
    ), await this.applySchemaEnvelope(e.schema);
  }
  async handleSchemaAck(e) {
    console.info(
      `[TrackerSchemaSync] ack cmid=${e.clientMutationId} accepted=${e.accepted}${e.schema ? ` type=${e.schema.schemaType} sync_id=${e.schema.syncId}` : ""}${e.error ? ` error=${e.error.code}` : ""}`
    );
    const n = this.schemaOutbox.settle(e.clientMutationId);
    if (n && this.notifySchemaSettled(n, e.accepted, e.error), e.accepted && e.schema) {
      this.pendingLaneIds.delete(e.clientMutationId), await this.applySchemaEnvelope(e.schema);
      return;
    }
    await this.retireRefusedLaneChange(
      "schema",
      e.clientMutationId,
      e.error,
      this.config.schemaSync?.markRejected
    );
  }
  notifySchemaSettled(e, n, r) {
    try {
      this.config.schemaSync?.onSettled?.({
        type: e.type,
        model: e.model,
        accepted: n,
        ...r ? { error: { code: r.code, message: r.message } } : {}
      });
    } catch (i) {
      this.config.onBootstrapError?.(i);
    }
  }
  /**
   * Answer, as refused, schema mutations the room will never ack. The codes
   * are temporary, so a desktop row is not retired and goes out again on the
   * next connect; a browser creation waiting on its answer hears now instead
   * of never.
   */
  refuseInFlightSchemaMutations(e, n) {
    for (const r of this.schemaOutbox.drain())
      this.pendingLaneIds.delete(r.clientMutationId), this.notifySchemaSettled(r, !1, { code: e, message: n });
  }
  async handleSavedViewDelta(e) {
    await this.applySavedViewEnvelope(e.view);
  }
  async handleSavedViewAck(e) {
    if (e.accepted && e.view) {
      await this.applySavedViewEnvelope(e.view);
      return;
    }
    await this.retireRefusedLaneChange(
      "savedView",
      e.clientMutationId,
      e.error,
      this.config.savedViewSync?.markRejected
    );
  }
  /**
   * Retire a saved-view / navigation / schema change the server has settled on,
   * and tell the host.
   *
   * Only *terminal* codes retire the row. A write barrier like `rotationLocked`
   * or a missing key is temporary, and dropping the user's change on one would
   * turn a momentary refusal into silent data loss -- so anything not in the
   * tracker-specific permanent vocabulary stays queued and is retried, exactly
   * as before. Tracker codes deliberately do not inherit the document outbox
   * policy: `adminRequired`, `malformed`, and `legacy_encryption_retired` exist
   * only here and replaying them cannot make the payload valid.
   */
  async retireRefusedLaneChange(e, n, r, i) {
    const s = this.pendingLaneIds.get(n);
    if (this.pendingLaneIds.delete(n), !(!r || s === void 0) && Ce(r.code)) {
      if (i)
        try {
          await i(s, r.code);
        } catch (a) {
          this.config.onBootstrapError?.(a);
        }
      this.config.onRejection?.({
        clientMutationId: n,
        itemId: s,
        lane: e,
        rejection: { code: r.code, message: r.message, occurredAt: Date.now() }
      });
    }
  }
  async handleNavigationDelta(e) {
    await this.applyNavigationEnvelope(e.entry);
  }
  async handleNavigationAck(e) {
    if (e.accepted && e.entry) {
      await this.applyNavigationEnvelope(e.entry);
      return;
    }
    await this.retireRefusedLaneChange(
      "navigation",
      e.clientMutationId,
      e.error,
      this.config.navigationSync?.markRejected
    );
  }
  handleConfigBroadcast(e) {
    this.config.onConfigChange?.(e.config);
    for (const [n, r] of this.pendingConfigChanges)
      (r.requestedPrefix === e.config.issueKeyPrefix || r.requestedPrefix === e.config.issueKeyPrefixAssignment?.requestedPrefix) && (clearTimeout(r.timer), this.pendingConfigChanges.delete(n), r.resolve({ success: !0, config: e.config }));
  }
  handlePresenceRoster(e) {
    this.presence.clear();
    for (const n of e.members) {
      const r = Bt(n.teamMemberId);
      r !== this.config.teamMemberId && this.presence.set(r, { ...n, teamMemberId: r });
    }
    this.notifyPresenceChange();
  }
  handlePresenceDelta(e) {
    const n = Bt(e.member.teamMemberId);
    n !== this.config.teamMemberId && (e.connected ? this.presence.set(n, { ...e.member, teamMemberId: n }) : this.presence.delete(n), this.notifyPresenceChange());
  }
  notifyPresenceChange() {
    this.config.onPresenceChange?.(this.getPresence());
  }
  handleServerError(e) {
    if (this.config.onServerError?.(e), e.code === "access_revoked") {
      this.terminateAccess({
        reason: "tracker-access-revoked",
        closeCode: 4003,
        message: e.message || "Your access to this tracker was revoked."
      });
      return;
    }
    e.clientMutationId || this.refuseInFlightSchemaMutations(e.code, e.message);
    const n = e.clientMutationId ? this.pendingConfigChanges.get(e.clientMutationId) : this.pendingConfigChanges.size === 1 ? this.pendingConfigChanges.values().next().value : void 0;
    if (n) {
      if (clearTimeout(n.timer), e.clientMutationId) this.pendingConfigChanges.delete(e.clientMutationId);
      else
        for (const [r, i] of this.pendingConfigChanges)
          i === n && this.pendingConfigChanges.delete(r);
      n.resolve({
        success: !1,
        code: e.code,
        message: e.message,
        conflictingProjectName: e.conflictingProjectName,
        suggestedPrefix: e.suggestedPrefix
      });
    }
    !e.code.startsWith("issueKeyPrefix") && e.code !== "invalid_config" && this.setStatus("error");
  }
  resolvePendingConfigChanges(e) {
    for (const n of this.pendingConfigChanges.values())
      clearTimeout(n.timer), n.resolve(e);
    this.pendingConfigChanges.clear();
  }
  // --------------------------------------------------------------------------
  // Apply / project
  // --------------------------------------------------------------------------
  /**
   * Decrypt (if needed) and project a server envelope. Tolerant of
   * per-item decryption failures: a single unreadable envelope (e.g. a
   * stale-key-epoch payload arriving before our `staleKeyEpoch` rejection
   * has triggered a refresh) is skipped, not fatal.
   *
   * Returns `true` when the envelope was applied (or was a tombstone), and
   * `false` when decryption failed and the row was skipped. Callers use
   * this signal to detect a stale-key bootstrap and trigger `refreshKey()`.
   */
  async applyEnvelope(e) {
    const n = e.encryptedPayload === null;
    let r = null;
    if (!n)
      try {
        r = ua(e);
      } catch (i) {
        return console.warn("[TrackerSync] failed to parse item payload; skipping", i), !1;
      }
    return await this.persistence.applyRemoteItem(e, r), this.config.onItemApplied?.({
      itemId: e.itemId,
      syncId: e.syncId,
      payload: r,
      isTombstone: n,
      issueNumber: e.issueNumber,
      issueKey: e.issueKey
    }), !0;
  }
  /**
   * Socket messages are dispatched without awaiting each other, and a host's
   * `applyRemote` awaits file writes. Unserialized, an older delivery can finish
   * after a newer one and leave the older content and syncId in place.
   */
  applySchemaEnvelope(e) {
    const n = this.schemaApplyChain.then(() => this.applySchemaEnvelopeNow(e));
    return this.schemaApplyChain = n.catch(() => {
    }), n;
  }
  async applySchemaEnvelopeNow(e) {
    const n = this.config.schemaSync;
    if (!n) return !0;
    const r = e.encryptedPayload === null;
    let i = null;
    if (!r)
      try {
        i = pa(e);
      } catch (s) {
        return console.warn("[TrackerSchemaSync] failed to parse schema payload; skipping", s), !1;
      }
    return await n.applyRemote({
      type: e.schemaType,
      model: i,
      syncId: e.syncId
    }), this.config.onSchemaApplied?.({
      type: e.schemaType,
      syncId: e.syncId,
      model: i,
      isTombstone: r
    }), !0;
  }
  async applySavedViewEnvelope(e) {
    const n = this.config.savedViewSync;
    if (!n) return !0;
    const r = e.encryptedPayload === null;
    let i = null;
    if (!r)
      try {
        i = ma(e);
      } catch {
        return !1;
      }
    return await n.applyRemote({ viewId: e.viewId, payload: i, syncId: e.syncId }), !0;
  }
  async applyNavigationEnvelope(e) {
    const n = this.config.navigationSync;
    if (!n) return !0;
    const r = e.encryptedPayload === null;
    let i = null;
    if (!r)
      try {
        i = fa(e);
      } catch {
        return !1;
      }
    return await n.applyRemote({ entryId: e.entryId, payload: i, syncId: e.syncId }), !0;
  }
  // --------------------------------------------------------------------------
  // Queue drive
  // --------------------------------------------------------------------------
  async enqueueMutation(e, n, r, i) {
    n && Ue(n);
    const s = Ee(), a = Date.now(), l = {
      clientMutationId: s,
      itemId: e,
      workspacePath: "",
      // host adapter fills this in; engine doesn't care
      state: i.persistedEnqueue ? "persistedEnqueue" : "created",
      kind: r,
      payload: n ?? void 0,
      enqueuedAt: a,
      owner: {
        orgId: this.config.orgId,
        teamProjectId: this.config.teamProjectId,
        teamMemberId: this.config.teamMemberId
      }
    };
    let c;
    return i.persistedEnqueue ? c = await this.persistence.applyAndEnqueueAtomically(e, n, l) : (c = await this.persistence.applyOptimistic(e, n), l.expectedSyncId = c.syncId ?? 0, l.rollbackSnapshot = c, await this.persistence.enqueueTransaction(l)), this.rollbackSnapshots.set(s, { itemId: e, snapshot: c }), l.state === "created" && (await this.persistence.markTransactionState(s, "queued"), l.state = "queued"), await this.driveTransaction(l), { clientMutationId: s };
  }
  /**
   * Move a transaction through the wire. If the socket is closed, leave
   * the row in `queued` for the next reconnect. Encryption happens HERE,
   * not at enqueue, so a key rotation between enqueue and send uses the
   * fresh key.
   */
  async driveTransaction(e) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    const n = Date.now();
    if (await this.persistence.markTransactionState(e.clientMutationId, "executing", n), e.kind === "delete" || e.payload === void 0) {
      this.send({
        type: "trackerMutation",
        clientMutationId: e.clientMutationId,
        itemId: e.itemId,
        expectedSyncId: e.expectedSyncId ?? this.rollbackSnapshots.get(e.clientMutationId)?.snapshot.syncId ?? 0,
        encryptedPayload: null
      });
      return;
    }
    this.send({
      type: "trackerMutation",
      clientMutationId: e.clientMutationId,
      itemId: e.itemId,
      expectedSyncId: e.expectedSyncId ?? this.rollbackSnapshots.get(e.clientMutationId)?.snapshot.syncId ?? 0,
      encryptedPayload: Ue(e.payload),
      ...e.payload?.issueNumber !== void 0 ? { issueNumber: e.payload.issueNumber } : {},
      ...e.payload?.issueKey !== void 0 ? { issueKey: e.payload.issueKey } : {}
    });
  }
  async driveTransactionBatch(e) {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    const n = Date.now();
    if (this.persistence.markTransactionStates)
      await this.persistence.markTransactionStates(
        e.map((r) => r.clientMutationId),
        "executing",
        n
      );
    else
      for (const r of e)
        await this.persistence.markTransactionState(r.clientMutationId, "executing", n);
    this.send({
      type: "trackerMutationBatch",
      mutations: e.map((r) => ({
        clientMutationId: r.clientMutationId,
        itemId: r.itemId,
        expectedSyncId: r.expectedSyncId ?? this.rollbackSnapshots.get(r.clientMutationId)?.snapshot.syncId ?? 0,
        encryptedPayload: Ue(r.payload),
        ...r.payload?.issueNumber !== void 0 ? { issueNumber: r.payload.issueNumber } : {},
        ...r.payload?.issueKey !== void 0 ? { issueKey: r.payload.issueKey } : {}
      }))
    });
  }
  async pushPendingSavedViews() {
    const e = this.config.savedViewSync;
    if (!e || !this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    const n = await e.listUnsynced();
    for (const r of n) {
      const i = Ee();
      if (this.pendingLaneIds.set(i, r.viewId), r.deleted || r.payload === null) {
        this.send({
          type: "trackerSavedViewMutation",
          clientMutationId: i,
          viewId: r.viewId,
          encryptedPayload: null
        });
        continue;
      }
      this.send({
        type: "trackerSavedViewMutation",
        clientMutationId: i,
        viewId: r.viewId,
        encryptedPayload: r.payload
      });
    }
  }
  async pushPendingNavigation() {
    const e = this.config.navigationSync;
    if (!e || !this.ws || this.ws.readyState !== WebSocket.OPEN) return;
    const n = await e.listUnsynced();
    for (const r of n) {
      const i = Ee();
      if (this.pendingLaneIds.set(i, r.entryId), r.deleted || r.payload === null) {
        this.send({
          type: "trackerNavigationMutation",
          clientMutationId: i,
          entryId: r.entryId,
          encryptedPayload: null
        });
        continue;
      }
      this.send({
        type: "trackerNavigationMutation",
        clientMutationId: i,
        entryId: r.entryId,
        encryptedPayload: r.payload
      });
    }
  }
  // --------------------------------------------------------------------------
  // Connection plumbing
  // --------------------------------------------------------------------------
  send(e) {
    !this.ws || this.ws.readyState !== WebSocket.OPEN || this.ws.send(JSON.stringify(e));
  }
  setStatus(e) {
    this.status !== e && (this.status = e, this.config.onStatusChange?.(e));
  }
  handleDisconnect(e = null) {
    const n = !this.suppressReconnect && !e;
    if (this.stopPing(), this.ws = null, this.synced = !1, this.connecting = !1, this.presence.size > 0 && (this.presence.clear(), this.notifyPresenceChange()), this.resolvePendingConfigChanges({
      success: !1,
      code: "disconnected",
      message: "Tracker sync disconnected before the prefix change was confirmed."
    }), e) {
      this.recordAccessTermination(e);
      return;
    }
    this.setStatus("disconnected"), n && !this.destroyed && this.scheduleReconnect();
  }
  recordAccessTermination(e) {
    this.accessTermination || (this.accessTermination = e, this.suppressReconnect = !0, this.cancelReconnect(), this.refuseInFlightSchemaMutations("accessEnded", e.message), this.setStatus("error"), this.config.onAccessTerminated?.(e));
  }
  scheduleReconnect() {
    if (this.destroyed || this.reconnectTimer) return;
    const n = Math.min(
      Sa * Math.pow(2, this.reconnectAttempt),
      Na
    ) * (0.5 + Math.random());
    this.reconnectAttempt++, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, !this.destroyed && this.connect();
    }, n);
  }
  cancelReconnect() {
    this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
  startPing() {
    this.stopPing(), this.pingTimer = setInterval(() => {
      this.announcePresence(), this.send({ type: "trackerPing" });
    }, Ea);
  }
  announcePresence() {
    const e = this.config.presenceIdentity, n = e?.displayName.trim() || this.config.teamMemberId;
    this.send({
      type: "trackerPresence",
      displayName: n,
      avatarUrl: e?.avatarUrl ?? null
    });
  }
  stopPing() {
    this.pingTimer && (clearInterval(this.pingTimer), this.pingTimer = null);
  }
}
const rn = "Browser trackers only support team-shared mutations", Rt = "nimbalyst-tracker-v1:";
function nr(t, e) {
  return `${Rt}${t}:${e}`;
}
async function rr(t, e = globalThis.indexedDB) {
  const r = (await e.databases()).map((i) => i.name).filter((i) => typeof i == "string" && t(i));
  await Promise.all(r.map(async (i) => {
    const s = new _t(i, e);
    try {
      await s.purgeAll();
    } finally {
      await s.close();
    }
  }));
}
async function sl(t, e, n) {
  const r = new _t(
    nr(t, e),
    n
  );
  try {
    await r.purgeAll();
  } finally {
    await r.close();
  }
}
async function al(t, e) {
  const n = `${Rt}${t}:`;
  await rr((r) => r.startsWith(n), e);
}
async function ol(t) {
  await rr((e) => e.startsWith(Rt), t);
}
function ct(t, e) {
  if (t === "personal") throw new Error(`${rn}; personal sharing is unavailable`);
  if (e) throw new Error(`${rn}; local drafts are unavailable`);
}
function dt(t, e) {
  const { envelope: n, payload: r } = t;
  if (!r || n.encryptedPayload === null) return null;
  const i = new Date(n.updatedAt).toISOString(), s = {
    ...r.fields,
    labels: ba(r.labels)
  }, a = {
    id: r.itemId,
    primaryType: r.primaryType,
    typeTags: [r.primaryType],
    issueNumber: r.issueNumber ?? n.issueNumber,
    issueKey: r.issueKey ?? n.issueKey,
    source: "native",
    archived: r.archived,
    syncStatus: n.syncId > 0 ? "synced" : "pending",
    content: void 0,
    system: {
      workspace: e,
      createdAt: r.system.createdAt ?? i,
      updatedAt: r.system.updatedAt ?? i,
      lastIndexed: i,
      authorIdentity: r.system.authorIdentity ?? null,
      lastModifiedBy: r.system.lastModifiedBy ?? null,
      createdByAgent: r.system.createdByAgent,
      linkedCommitSha: r.system.linkedCommitSha,
      linkedCommits: r.system.linkedCommits,
      linkedPullRequests: r.system.linkedPullRequests,
      documentId: r.system.documentId,
      origin: r.system.origin,
      triagedAt: r.system.triagedAt,
      triagedBy: r.system.triagedBy,
      comments: r.comments,
      activity: r.activity
    },
    fields: s
  }, l = Pr(a);
  return l.labelsMap = r.labels, l.bodyVersion = r.bodyVersion, l;
}
function La(t, e, n) {
  const r = (/* @__PURE__ */ new Date()).toISOString();
  return {
    itemId: t.id,
    primaryType: t.type,
    archived: !1,
    bodyVersion: n ? 1 : 0,
    fields: {
      ...t.customFields ?? {},
      title: t.title,
      status: t.status,
      priority: t.priority,
      ...t.owner === void 0 ? {} : { owner: t.owner },
      ...t.tags === void 0 ? {} : { tags: t.tags }
    },
    labels: {},
    comments: [],
    system: {
      authorIdentity: e,
      lastModifiedBy: e,
      createdAt: r,
      updatedAt: r
    }
  };
}
function sn(t, e, n) {
  const r = { ...t.fields, ...e };
  let i = t.labels;
  if ("labels" in e) {
    const c = e.labels;
    i = va(t.labels, Array.isArray(c) ? c.filter((d) => typeof d == "string") : []), delete r.labels;
  }
  const s = typeof e.type == "string" ? e.type : typeof e.primaryType == "string" ? e.primaryType : t.primaryType, a = typeof e.archived == "boolean" ? e.archived : t.archived, l = typeof e.bodyVersion == "number" ? e.bodyVersion : t.bodyVersion;
  for (const c of ["type", "primaryType", "archived", "bodyVersion"]) delete r[c];
  return {
    ...t,
    primaryType: s,
    archived: a,
    bodyVersion: l,
    fields: r,
    labels: i,
    system: {
      ...t.system,
      lastModifiedBy: n,
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    }
  };
}
class ll {
  constructor(e) {
    this.options = e, this.persistence = e.persistence ?? new _t(
      e.databaseName ?? nr(e.orgId, e.teamProjectId),
      e.indexedDbFactory
    ), this.syncState = {
      workspacePath: e.workspacePath,
      status: "disconnected",
      projectId: e.teamProjectId,
      access: null
    };
    const n = {
      serverUrl: e.serverUrl,
      orgId: e.orgId,
      teamProjectId: e.teamProjectId,
      teamMemberId: e.teamMemberId,
      persistence: this.persistence,
      getJwt: async () => {
        try {
          return await e.getTeamJwt();
        } catch (r) {
          const i = e.classifyAuthFailure?.(r) ?? null;
          throw i && this.engine.terminateAccess(i), r;
        }
      },
      authorizeConnection: e.authorizeRoom ?? ((r) => this.authorizeRoom(r)),
      onAuthorized: () => {
        this.authorized = !0, this.emitAuthorizedProjection();
      },
      presenceIdentity: e.presenceIdentity,
      schemaSync: e.schemaSync,
      navigationSync: e.navigationSync,
      initializeIssueKeyPrefix: e.initializeIssueKeyPrefix,
      ...e.createWebSocket ? { createWebSocket: e.createWebSocket } : {},
      savedViewSync: {
        getMaxSyncId: () => this.persistence.getMaxSavedViewSyncId(),
        listUnsynced: async () => (await this.persistence.listSavedViews()).filter((r) => r.unsynced && this.savedViewBelongsToCurrentMember(r.owner)).map((r) => ({ viewId: r.viewId, payload: r.payload, deleted: r.deleted })),
        applyRemote: async ({ viewId: r, payload: i, syncId: s }) => {
          await this.persistence.applyRemoteSavedView(r, i, s), await this.emitSavedViews();
        },
        markRejected: async (r, i) => {
          await this.persistence.markSavedViewRejected(r, i), await this.emitSavedViews();
        }
      },
      onStatusChange: (r) => {
        this.setSyncState({ status: r, access: this.engine.getAccessTermination() });
      },
      // `setStatus` is edge-triggered, so a refusal arriving while the status
      // is already `error` emits nothing. This is what guarantees the surface
      // hears about it exactly once.
      onAccessTerminated: (r) => {
        this.handleAccessTerminated(r);
      },
      onPresenceChange: (r) => {
        this.emit({ type: "presence", members: [...r] });
      },
      onItemApplied: (r) => {
        this.emitAppliedItem(r.itemId, r.isTombstone);
      },
      onConfigChange: (r) => {
        this.emit({
          type: "config-changed",
          workspacePath: e.workspacePath,
          config: { issueKeyPrefix: r.issueKeyPrefix }
        });
      },
      onRejection: (r) => {
        this.emit({
          type: "mutation-rejected",
          rejection: {
            workspacePath: e.workspacePath,
            itemId: r.itemId,
            clientMutationId: r.clientMutationId,
            code: r.rejection.code,
            message: r.rejection.message
          }
        }), this.emitAppliedItem(r.itemId, !1);
      },
      onBootstrapError: (r) => e.reportError?.(r, "tracker bootstrap"),
      onServerError: (r) => e.reportError?.(r, "tracker server")
    };
    this.engine = new Ca(n), this.engine.connect().catch((r) => e.reportError?.(r, "tracker connect"));
  }
  options;
  persistence;
  engine;
  listeners = /* @__PURE__ */ new Set();
  syncState;
  /** Cached projections stay sealed until the current member passes the room gate. */
  authorized = !1;
  disposed = !1;
  get transactionOwner() {
    return {
      orgId: this.options.orgId,
      teamProjectId: this.options.teamProjectId,
      teamMemberId: this.options.teamMemberId
    };
  }
  async snapshot() {
    if (this.assertActive(), !this.authorized)
      return { items: [], savedViews: [], presence: [], sync: this.syncState };
    const [e, n] = await Promise.all([this.readItems(), this.readSavedViews()]);
    return this.authorized ? { items: e, savedViews: n, presence: this.engine.getPresence(), sync: this.syncState } : { items: [], savedViews: [], presence: [], sync: this.syncState };
  }
  subscribe(e) {
    return this.assertActive(), this.listeners.add(e), () => this.listeners.delete(e);
  }
  status() {
    return this.syncState;
  }
  /** Push the schema lane now; before bootstrap finishes, the bootstrap pushes it. */
  flushSchemas() {
    return this.engine.flushSchemas();
  }
  /**
   * Not available in the browser yet, and it throws rather than approximating.
   *
   * The IndexedDB persistence keeps only current rows: N6 left browser-side
   * revisions out on purpose, because the room owns `serverRevision` and the
   * browser's half of that lands with the collab server's revision read (C2).
   * Answering with the live item instead would silently show newer evidence
   * under a pinned citation, which is the one failure contract 4.2 exists to
   * prevent.
   */
  async getItemRevision(e, n) {
    throw new Us("The web console");
  }
  async command(e) {
    switch (this.assertActive(), e.type !== "list-items" && e.type !== "refresh-items" && e.type !== "reconnect" && this.assertAuthorized(), e.type) {
      case "list-items":
      case "refresh-items":
        return { ok: !0, items: await this.readItems() };
      case "create-item":
        if (ct(e.item.sharing, e.item.draftByDefault), e.item.content !== void 0)
          throw new Error("Tracker body content must be written through its collaborative document room");
        {
          const n = e.item.description?.trim() ? e.item.description : null;
          if (n !== null) {
            const r = this.options.seedTrackerBody;
            if (!r)
              throw new Error("This host cannot write item bodies (no seedTrackerBody). The item was not created.");
            await r(await this.openTrackerBodyRoom(qs(e.item.id)), n);
          }
          return {
            ok: !0,
            result: await this.upsert(La(e.item, this.options.currentUser, n !== null))
          };
        }
      case "update-item":
        return { ok: !0, result: await this.updateOne(e.input) };
      case "update-items":
        return { ok: !0, result: await this.updateMany(e.input) };
      case "archive-item":
        return {
          ok: !0,
          result: await this.updateExisting(
            e.itemId,
            (n) => ({ ...n, archived: e.archive })
          )
        };
      case "delete-item": {
        const n = await this.engine.deleteItem(e.itemId, { persistedEnqueue: !0 });
        return this.emit({ type: "items-removed", itemIds: [e.itemId] }), { ok: !0, result: n };
      }
      case "update-item-content":
        throw new Error("Tracker body content must be written through its collaborative document room");
      case "add-comment":
        return {
          ok: !0,
          result: await this.updateExisting(e.itemId, (n) => ({
            ...n,
            comments: [...n.comments, {
              id: crypto.randomUUID(),
              authorIdentity: this.options.currentUser,
              body: e.body,
              createdAt: Date.now()
            }]
          }))
        };
      case "update-comment":
        return {
          ok: !0,
          result: await this.updateExisting(e.itemId, (n) => ({
            ...n,
            comments: n.comments.map((r) => r.id === e.commentId ? {
              ...r,
              ...e.body === void 0 ? {} : { body: e.body },
              ...e.deleted === void 0 ? {} : { deleted: e.deleted || void 0 },
              updatedAt: Date.now()
            } : r)
          }))
        };
      case "share-saved-view":
        return await this.persistence.putLocalSavedView(
          e.savedView.viewId,
          e.savedView.payload,
          this.transactionOwner
        ), await this.emitSavedViews(), await this.engine.flushSavedViews(), { ok: !0, savedViews: await this.readSavedViews() };
      case "unshare-saved-view":
        return await this.persistence.putLocalSavedView(e.viewId, null, this.transactionOwner), await this.emitSavedViews(), await this.engine.flushSavedViews(), { ok: !0, savedViews: await this.readSavedViews() };
      case "reconnect": {
        const n = this.engine.getAccessTermination();
        if (n) throw new Error(`Tracker room access ended: ${n.message}`);
        return this.engine.disconnect(), await this.engine.connect(), { ok: !0 };
      }
    }
  }
  dispose() {
    this.disposed || (this.disposed = !0, this.engine.destroy(), this.listeners.clear(), this.persistence.close());
  }
  async updateOne(e) {
    return ct(e.sharing, e.draftByDefault), this.updateExisting(e.itemId, (n) => sn(
      n,
      e.updates,
      this.options.currentUser
    ));
  }
  async updateMany(e) {
    for (const l of e.entries)
      if (ct(l.sharing, l.draftByDefault), l.fileUpdates && Object.keys(l.fileUpdates).length > 0)
        throw new Error("Browser trackers cannot apply filesystem-backed updates");
    const n = e.entries.filter((l) => l.storeUpdates);
    if (n.length === 0) return { clientMutationIds: [] };
    const r = await this.persistence.getItems(n.map((l) => l.itemId)), i = r.map((l, c) => {
      if (!l?.payload || l.envelope.encryptedPayload === null)
        throw new Error(`Tracker item not found: ${n[c].itemId}`);
      return sn(
        l.payload,
        n[c].storeUpdates ?? {},
        this.options.currentUser
      );
    }), s = await this.engine.upsertItems(i), a = i.map((l, c) => dt({
      envelope: r[c].envelope,
      payload: l
    }, this.options.workspacePath)).filter((l) => l !== null);
    return this.emit({ type: "items-upserted", items: a }), s;
  }
  async updateExisting(e, n) {
    const r = await this.persistence.getItem(e);
    if (!r?.payload || r.envelope.encryptedPayload === null)
      throw new Error(`Tracker item not found: ${e}`);
    const i = n(r.payload);
    return i.system = {
      ...i.system,
      lastModifiedBy: this.options.currentUser,
      updatedAt: (/* @__PURE__ */ new Date()).toISOString()
    }, this.upsert(i);
  }
  async openTrackerBodyRoom(e) {
    if (this.options.openTrackerBodyRoom) return this.options.openTrackerBodyRoom(e);
    const { DocumentSyncProvider: n } = await import("./DocumentSync-DbLa9QKF.js");
    return new n({
      serverUrl: this.options.serverUrl,
      orgId: this.options.orgId,
      documentId: e,
      teamMemberId: this.options.teamMemberId,
      getJwt: () => this.options.getTeamJwt(),
      ...this.options.createWebSocket ? { createWebSocket: this.options.createWebSocket } : {}
    });
  }
  async upsert(e) {
    const n = await this.engine.upsertItem(e, { persistedEnqueue: !0 });
    return await this.emitAppliedItem(e.itemId, !1), n;
  }
  async readItems() {
    if (!this.authorized) return [];
    const e = await this.persistence.listItems();
    return this.authorized ? e.map((n) => dt(n, this.options.workspacePath)).filter((n) => n !== null) : [];
  }
  async readSavedViews() {
    if (!this.authorized) return [];
    const e = await this.persistence.listSavedViews();
    return this.authorized ? e.filter((n) => !n.deleted && n.payload !== null && (!n.unsynced || this.savedViewBelongsToCurrentMember(n.owner))).map((n) => ({ viewId: n.viewId, payload: n.payload })) : [];
  }
  async emitAppliedItem(e, n) {
    if (this.disposed || !this.authorized) return;
    if (n) {
      this.emit({ type: "items-removed", itemIds: [e] });
      return;
    }
    const r = await this.persistence.getItem(e);
    if (this.disposed || !this.authorized) return;
    const i = r ? dt(r, this.options.workspacePath) : null;
    i ? this.emit({ type: "items-upserted", items: [i] }) : this.emit({ type: "items-removed", itemIds: [e] });
  }
  async emitSavedViews() {
    this.disposed || this.emit({ type: "saved-views-replaced", savedViews: await this.readSavedViews() });
  }
  /**
   * A plain GET reaches the exact worker authorization gate used by the
   * WebSocket upgrade. Authorized requests continue to TrackerRoom and answer
   * 400 "Expected WebSocket"; 401/403 are returned before a socket exists.
   */
  async authorizeRoom(e) {
    const n = tr(this.options.orgId, this.options.teamProjectId), r = new URL(`${this.options.serverUrl}/sync/${n}`);
    r.protocol === "wss:" ? r.protocol = "https:" : r.protocol === "ws:" && (r.protocol = "http:"), r.searchParams.set("token", e);
    const i = await fetch(r);
    if (i.status === 400) return null;
    const s = await i.text();
    if (i.status === 401)
      return {
        reason: "signed-out",
        message: s || "Your team session is no longer authorized."
      };
    if (i.status === 403)
      return {
        reason: "tracker-access-revoked",
        message: s || "Your access to this tracker was revoked."
      };
    throw new Error(`Tracker authorization probe failed with HTTP ${i.status}`);
  }
  async emitAuthorizedProjection() {
    if (this.disposed || !this.authorized) return;
    const [e, n] = await Promise.all([this.readItems(), this.readSavedViews()]);
    this.disposed || !this.authorized || (this.emit({ type: "items-replaced", items: e }), this.emit({ type: "saved-views-replaced", savedViews: n }));
  }
  async handleAccessTerminated(e) {
    this.authorized = !1, this.setSyncState({ status: "error", access: e }), this.emit({ type: "items-replaced", items: [] }), this.emit({ type: "saved-views-replaced", savedViews: [] });
    try {
      await this.persistence.purgeAll();
    } catch (n) {
      this.options.reportError?.(n, "tracker access purge");
    }
  }
  setSyncState(e) {
    const n = { ...this.syncState, ...e };
    n.status === this.syncState.status && n.access === this.syncState.access || (this.syncState = n, this.emit({ type: "status", sync: this.syncState }));
  }
  emit(e) {
    if (!this.disposed)
      for (const n of this.listeners) n(e);
  }
  assertActive() {
    if (this.disposed) throw new Error("Tracker data source has been disposed");
  }
  assertAuthorized() {
    if (!this.authorized) throw new Error("Tracker room authorization has not completed");
  }
  savedViewBelongsToCurrentMember(e) {
    return e?.orgId === this.options.orgId && e.teamProjectId === this.options.teamProjectId && e.teamMemberId === this.options.teamMemberId;
  }
}
const Pa = {
  trackerTypes: [],
  navigationEntries: [],
  predicates: [],
  labels: yt()
};
function Je(t) {
  return t.sharing === "personal";
}
function Da(t, e, n) {
  const r = vt(t, e);
  if (!r) return null;
  if (r.kind === "model") return Fn(r.model, "team");
  if (r.kind === "predicates" || r.kind === "labels") return null;
  const i = n(t);
  if (!i) return null;
  try {
    return xi(i, r.patch);
  } catch {
    return null;
  }
}
function _a(t, e) {
  const n = e?.code ?? "unknown";
  return n === "schemaExists" ? `Someone else just created a type named "${t}". Pick another name.` : n === "rotationLocked" ? "The team's server is not accepting changes to this project right now (rotationLocked). The type was not created." : n === "createOnlyUnsupported" || Ce(n) ? e?.message || `The team room refused the new type (${n}).` : `The team's server couldn't take the new type right now (${n}). Try again.`;
}
class cl {
  builtins = /* @__PURE__ */ new Map();
  models = /* @__PURE__ */ new Map();
  navigation = /* @__PURE__ */ new Map();
  predicates = [];
  labels = yt();
  listeners = /* @__PURE__ */ new Set();
  state = Pa;
  disposed = !1;
  /** New team types waiting on the room, by type id. */
  pendingDefinitions = /* @__PURE__ */ new Map();
  reportError;
  constructor(e) {
    this.reportError = e.reportError;
    for (const n of e.builtins)
      this.builtins.set(n.type, n), !Je(n) && (this.models.set(n.type, n), ue.register(n, !0));
    this.state = this.project();
  }
  /**
   * Schemas bootstrap from zero on every connect by design, so this lane needs
   * no cursor -- see the note on `TrackerSchemaSyncHooks`.
   */
  schemaSync = {
    listUnsynced: async () => [...this.pendingDefinitions.entries()].map(([e, n]) => ({ type: e, model: n.payload, deleted: !1, createOnly: "required" })),
    // A new type settles only on the answer to its own mutation. A delta for the
    // same id from another client is that client's type, not this creation's
    // success; the room refuses this one with `schemaExists` instead.
    onSettled: ({ type: e, model: n, accepted: r, error: i }) => {
      const s = this.pendingDefinitions.get(e);
      if (!(!s || s.payload !== n)) {
        if (r) {
          this.pendingDefinitions.delete(e), queueMicrotask(s.resolve);
          return;
        }
        this.pendingDefinitions.delete(e), s.reject(new Error(_a(e, i)));
      }
    },
    applyRemote: async ({ type: e, model: n }) => {
      if (!this.disposed) {
        if (e === qn) {
          const r = n === null ? null : vt(e, n);
          if (n !== null && r?.kind !== "predicates") {
            this.reportError?.(new Error("Unreadable predicate registry"), "tracker schema");
            return;
          }
          this.predicates = r?.kind === "predicates" ? r.predicates : [], ue.setPredicates(this.predicates), this.emit();
          return;
        }
        if (e === Un) {
          const r = n === null ? null : vt(e, n);
          if (n !== null && r?.kind !== "labels") {
            this.reportError?.(new Error("Unreadable label registry"), "tracker schema");
            return;
          }
          this.labels = r?.kind === "labels" ? r.registry : yt(), ue.setLabels(this.labels), this.emit();
          return;
        }
        if (n === null) {
          this.models.delete(e);
          const r = this.builtins.get(e);
          r && !Je(r) ? this.models.set(e, r) : ue.clearWorkspaceSchema(e);
        } else {
          const r = Da(e, n, (i) => this.builtins.get(i));
          if (!r) {
            this.reportError?.(new Error(`Unresolvable tracker schema for '${e}'`), "tracker schema");
            return;
          }
          Je(r) ? (this.models.delete(e), ue.clearWorkspaceSchema(e)) : (this.models.set(e, r), ue.register(r));
        }
        this.emit();
      }
    }
  };
  /**
   * A zero cursor every connect, on purpose: the whole tree is a handful of
   * rows, and holding it in memory means a tab never renders a folder layout
   * the room has since changed.
   */
  navigationSync = {
    getMaxSyncId: async () => 0,
    listUnsynced: async () => [],
    applyRemote: async ({ entryId: e, payload: n }) => {
      if (this.disposed) return;
      if (n === null) {
        this.navigation.delete(e), this.emit();
        return;
      }
      let r;
      try {
        r = JSON.parse(n);
      } catch {
        this.reportError?.(new Error(`Malformed navigation entry '${e}'`), "tracker navigation");
        return;
      }
      if (!na(r)) {
        this.reportError?.(new Error(`Unrecognized navigation entry '${e}'`), "tracker navigation");
        return;
      }
      this.navigation.set(r.entryId, r), this.emit();
    }
  };
  getState() {
    return this.state;
  }
  /**
   * Queue a brand-new team type for the room as a create-only mutation.
   * Resolves on the room's acceptance of this mutation, rejects on its refusal
   * (including `schemaExists` when another client created the id first, and a
   * room too old to refuse an existing type). The caller flushes the schema lane.
   *
   * Creation never replaces: an id this room already defines (or a builtin)
   * is refused here, before anything is sent.
   */
  defineTeamType(e) {
    if (this.disposed) return Promise.reject(new Error("The tracker room is closed."));
    if (e.sharing === "personal")
      return Promise.reject(new Error("The team section holds only team types."));
    const n = e.type;
    if (this.models.has(n) || this.builtins.has(n) || this.pendingDefinitions.has(n))
      return Promise.reject(new Error(`A type named "${n}" already exists.`));
    const { model: r, errors: i } = Ur(e, (a) => this.models.get(a));
    if (!r) return Promise.reject(new Error(i[0]?.message ?? `Type '${n}' could not be resolved.`));
    const s = Ai(
      Fn(r, "team"),
      Yr(e) ? e : null
    );
    return new Promise((a, l) => {
      this.pendingDefinitions.set(n, { payload: s, resolve: a, reject: l });
    });
  }
  subscribe(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
  dispose() {
    if (!this.disposed) {
      this.disposed = !0, this.listeners.clear();
      for (const e of this.pendingDefinitions.values())
        e.reject(new Error("The tracker room closed before the new type was saved."));
      this.pendingDefinitions.clear(), ue.clearWorkspaceSchemas();
    }
  }
  project() {
    return {
      trackerTypes: [...this.models.values()].sort((e, n) => e.type.localeCompare(n.type)),
      navigationEntries: [...this.navigation.values()].sort(Ze),
      predicates: this.predicates,
      labels: this.labels
    };
  }
  emit() {
    if (!this.disposed) {
      this.state = this.project();
      for (const e of this.listeners) e(this.state);
    }
  }
}
function dl(t, e, n) {
  const r = e && n?.syncStatus !== "local" ? { orgId: e.orgId, projectId: e.teamProjectId } : "local";
  return Fr({ kind: "item", scope: r, itemRef: t });
}
function ul({ clauses: t }) {
  return t.length === 0 ? null : /* @__PURE__ */ m(
    "div",
    {
      className: "tracker-personal-clause-notice flex items-center gap-2 px-3 py-1.5 border-b border-nim bg-nim-secondary text-[11px] text-nim-muted",
      "data-testid": "tracker-personal-clause-notice",
      role: "status",
      children: [
        /* @__PURE__ */ o(R, { icon: "info", size: 13, className: "shrink-0 text-nim-faint" }),
        /* @__PURE__ */ o("span", { className: "min-w-0", children: Dr(t) })
      ]
    }
  );
}
const Ra = {
  recoveryConflict: "An older queued edit needs review against the recovered item.",
  forbidden: "Your permission no longer allows this change.",
  staleKeyEpoch: "The tracker encryption state changed before the server could accept this change.",
  rotationLocked: "The tracker is temporarily locked while its encryption state changes.",
  custodyUnavailable: "The team encryption service is unavailable for this tracker.",
  malformed: "The server could not accept the submitted tracker data.",
  legacy_encryption_retired: "This team must be migrated before tracker changes can be accepted.",
  issueKeyPrefixConflict: "The tracker key prefix conflicts with another project in this team.",
  adminRequired: "This change requires a team administrator.",
  schemaExists: "Someone else already created a type with this name.",
  serverError: "The server hit an error and saved nothing. Try the change again."
};
function ir(t) {
  const e = Ra[t.code] ?? "The server refused this change.", n = t.message?.trim();
  return `${t.code === "recoveryConflict" ? "Queued edit retained for review." : "Change rolled back."} ${e}${n ? ` ${n}` : ""}`;
}
function pl({ rejection: t }) {
  return t ? /* @__PURE__ */ m(
    "div",
    {
      className: "tracker-mutation-rejection flex items-start gap-2 border-b border-nim-error bg-[color-mix(in_srgb,var(--nim-error)_10%,transparent)] px-3 py-2 text-xs text-nim-error",
      "data-rejection-code": t.code,
      "data-item-id": t.itemId,
      role: "alert",
      children: [
        /* @__PURE__ */ o("strong", { className: "shrink-0", children: "Server rejected the change." }),
        /* @__PURE__ */ o("span", { children: ir(t) })
      ]
    }
  ) : null;
}
const $a = [
  "user",
  "select",
  "multiselect",
  "array",
  "relationship",
  "reference",
  // Citation entries are item references like relationship values, so their
  // filter options come from the rows too.
  "citation"
], Ma = 100;
function ml(t, e, n) {
  return t.map((r) => {
    if (!$a.includes(r.type ?? "")) return r;
    const i = /* @__PURE__ */ new Map();
    for (const l of r.options ?? [])
      i.set(l.value, {
        label: l.label,
        count: 0,
        color: l.color,
        icon: l.icon
      });
    const s = (l) => {
      if (l == null || l === "") return;
      if (Array.isArray(l)) {
        l.forEach(s);
        return;
      }
      if (typeof l == "object") {
        const u = l, g = u.itemId ?? u.issueKey ?? u.url ?? u.email ?? u.gitEmail ?? u.gitName ?? u.displayName ?? u.title, p = u.title ?? u.name ?? u.displayName ?? u.email ?? u.gitEmail ?? u.gitName ?? u.issueKey ?? g;
        if (g === void 0) return;
        const f = String(g), h = i.get(f);
        i.set(f, {
          label: h?.label ?? String(p),
          count: (h?.count ?? 0) + 1,
          color: h?.color,
          icon: h?.icon
        });
        return;
      }
      const c = String(l), d = i.get(c);
      i.set(c, {
        label: d?.label ?? c,
        count: (d?.count ?? 0) + 1,
        color: d?.color,
        icon: d?.icon
      });
    };
    for (const l of e) s(n(l, r.id));
    const a = Array.from(i, ([l, c]) => ({ value: l, ...c }));
    return r.options?.length || a.sort((l, c) => l.label.localeCompare(c.label)), { ...r, options: a.slice(0, Ma) };
  });
}
const je = () => import("./TrackerFilterOmniboxMenu-Bi0J5gVZ.js"), Oa = ye(
  () => je().then((t) => ({
    default: t.TrackerFilterOmniboxMenu
  }))
), It = "nimbalyst:tracker-focus-search";
function fl() {
  window.dispatchEvent(new CustomEvent(It));
}
function Fa(t, e) {
  const n = e.find((i) => i.id === t.field), r = (Array.isArray(t.value) ? t.value : [t.value]).filter((i) => i != null && i !== "").map((i) => {
    const s = String(i);
    return n?.options?.find((a) => a.value === s)?.label ?? s;
  });
  return {
    field: n?.label ?? t.field,
    op: xe[t.op],
    value: Se.has(t.op) ? "" : t.op === "in-last" || t.op === "not-in-last" ? `${r.join(", ")} days` : r.join(", ")
  };
}
function hl({
  searchQuery: t,
  onSearchQueryChange: e,
  fields: n,
  filters: r,
  onFiltersChange: i,
  tagOptions: s,
  tagFilter: a,
  onTagFilterChange: l,
  showPills: c = !0,
  inlinePills: d = !1,
  onPillClick: u,
  trailing: g,
  className: p = "",
  placeholder: f = "Search, # for tags, or a field name to filter…",
  size: h = "default"
}) {
  const b = h === "large", [w, L] = O(""), [N, E] = O(!1), [A, j] = O(null), T = ce(null), $ = ce(null), F = Z((I) => {
    T.current = I;
  }, []), z = t + w, k = Q(
    () => kt(z, n),
    [z, n]
  ), D = Q(
    () => N ? ta(k.draft, n, { tagOptions: s }) : [],
    [N, k.draft, n, s]
  ), _ = a ?? [], U = Q(
    () => (r?.clauses ?? []).map((I, q) => ({ clause: I, index: q })).filter(({ clause: I }) => Te(I)),
    [r]
  );
  Br(() => {
    j((I) => I === null || D.length === 0 ? null : Math.min(I, D.length - 1));
  }, [D.length]), pe(() => {
    const I = () => {
      const q = T.current;
      q && (q.focus(), q.select());
    };
    return window.addEventListener(It, I), () => window.removeEventListener(It, I);
  }, []);
  const ee = Z(
    (I, q) => {
      const v = kt(I, n), S = v.draft.stage !== "field";
      L(S ? v.draft.raw : ""), e(S ? v.searchText : I), E(!0), j(q && S ? 0 : null);
    },
    [n, e]
  ), X = z.slice(0, k.tokenStart), oe = Z(
    (I) => {
      i(vr(r, I.field, [I])), e(X), L(""), E(!1), j(null), T.current?.focus();
    },
    [r, i, e, X]
  ), P = Z(
    (I) => {
      _.includes(I) || l?.([..._, I]), e(X), L(""), E(!1), j(null), T.current?.focus();
    },
    [_, e, l, X]
  ), K = Z(
    (I) => {
      l?.(_.filter((q) => q !== I));
    },
    [_, l]
  ), J = Z(
    (I) => {
      if (I.tag) {
        P(I.tag);
        return;
      }
      if (I.clause) {
        oe(I.clause);
        return;
      }
      I.insertText !== void 0 && (e(X), L(I.insertText), E(!0), j(0), T.current?.focus());
    },
    [P, oe, e, X]
  ), G = Z(
    (I) => {
      i({
        combinator: r?.combinator ?? "and",
        clauses: (r?.clauses ?? []).filter(
          (q, v) => v !== I
        )
      });
    },
    [r, i]
  ), B = Z(
    (I, q) => {
      G(q), L(Zt(I, n)), E(!0), j(0), T.current?.focus();
    },
    [n, G]
  ), se = Z(() => {
    L(""), e(""), i({ combinator: r?.combinator ?? "and", clauses: [] }), _.length > 0 && l?.([]), E(!1), j(null);
  }, [
    _.length,
    r?.combinator,
    i,
    e,
    l
  ]), x = Z(
    (I) => {
      if (I.key === "ArrowDown") {
        D.length === 0 && !N && E(!0), I.preventDefault(), j(
          (q) => q === null ? 0 : Math.min(q + 1, Math.max(D.length - 1, 0))
        );
        return;
      }
      if (I.key === "ArrowUp") {
        if (A === null) return;
        I.preventDefault(), j(
          (q) => q === null || q === 0 ? null : q - 1
        );
        return;
      }
      if (I.key === "Tab") {
        const q = D[A ?? 0];
        if (!q) return;
        I.preventDefault(), J(q);
        return;
      }
      if (I.key === "Enter") {
        const q = A === null ? null : D[A];
        if (q) {
          I.preventDefault(), J(q);
          return;
        }
        const v = Dt(k.draft);
        v && (I.preventDefault(), oe(v));
        return;
      }
      if (I.key === "Escape") {
        if (N) {
          I.preventDefault(), I.stopPropagation(), E(!1), j(null);
          return;
        }
        w && (I.preventDefault(), I.stopPropagation(), L(""));
        return;
      }
      if (I.key === "Backspace" && z === "") {
        if (_.length > 0) {
          I.preventDefault(), K(_[_.length - 1]);
          return;
        }
        U.length > 0 && (I.preventDefault(), G(U[U.length - 1].index));
      }
    },
    [
      U,
      _,
      J,
      oe,
      w,
      A,
      z,
      N,
      k.draft,
      G,
      K,
      D
    ]
  ), V = z.length > 0 || U.length > 0 || _.length > 0, le = U.length > 0 || _.length > 0, me = b && d ? "h-6 text-[12px]" : "h-5 text-[10px]", te = b && d ? 12 : 10, ge = /* @__PURE__ */ m(Le, { children: [
    _.map((I) => /* @__PURE__ */ m(
      "button",
      {
        type: "button",
        className: `tracker-filter-omnibox-tag-chip flex ${me} shrink-0 items-center gap-1 rounded-full border border-blue-400/30 bg-blue-400/[0.12] px-1.5 text-blue-400 hover:bg-blue-400/[0.18]`,
        onClick: () => K(I),
        title: `Remove #${I} filter`,
        "data-testid": `tracker-filter-omnibox-tag-chip-${I}`,
        children: [
          "#",
          I,
          /* @__PURE__ */ o(R, { icon: "close", size: te })
        ]
      },
      `tag-${I}`
    )),
    U.map(({ clause: I, index: q }) => {
      const v = Fa(I, n);
      return /* @__PURE__ */ m(
        "div",
        {
          className: `tracker-filter-omnibox-pill flex ${me} max-w-full items-center overflow-hidden rounded-full border border-nim ${d ? "bg-nim-tertiary" : "bg-nim-secondary"} text-nim-muted`,
          "data-testid": `tracker-filter-omnibox-pill-${q}`,
          children: [
            /* @__PURE__ */ m(
              "button",
              {
                type: "button",
                className: "flex h-full min-w-0 items-center gap-1 px-1.5 hover:bg-nim-tertiary hover:text-nim",
                onClick: () => {
                  (u?.(q, I) === !1 || !u) && B(I, q);
                },
                title: u ? "Edit filters" : `Edit ${Zt(I, n)}`,
                children: [
                  /* @__PURE__ */ o("span", { className: "shrink-0 font-medium text-nim", children: v.field }),
                  /* @__PURE__ */ o("span", { className: "shrink-0 text-nim-faint", children: v.op }),
                  v.value && /* @__PURE__ */ o("span", { className: "truncate", children: v.value })
                ]
              }
            ),
            /* @__PURE__ */ o(
              "button",
              {
                type: "button",
                className: `inline-flex h-full ${b && d ? "w-5" : "w-4"} shrink-0 items-center justify-center border-l border-nim text-nim-faint hover:bg-nim-tertiary hover:text-nim`,
                onClick: () => G(q),
                "aria-label": `Remove ${v.field} filter`,
                children: /* @__PURE__ */ o(R, { icon: "close", size: te })
              }
            )
          ]
        },
        `${I.field}-${q}`
      );
    })
  ] });
  return /* @__PURE__ */ m(
    "div",
    {
      className: `tracker-filter-omnibox flex min-w-0 flex-col gap-1 ${p}`,
      "data-testid": "tracker-filter-omnibox",
      children: [
        d ? /* @__PURE__ */ m(
          "div",
          {
            ref: $,
            className: `tracker-filter-omnibox-box flex min-w-0 cursor-text flex-wrap items-center gap-1 border border-nim bg-nim-secondary focus-within:border-[var(--nim-primary)] ${b ? "min-h-9 rounded-md py-1 pl-3 pr-2" : "min-h-7 rounded py-0.5 pl-2 pr-1"}`,
            onClick: (I) => {
              I.target === I.currentTarget && T.current?.focus();
            },
            children: [
              /* @__PURE__ */ o(R, { icon: "search", size: b ? 18 : 14, className: "mr-1 shrink-0 text-nim-faint pointer-events-none" }),
              ge,
              /* @__PURE__ */ o(
                "input",
                {
                  ref: F,
                  type: "text",
                  role: "combobox",
                  "aria-expanded": N && D.length > 0,
                  "aria-controls": "tracker-filter-omnibox-menu",
                  "aria-label": "Search or filter tracker items",
                  className: `tracker-filter-omnibox-input min-w-[120px] flex-1 border-none bg-transparent p-0 text-nim placeholder:text-nim-faint focus:outline-none ${b ? "h-7 text-[13.5px]" : "text-xs"}`,
                  placeholder: le ? void 0 : f,
                  value: z,
                  onChange: (I) => ee(I.target.value, !0),
                  onPointerEnter: () => {
                    je();
                  },
                  onFocus: () => {
                    je(), E(!0);
                  },
                  onKeyDown: x,
                  "data-testid": "tracker-filter-omnibox-input"
                }
              ),
              g,
              V && /* @__PURE__ */ o(
                "button",
                {
                  type: "button",
                  className: "shrink-0 text-nim-faint hover:text-nim",
                  onClick: se,
                  "aria-label": "Clear search and filters",
                  "data-testid": "tracker-filter-omnibox-clear",
                  children: /* @__PURE__ */ o(R, { icon: "close", size: b ? 16 : 13 })
                }
              )
            ]
          }
        ) : /* @__PURE__ */ m("div", { className: "relative flex-1 min-w-0", children: [
          /* @__PURE__ */ o(
            R,
            {
              icon: "search",
              size: b ? 18 : 14,
              className: `absolute ${b ? "left-3" : "left-2"} top-1/2 -translate-y-1/2 text-nim-faint pointer-events-none`
            }
          ),
          /* @__PURE__ */ o(
            "input",
            {
              ref: F,
              type: "text",
              role: "combobox",
              "aria-expanded": N && D.length > 0,
              "aria-controls": "tracker-filter-omnibox-menu",
              "aria-label": "Search or filter tracker items",
              className: `tracker-filter-omnibox-input w-full border border-nim bg-nim-secondary text-nim placeholder:text-nim-faint focus:border-[var(--nim-primary)] focus:outline-none ${b ? "h-9 rounded-md pl-10 pr-9 text-[13.5px]" : "rounded py-1 pl-7 pr-6 text-xs"}`,
              placeholder: f,
              value: z,
              onChange: (I) => ee(I.target.value, !0),
              onPointerEnter: () => {
                je();
              },
              onFocus: () => {
                je(), E(!0);
              },
              onKeyDown: x,
              "data-testid": "tracker-filter-omnibox-input"
            }
          ),
          V && /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              className: `absolute ${b ? "right-2.5" : "right-1"} top-1/2 -translate-y-1/2 text-nim-faint hover:text-nim`,
              onClick: se,
              "aria-label": "Clear search and filters",
              "data-testid": "tracker-filter-omnibox-clear",
              children: /* @__PURE__ */ o(R, { icon: "close", size: b ? 16 : 13 })
            }
          )
        ] }),
        c && !d && le && /* @__PURE__ */ o(
          "div",
          {
            className: "tracker-filter-omnibox-pills flex flex-wrap items-center gap-1",
            "data-testid": "tracker-filter-omnibox-pills",
            children: ge
          }
        ),
        N && D.length > 0 && T.current && /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(
          Oa,
          {
            reference: d && $.current || T.current,
            suggestions: D,
            highlightIndex: A,
            onHighlight: j,
            onApply: J,
            onClose: () => E(!1)
          }
        ) })
      ]
    }
  );
}
const sr = () => import("./TrackerAdvancedFilterBuilder-aMtezyGA.js"), Ba = ye(
  () => sr().then((t) => ({
    default: t.TrackerAdvancedFilterBuilder
  }))
);
function an() {
  sr();
}
function ja(t) {
  return /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(Ba, { ...t }) });
}
const ar = () => import("./TrackerFilterValueMenu-B1iHpju9.js"), Va = ye(
  () => ar().then((t) => ({
    default: t.TrackerFilterValueMenu
  }))
);
function on() {
  ar();
}
function Ka(t) {
  return /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(Va, { ...t }) });
}
const or = () => import("./DisplayOptionsPanel-C7Q2c9Db.js"), za = ye(
  () => or().then((t) => ({
    default: t.DisplayOptionsPanel
  }))
);
function ln() {
  or();
}
function qa(t) {
  return /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(za, { ...t }) });
}
const lr = () => import("./TagBoard-D-McthWJ.js"), Ua = ye(
  () => lr().then((t) => ({ default: t.TagBoard }))
);
function cn() {
  lr();
}
function yl(t) {
  return /* @__PURE__ */ o(
    he,
    {
      fallback: /* @__PURE__ */ o(Sn, { icon: "sell", message: "Loading tag board…" }),
      children: /* @__PURE__ */ o(Ua, { ...t })
    }
  );
}
const cr = () => import("./TrackerTimelineView-CwYsSQdW.js"), Ya = ye(
  () => cr().then((t) => ({
    default: t.TrackerTimelineView
  }))
);
function dn() {
  cr();
}
function gl(t) {
  return /* @__PURE__ */ o(
    he,
    {
      fallback: /* @__PURE__ */ o(Sn, { icon: "timeline", message: "Loading timeline…" }),
      children: /* @__PURE__ */ o(Ya, { ...t })
    }
  );
}
const Wa = [
  { scope: "open", label: "Open", title: "Work that is still outstanding" },
  { scope: "all", label: "All", title: "Every item, open and closed" },
  {
    scope: "closed",
    label: "Closed",
    title: "Work that was finished or abandoned"
  }
];
function Ha({
  scope: t,
  onScopeChange: e
}) {
  return /* @__PURE__ */ o(
    "div",
    {
      className: "tracker-status-scope inline-flex h-7 overflow-hidden rounded border border-nim",
      role: "group",
      "aria-label": "Status scope",
      "data-testid": "tracker-status-scope",
      children: Wa.map((n) => /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          className: `h-full border-r border-nim px-2.5 text-[11px] font-medium transition-colors last:border-r-0 ${n.scope === t ? "bg-nim-tertiary text-nim" : "bg-nim-secondary text-nim-muted hover:bg-nim-tertiary hover:text-nim"}`,
          "aria-pressed": n.scope === t,
          title: n.title,
          onClick: () => e(n.scope),
          "data-testid": `tracker-status-scope-${n.scope}`,
          children: n.label
        },
        n.scope
      ))
    }
  );
}
function un(t) {
  const e = `${t.id} ${t.label}`.toLowerCase();
  return e.includes("favorite") || e.includes("starred") ? "star" : e.includes("status") ? "progress_activity" : e.includes("priority") ? "signal_cellular_alt" : e.includes("assignee") || e.includes("owner") || t.type === "user" ? "person" : e.includes("tag") || e.includes("label") ? "sell" : e.includes("relation") || t.type === "relationship" || t.type === "reference" ? "account_tree" : e.includes("date") || e.includes("created") || e.includes("updated") ? "calendar_today" : e.includes("type") ? "category" : e.includes("source") || e.includes("module") ? "deployed_code" : t.type === "boolean" ? "toggle_on" : t.type === "number" ? "numbers" : t.type === "array" || t.type === "multiselect" ? "list" : "text_fields";
}
function Ja(t, e, n) {
  if (t === void 0) return "";
  const r = (s) => {
    const a = String(s);
    return n?.options?.find((l) => l.value === a)?.label ?? a;
  }, i = Array.isArray(t) ? t.map(r).join(", ") : r(t);
  return e === "in-last" || e === "not-in-last" ? `${i} days` : i;
}
function Ga({ anchored: t, children: e }) {
  return t ? /* @__PURE__ */ o(Rn, { children: e }) : e;
}
function bl({
  itemCount: t,
  unscopedItemCount: e,
  availableColumns: n,
  columnConfig: r,
  onColumnConfigChange: i,
  showColumnControls: s,
  filterFields: a,
  filters: l,
  onFiltersChange: c,
  openFiltersToken: d = 0,
  filterAnchor: u = null,
  statusScope: g,
  onStatusScopeChange: p,
  viewMode: f,
  groupBy: h,
  ordering: b,
  onLayoutChange: w,
  viewModeOptions: L = wr
}) {
  const [N, E] = O(!1), [A, j] = O(!1), [T, $] = O("fields"), [F, z] = O(""), [k, D] = O(0), [_, U] = O(null), [ee, X] = O(
    null
  ), [oe, P] = O("="), [K, J] = O(""), G = ce(null), B = ce(null), se = ce(null), x = ce(null), { refs: V, floatingStyles: le } = Cn({
    elements: { reference: u },
    placement: "bottom-start",
    open: !!u && N,
    whileElementsMounted: Ln,
    middleware: [Pn(4), Dn({ padding: 8 }), _n({ padding: 8 })]
  }), me = Q(
    () => (l?.clauses ?? []).filter(Te).length,
    [l]
  ), te = Q(
    () => a.find((y) => y.id === _),
    [a, _]
  ), ge = Q(() => {
    const y = F.trim().toLowerCase();
    return y ? a.filter(
      (M) => M.label.toLowerCase().includes(y) || M.id.toLowerCase().includes(y)
    ) : a;
  }, [a, F]), I = () => {
    $("fields"), z(""), D(0), U(null), X(null);
  };
  pe(() => {
    d <= 0 || (I(), j(!1), E(!0));
  }, [d]), pe(() => {
    if (!N) return;
    const y = (M) => {
      const C = M.target;
      !G.current?.contains(C) && !B.current?.contains(C) && !x.current?.contains(C) && !u?.contains(C) && E(!1);
    };
    return document.addEventListener("mousedown", y), () => document.removeEventListener("mousedown", y);
  }, [N, u]);
  const q = (y, M) => {
    U(y.id), X(M ?? null), P(St(y.type)[0]), J(""), $("field");
  }, v = (y = K, M) => {
    if (!te) return;
    const C = M ?? oe;
    let Y;
    if (Se.has(C))
      Y = { field: te.id, op: C };
    else if (C === "in" || C === "not-in") {
      const de = Array.isArray(y) ? y : String(y).split(",").map((ve) => ve.trim()).filter(Boolean);
      Y = { field: te.id, op: C, value: de };
    } else C === "between" ? Y = {
      field: te.id,
      op: C,
      value: Array.isArray(y) ? y : ["", ""]
    } : Y = { field: te.id, op: C, value: y };
    if (!Te(Y)) return;
    const W = (l?.clauses ?? []).filter(Te), ke = Array.isArray(y) && (te.type === "array" || te.type === "multiselect" || te.multiValue === !0);
    c({
      combinator: l?.combinator ?? "and",
      clauses: [
        ...W.filter(
          (de) => !ke || de.field !== te.id
        ),
        Y
      ]
    }), $("fields"), U(null), X(null), J(""), E(!1);
  }, S = (y) => {
    c({
      combinator: l?.combinator ?? "and",
      clauses: (l?.clauses ?? []).filter(
        (M, C) => C !== y
      )
    });
  };
  return /* @__PURE__ */ m(
    "div",
    {
      className: "tracker-view-header-controls flex shrink-0 items-center gap-1.5",
      "data-testid": "tracker-view-header-controls",
      children: [
        /* @__PURE__ */ o(
          "span",
          {
            className: "min-w-8 text-right text-[11px] tabular-nums text-nim-faint",
            "data-testid": "tracker-view-item-count",
            children: e === void 0 ? `${t} item${t === 1 ? "" : "s"}` : g === "all" ? `${t} total` : `${t} ${g} of ${e}`
          }
        ),
        /* @__PURE__ */ o(
          Ha,
          {
            scope: g,
            onScopeChange: p
          }
        ),
        /* @__PURE__ */ m("div", { className: "relative", ref: G, children: [
          !u && /* @__PURE__ */ m(
            "button",
            {
              type: "button",
              className: `inline-flex h-7 items-center gap-1 rounded border px-2 text-[11px] font-medium transition-colors ${N || me > 0 ? "border-nim-focus bg-nim-tertiary text-nim" : "border-nim bg-nim-secondary text-nim-muted hover:bg-nim-tertiary hover:text-nim"}`,
              onClick: () => {
                j(!1), N ? E(!1) : (I(), E(!0));
              },
              "aria-expanded": N,
              "data-testid": "tracker-view-filter-button",
              children: [
                /* @__PURE__ */ o(R, { icon: "filter_list", size: 14 }),
                "Filter",
                me > 0 && /* @__PURE__ */ o("span", { className: "rounded-full bg-[var(--nim-primary)] px-1.5 text-[10px] leading-4 text-white", children: me })
              ]
            }
          ),
          N && /* @__PURE__ */ o(Ga, { anchored: !!u, children: /* @__PURE__ */ m(
            "div",
            {
              ref: (y) => {
                x.current = y, u && V.setFloating(y);
              },
              style: u ? le : void 0,
              className: `${u ? "z-50" : "absolute right-0 top-full z-50 mt-1"} max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border border-nim bg-nim-secondary shadow-xl ${T === "advanced" ? "w-[620px]" : "w-[360px]"}`,
              role: "dialog",
              "aria-label": "Tracker filters",
              "data-testid": "tracker-filter-builder",
              children: [
                T !== "advanced" && /* @__PURE__ */ m(Le, { children: [
                  /* @__PURE__ */ m("div", { className: "relative border-b border-nim p-3", children: [
                    /* @__PURE__ */ o(
                      R,
                      {
                        icon: "search",
                        size: 17,
                        className: "absolute left-4 top-1/2 -translate-y-1/2 text-nim-faint"
                      }
                    ),
                    /* @__PURE__ */ o(
                      "input",
                      {
                        autoFocus: !0,
                        className: "h-9 w-full rounded-md border border-transparent bg-transparent pl-8 pr-10 text-[15px] text-nim outline-none placeholder:text-nim-faint focus:border-nim-focus",
                        placeholder: "Add filter…",
                        value: F,
                        onChange: (y) => {
                          z(y.target.value), D(0);
                        },
                        onKeyDown: (y) => {
                          const M = ge.length + 1;
                          if (y.key === "ArrowDown")
                            y.preventDefault(), D(
                              (C) => Math.min(C + 1, M - 1)
                            );
                          else if (y.key === "ArrowUp")
                            y.preventDefault(), D((C) => Math.max(C - 1, 0));
                          else if (y.key === "Enter") {
                            if (y.preventDefault(), k === 0) $("advanced");
                            else if (ge[k - 1]) {
                              const C = ge[k - 1], Y = G.current?.querySelector(
                                `[data-testid="tracker-filter-field-${C.id}"]`
                              );
                              q(C, Y?.getBoundingClientRect());
                            }
                          } else y.key === "Escape" && E(!1);
                        },
                        "data-testid": "tracker-filter-command-search"
                      }
                    ),
                    /* @__PURE__ */ o("span", { className: "absolute right-4 top-1/2 -translate-y-1/2 rounded border border-nim px-1.5 py-0.5 text-[10px] text-nim-faint", children: "F" })
                  ] }),
                  me > 0 && /* @__PURE__ */ m(
                    "div",
                    {
                      className: "border-b border-nim px-2 py-2",
                      "data-testid": "tracker-filter-active-list",
                      children: [
                        /* @__PURE__ */ o("div", { className: "px-2 pb-1 text-[10px] font-medium uppercase tracking-wider text-nim-faint", children: "Active filters" }),
                        (l?.clauses ?? []).map((y, M) => {
                          if (!Te(y)) return null;
                          const C = a.find(
                            (Y) => Y.id === y.field
                          );
                          return /* @__PURE__ */ m(
                            "div",
                            {
                              className: "flex items-center gap-2 rounded-md px-2 py-1.5 text-[12px] text-nim",
                              children: [
                                /* @__PURE__ */ o(
                                  R,
                                  {
                                    icon: un(
                                      C ?? {
                                        id: y.field,
                                        label: y.field
                                      }
                                    ),
                                    size: 15,
                                    className: "text-nim-faint"
                                  }
                                ),
                                /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 truncate", children: [
                                  C?.label ?? y.field,
                                  " ",
                                  /* @__PURE__ */ o("span", { className: "text-nim-muted", children: xe[y.op] }),
                                  " ",
                                  Ja(y.value, y.op, C)
                                ] }),
                                /* @__PURE__ */ o(
                                  "button",
                                  {
                                    type: "button",
                                    className: "rounded p-0.5 text-nim-faint hover:bg-nim-tertiary hover:text-nim",
                                    onClick: () => S(M),
                                    "aria-label": `Remove ${C?.label ?? y.field} filter`,
                                    children: /* @__PURE__ */ o(R, { icon: "close", size: 13 })
                                  }
                                )
                              ]
                            },
                            `${y.field}-${M}`
                          );
                        })
                      ]
                    }
                  ),
                  /* @__PURE__ */ o("div", { className: "border-b border-nim p-2", children: /* @__PURE__ */ m(
                    "button",
                    {
                      type: "button",
                      className: k === 0 ? "flex w-full items-center gap-3 rounded-md bg-nim-tertiary px-3 py-2 text-left text-[14px] text-nim" : "flex w-full items-center gap-3 rounded-md px-3 py-2 text-left text-[14px] text-nim hover:bg-nim-tertiary",
                      onMouseEnter: () => {
                        an(), D(0), $("fields"), U(null), X(null);
                      },
                      onFocus: an,
                      onClick: () => {
                        $("advanced"), U(null), X(null);
                      },
                      "data-testid": "tracker-filter-advanced",
                      children: [
                        /* @__PURE__ */ o(
                          R,
                          {
                            icon: "filter_alt",
                            size: 19,
                            className: "text-nim-muted"
                          }
                        ),
                        /* @__PURE__ */ o("span", { className: "flex-1", children: "Advanced filter" })
                      ]
                    }
                  ) }),
                  /* @__PURE__ */ m("div", { className: "max-h-[430px] overflow-y-auto p-2", children: [
                    ge.map((y, M) => {
                      const C = M > 0 && (y.group ?? "common") !== (ge[M - 1].group ?? "common"), Y = M + 1;
                      return /* @__PURE__ */ o(
                        "div",
                        {
                          className: C ? "mt-2 border-t border-nim pt-2" : "",
                          children: /* @__PURE__ */ m(
                            "button",
                            {
                              type: "button",
                              className: _ === y.id || k === Y ? "flex w-full items-center gap-3 rounded-md bg-nim-tertiary px-3 py-2 text-left text-[14px] text-nim" : "flex w-full items-center gap-3 rounded-md px-3 py-2 text-left text-[14px] text-nim hover:bg-nim-tertiary",
                              onMouseEnter: (W) => {
                                on(), D(Y), q(
                                  y,
                                  W.currentTarget.getBoundingClientRect()
                                );
                              },
                              onFocus: on,
                              onClick: (W) => q(
                                y,
                                W.currentTarget.getBoundingClientRect()
                              ),
                              "data-testid": `tracker-filter-field-${y.id}`,
                              children: [
                                /* @__PURE__ */ o(
                                  R,
                                  {
                                    icon: un(y),
                                    size: 19,
                                    className: "text-nim-muted"
                                  }
                                ),
                                /* @__PURE__ */ o("span", { className: "min-w-0 flex-1 truncate", children: y.label }),
                                /* @__PURE__ */ o(
                                  R,
                                  {
                                    icon: "chevron_right",
                                    size: 16,
                                    className: "text-nim-faint"
                                  }
                                )
                              ]
                            }
                          )
                        },
                        y.id
                      );
                    }),
                    ge.length === 0 && /* @__PURE__ */ o("div", { className: "px-3 py-8 text-center text-[12px] text-nim-faint", children: "No matching fields" })
                  ] })
                ] }),
                T === "advanced" && /* @__PURE__ */ o(
                  ja,
                  {
                    filterFields: a,
                    filters: l,
                    onFiltersChange: c,
                    onBack: () => $("fields"),
                    onClose: () => E(!1)
                  }
                )
              ]
            }
          ) }),
          N && T === "field" && te && /* @__PURE__ */ o(
            Ka,
            {
              field: te,
              anchorRect: ee,
              placement: u ? "right" : "left",
              selectedValues: new Set(
                at(l, te.id).flatMap(
                  (y) => Array.isArray(y.value) ? y.value.map(String) : y.value === void 0 ? [] : [String(y.value)]
                )
              ),
              onSelect: v,
              onClear: at(l, te.id).length > 0 ? () => {
                c({
                  combinator: l?.combinator ?? "and",
                  clauses: (l?.clauses ?? []).filter(
                    (y) => y.field !== te.id
                  )
                }), $("fields"), U(null), X(null);
              } : void 0,
              onClose: () => {
                $("fields"), U(null), X(null);
              },
              dismissOnOutsideClick: !1,
              menuRef: B
            },
            `${te.id}:${JSON.stringify(
              at(l, te.id).map(
                (y) => y.value
              )
            )}`
          )
        ] }),
        /* @__PURE__ */ m("div", { className: "relative", children: [
          /* @__PURE__ */ m(
            "button",
            {
              ref: se,
              type: "button",
              className: `inline-flex h-7 items-center gap-1 rounded border px-2 text-[11px] font-medium transition-colors ${A ? "border-nim-focus bg-nim-tertiary text-nim" : "border-nim bg-nim-secondary text-nim-muted hover:bg-nim-tertiary hover:text-nim"}`,
              onClick: () => {
                E(!1), j((y) => !y);
              },
              onPointerEnter: () => {
                ln(), cn(), dn();
              },
              onFocus: () => {
                ln(), cn(), dn();
              },
              title: "Display settings — view, grouping, ordering & columns",
              "aria-label": "Display settings",
              "aria-expanded": A,
              "data-testid": "tracker-view-display-options",
              children: [
                /* @__PURE__ */ o(R, { icon: "tune", size: 14 }),
                "Display"
              ]
            }
          ),
          A && /* @__PURE__ */ o(
            qa,
            {
              availableColumns: n,
              config: r,
              onConfigChange: i,
              onClose: () => j(!1),
              anchorElement: se.current,
              viewModes: L,
              viewMode: f,
              onViewModeChange: (y) => w({
                viewMode: xr(y, f)
              }),
              groupBy: h,
              onGroupByChange: (y) => w({ groupBy: y }),
              ordering: b,
              onOrderingChange: (y) => w({ ordering: y }),
              showColumnProperties: s
            }
          )
        ] })
      ]
    }
  );
}
function pn(t) {
  const e = t.toLowerCase();
  return ["done", "completed", "closed"].includes(e) ? "bg-[var(--nim-success)]/15 text-[var(--nim-success)]" : e === "blocked" ? "bg-[var(--nim-error)]/15 text-[var(--nim-error)]" : e === "in-review" || e === "review" ? "bg-[var(--nim-warning)]/15 text-[var(--nim-warning)]" : e === "in-progress" || e === "active" ? "bg-[var(--nim-primary)]/15 text-[var(--nim-primary)]" : "bg-nim-tertiary text-nim-muted";
}
function Tt(t) {
  return t.replace(/[-_]/g, " ");
}
function Qa(t) {
  return t.actor.displayName.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((e) => e[0]?.toUpperCase()).join("") || "A";
}
function ut(t) {
  return t.issueKey ?? t.primaryType;
}
function Ye({ lane: t }) {
  const e = t.isCurrentUser ? "bg-[var(--nim-primary)]/20 text-[var(--nim-primary)]" : t.isAutomation ? "bg-nim-tertiary text-nim-muted" : "bg-[var(--nim-accent)]/20 text-[var(--nim-accent)]";
  return /* @__PURE__ */ o(
    "span",
    {
      className: `flex size-7 shrink-0 items-center justify-center rounded-full text-[10px] font-semibold ${e}`,
      children: t.isAutomation ? /* @__PURE__ */ o(R, { icon: "smart_toy", size: 14 }) : Qa(t)
    }
  );
}
function mn({ from: t, to: e }) {
  const n = t ?? "status", r = e ?? "updated";
  return /* @__PURE__ */ m("span", { className: "inline-flex items-center gap-1.5", children: [
    /* @__PURE__ */ o(
      "span",
      {
        className: `rounded-full px-2 py-0.5 text-[10px] font-medium ${pn(
          n
        )}`,
        children: Tt(n)
      }
    ),
    /* @__PURE__ */ o(
      R,
      {
        icon: "arrow_forward",
        size: 12,
        className: "text-nim-faint"
      }
    ),
    /* @__PURE__ */ o(
      "span",
      {
        className: `rounded-full px-2 py-0.5 text-[10px] font-medium ${pn(
          r
        )}`,
        children: Tt(r)
      }
    )
  ] });
}
function We({
  id: t,
  icon: e,
  title: n,
  count: r,
  actionable: i = !1
}) {
  return /* @__PURE__ */ m(
    "h2",
    {
      id: t,
      className: "mb-2 flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.08em] text-nim-faint",
      children: [
        /* @__PURE__ */ o(R, { icon: e, size: 14 }),
        n,
        /* @__PURE__ */ o(
          "span",
          {
            className: `rounded-full px-2 py-0.5 ${i ? "bg-[var(--nim-warning)]/15 text-[var(--nim-warning)]" : "bg-nim-tertiary text-nim-muted"}`,
            children: r
          }
        )
      ]
    }
  );
}
function Xa({
  radar: t,
  needsYou: e,
  moved: n,
  sweeps: r,
  stalled: i,
  eventByAction: s,
  laneByActorKey: a,
  filterLabel: l,
  selectedItemId: c,
  onClearFilter: d,
  onItemSelect: u,
  onOpenDocument: g
}) {
  const [p, f] = O(null), h = (b) => (g ?? u)?.(b);
  return /* @__PURE__ */ m("main", { className: "mx-auto w-full max-w-5xl px-4 pb-8 pt-2", children: [
    l ? /* @__PURE__ */ m("div", { className: "mt-2 flex items-center gap-2 rounded-md bg-[var(--nim-primary)]/10 px-3 py-2 text-[11px] text-nim-muted", children: [
      "Showing activity for",
      " ",
      /* @__PURE__ */ o("strong", { className: "text-nim", children: l }),
      /* @__PURE__ */ o(
        "button",
        {
          type: "button",
          className: "ml-auto text-[var(--nim-primary)] hover:underline",
          onClick: d,
          children: "Show everyone"
        }
      )
    ] }) : null,
    /* @__PURE__ */ m("section", { className: "mt-5", "aria-labelledby": "radar-needs-you", children: [
      /* @__PURE__ */ o(
        We,
        {
          id: "radar-needs-you",
          icon: "inbox",
          title: "Needs you",
          count: e.length,
          actionable: !0
        }
      ),
      e.length === 0 ? /* @__PURE__ */ o("div", { className: "rounded-lg border border-dashed border-nim px-3 py-4 text-center text-[11px] text-nim-faint", children: "You are caught up. No teammate comments or status changes are waiting on you." }) : /* @__PURE__ */ o("div", { className: "space-y-2", children: e.map((b) => {
        const w = Nn(b.actor), L = a.get(w), N = s.get(
          `${b.itemId}:${w}:${b.at}`
        );
        return /* @__PURE__ */ m(
          "article",
          {
            className: `grid grid-cols-[28px_minmax(0,1fr)_auto] gap-3 rounded-lg border border-l-[3px] border-nim border-l-[var(--nim-warning)] bg-nim-secondary/45 p-3 ${c === b.itemId ? "ring-1 ring-[var(--nim-primary)]" : ""}`,
            children: [
              /* @__PURE__ */ o(Ye, { lane: L }),
              /* @__PURE__ */ m(
                "button",
                {
                  type: "button",
                  className: "min-w-0 text-left",
                  onClick: () => u?.(b.itemId),
                  children: [
                    /* @__PURE__ */ m("span", { className: "text-xs leading-5 text-nim", children: [
                      /* @__PURE__ */ o("strong", { children: b.actor.displayName }),
                      " ",
                      b.reason === "commented" ? "commented on" : "moved",
                      " ",
                      "your",
                      " ",
                      /* @__PURE__ */ o("span", { className: "font-mono text-[10px] text-[var(--nim-primary)]", children: b.issueKey ?? "item" }),
                      " ",
                      /* @__PURE__ */ o("span", { className: "text-nim-muted", children: b.title })
                    ] }),
                    N?.action === "commented" && N.body ? /* @__PURE__ */ o("span", { className: "mt-2 block rounded-r-md border-l-2 border-nim bg-nim px-3 py-2 text-[11px] leading-5 text-nim-muted", children: N.body }) : null,
                    N?.action === "status_changed" ? /* @__PURE__ */ o("span", { className: "mt-2 block", children: /* @__PURE__ */ o(
                      mn,
                      {
                        from: N.oldValue,
                        to: N.newValue
                      }
                    ) }) : null
                  ]
                }
              ),
              /* @__PURE__ */ m("div", { className: "flex flex-col items-end gap-2", children: [
                /* @__PURE__ */ o("span", { className: "text-[10px] text-nim-faint", children: Be(b.at, t.windowEnd) }),
                /* @__PURE__ */ o(
                  "button",
                  {
                    type: "button",
                    className: "rounded border border-nim px-2 py-1 text-[10px] text-nim-muted hover:bg-nim-hover hover:text-nim",
                    onClick: () => h(b.itemId),
                    children: "Open"
                  }
                )
              ] })
            ]
          },
          `${b.itemId}:${b.at}`
        );
      }) })
    ] }),
    n.length > 0 ? /* @__PURE__ */ m("section", { className: "mt-5", "aria-labelledby": "radar-moved", children: [
      /* @__PURE__ */ o(
        We,
        {
          id: "radar-moved",
          icon: "swap_horiz",
          title: "Moved",
          count: n.length
        }
      ),
      /* @__PURE__ */ o("div", { className: "overflow-hidden rounded-lg border border-nim bg-nim-secondary/35", children: n.map(({ event: b, lane: w, item: L }) => /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          className: `grid w-full grid-cols-[28px_minmax(0,1fr)_auto] items-center gap-3 border-b border-nim px-3 py-2.5 text-left last:border-b-0 hover:bg-nim-hover ${c === L.id ? "bg-[var(--nim-primary)]/10" : ""}`,
          onClick: () => u?.(L.id),
          onDoubleClick: () => h(L.id),
          children: [
            /* @__PURE__ */ o(Ye, { lane: w }),
            /* @__PURE__ */ m("span", { className: "min-w-0", children: [
              /* @__PURE__ */ m("span", { className: "flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-nim", children: [
                /* @__PURE__ */ o("span", { className: "font-mono text-[10px] text-[var(--nim-primary)]", children: ut(L) }),
                /* @__PURE__ */ o("span", { className: "truncate text-nim-muted", children: ze(L) }),
                /* @__PURE__ */ o(
                  mn,
                  {
                    from: b.oldValue,
                    to: b.newValue
                  }
                )
              ] }),
              /* @__PURE__ */ m("span", { className: "mt-1 block text-[10px] text-nim-faint", children: [
                w.isCurrentUser ? "You" : w.actor.displayName,
                L.system.createdByAgent ? ", via an agent" : ""
              ] })
            ] }),
            /* @__PURE__ */ o("span", { className: "text-[10px] text-nim-faint", children: Be(b.timestamp, t.windowEnd) })
          ]
        },
        b.id
      )) })
    ] }) : null,
    r.length > 0 ? /* @__PURE__ */ m("section", { className: "mt-5", "aria-labelledby": "radar-sweeps", children: [
      /* @__PURE__ */ o(
        We,
        {
          id: "radar-sweeps",
          icon: "layers",
          title: "Sweeps",
          count: r.length
        }
      ),
      /* @__PURE__ */ o("div", { className: "space-y-2", children: r.map(({ lane: b, mark: w }) => {
        const L = p === w.id, N = w.items.slice(0, 3).map(ut).join(", ");
        return /* @__PURE__ */ m(
          "div",
          {
            className: "overflow-hidden rounded-lg border border-dashed border-nim bg-nim-secondary/25",
            children: [
              /* @__PURE__ */ m(
                "button",
                {
                  type: "button",
                  "aria-expanded": L,
                  className: "grid w-full grid-cols-[28px_minmax(0,1fr)_auto] items-center gap-3 px-3 py-2.5 text-left hover:bg-nim-hover",
                  onClick: () => f(
                    (E) => E === w.id ? null : w.id
                  ),
                  children: [
                    /* @__PURE__ */ o(Ye, { lane: b }),
                    /* @__PURE__ */ m("span", { className: "min-w-0 text-[11px] text-nim", children: [
                      /* @__PURE__ */ o("strong", { children: b.isCurrentUser ? "You" : b.actor.displayName }),
                      " ",
                      w.label.toLowerCase(),
                      " ",
                      /* @__PURE__ */ m("span", { className: "text-nim-faint", children: [
                        "· ",
                        N,
                        w.items.length > 3 ? ` and ${w.items.length - 3} more` : ""
                      ] })
                    ] }),
                    /* @__PURE__ */ m("span", { className: "flex items-center gap-1 text-[10px] text-nim-faint", children: [
                      Be(
                        w.lastActivityAt,
                        t.windowEnd
                      ),
                      /* @__PURE__ */ o(
                        R,
                        {
                          icon: L ? "expand_less" : "expand_more",
                          size: 14
                        }
                      )
                    ] })
                  ]
                }
              ),
              L ? /* @__PURE__ */ o("div", { className: "border-t border-nim bg-nim", children: w.items.map((E) => /* @__PURE__ */ m(
                "button",
                {
                  type: "button",
                  className: "flex w-full items-center gap-2 border-b border-nim px-12 py-2 text-left text-[11px] last:border-b-0 hover:bg-nim-hover",
                  onClick: () => u?.(E.id),
                  onDoubleClick: () => h(E.id),
                  children: [
                    /* @__PURE__ */ o("span", { className: "shrink-0 font-mono text-[10px] text-[var(--nim-primary)]", children: ut(E) }),
                    /* @__PURE__ */ o("span", { className: "truncate text-nim-muted", children: ze(E) })
                  ]
                },
                E.id
              )) }) : null
            ]
          },
          w.id
        );
      }) })
    ] }) : null,
    i.length > 0 ? /* @__PURE__ */ m("section", { className: "mt-5", "aria-labelledby": "radar-stalled", children: [
      /* @__PURE__ */ o(
        We,
        {
          id: "radar-stalled",
          icon: "schedule",
          title: "Stalled",
          count: i.length
        }
      ),
      /* @__PURE__ */ o("div", { className: "overflow-hidden rounded-lg border border-nim bg-nim-secondary/35", children: i.map(({ lane: b, item: w }) => /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          className: `grid w-full grid-cols-[28px_minmax(0,1fr)_auto] items-center gap-3 border-b border-nim px-3 py-2.5 text-left last:border-b-0 hover:bg-nim-hover ${c === w.itemId ? "bg-[var(--nim-primary)]/10" : ""}`,
          onClick: () => u?.(w.itemId),
          onDoubleClick: () => h(w.itemId),
          children: [
            /* @__PURE__ */ o(Ye, { lane: b }),
            /* @__PURE__ */ m("span", { className: "min-w-0 text-[11px] text-nim", children: [
              /* @__PURE__ */ o("span", { className: "font-mono text-[10px] text-[var(--nim-primary)]", children: w.issueKey ?? w.state }),
              " ",
              /* @__PURE__ */ o("span", { className: "text-nim-muted", children: w.title }),
              /* @__PURE__ */ m("span", { className: "mt-1 block text-[10px] text-nim-faint", children: [
                Tt(w.state),
                " · no activity for",
                " ",
                Be(
                  w.lastActivityAt,
                  t.windowEnd
                )
              ] })
            ] }),
            /* @__PURE__ */ o("span", { className: "text-[10px] text-nim-faint", children: b.isCurrentUser ? "You" : b.actor.displayName })
          ]
        },
        w.itemId
      )) })
    ] }) : null
  ] });
}
function Za(t) {
  return t.presence?.status === "online" ? "bg-[var(--nim-success)]" : t.presence?.status === "away" ? "bg-[var(--nim-warning)]" : "bg-[var(--nim-text-faint)]";
}
function eo(t) {
  return t.issueKey ?? t.primaryType;
}
function to(t) {
  return t.marks.reduce(
    (e, n) => !e || n.lastActivityAt > e.lastActivityAt ? n : e,
    void 0
  );
}
function no(t) {
  const e = to(t), n = t.enrichment?.liveSessions, r = n ? `${n} session${n === 1 ? "" : "s"} live` : e ? "Last active" : "No recent activity";
  if (!e) return `${r} · ${t.summary}`;
  const i = e.kind === "run" ? e.label : `${eo(e.items[0])} ${e.label}`;
  return `${r} on ${i} · ${t.summary}`;
}
function ro(t) {
  return t.windowSource === "since-left" ? `Since you left ${new Date(t.windowStart).toLocaleString(void 0, {
    weekday: "short",
    hour: "numeric",
    minute: "2-digit"
  })} · ${Math.round(t.windowHours)}h` : `Last ${t.windowHours < 24 ? `${t.windowHours}h` : `${t.windowHours / 24}d`}`;
}
function vl({
  items: t,
  currentIdentity: e,
  lastSeenAt: n,
  presenceByActorKey: r,
  enrichmentByActorKey: i,
  selectedItemId: s,
  onItemSelect: a,
  onOpenDocument: l
}) {
  const [c, d] = O(
    () => n ? "since-left" : 24
  ), [u, g] = O(!1), [p, f] = O(() => Date.now()), [h, b] = O(null);
  pe(() => {
    const k = setInterval(() => f(Date.now()), 6e4);
    return () => clearInterval(k);
  }, []), pe(() => {
    n && !u && d("since-left");
  }, [n, u]);
  const w = Q(
    () => _r(t, {
      nowMs: p,
      ...c === "since-left" ? { lastSeenAt: n } : { windowHours: c },
      currentIdentity: e,
      presenceByActorKey: r,
      enrichmentByActorKey: i,
      getTitle: ze,
      getStatus: Tn
    }),
    [
      e,
      i,
      t,
      n,
      p,
      r,
      c
    ]
  ), L = Q(
    () => new Map(t.map((k) => [k.id, k])),
    [t]
  ), N = Q(
    () => new Map(w.lanes.map((k) => [k.actorKey, k])),
    [w.lanes]
  ), E = h ? N.get(h) : void 0, A = (k) => !h || h === k, j = Q(() => {
    const k = /* @__PURE__ */ new Map();
    for (const D of w.lanes)
      for (const _ of D.marks)
        for (const U of _.events)
          k.set(
            `${U.itemId}:${U.actorKey}:${U.timestamp}`,
            U
          );
    return k;
  }, [w.lanes]), T = w.waitingOnYou.filter(
    (k) => !h || E?.isCurrentUser || Nn(k.actor) === h
  ), $ = w.lanes.flatMap(
    (k) => k.marks.flatMap(
      (D) => D.events.filter(
        (_) => _.action === "status_changed" && A(_.actorKey)
      ).map((_) => ({
        event: _,
        lane: k,
        item: L.get(_.itemId)
      })).filter((_) => !!_.item)
    )
  ).sort((k, D) => D.event.timestamp - k.event.timestamp), F = w.lanes.flatMap(
    (k) => k.marks.filter((D) => D.kind === "run" && A(k.actorKey)).map((D) => ({ lane: k, mark: D }))
  ).sort((k, D) => D.mark.lastActivityAt - k.mark.lastActivityAt), z = w.lanes.flatMap(
    (k) => k.stalled.filter(() => A(k.actorKey)).map((D) => ({ lane: k, item: D }))
  ).sort((k, D) => D.item.lastActivityAt - k.item.lastActivityAt);
  return w.lanes.length === 0 ? /* @__PURE__ */ m(
    "div",
    {
      className: "flex h-full flex-col items-center justify-center gap-2 bg-nim text-sm text-nim-muted",
      "data-testid": "tracker-radar-empty",
      children: [
        /* @__PURE__ */ o(R, { icon: "radar", size: 28, className: "text-nim-faint" }),
        /* @__PURE__ */ o("span", { children: "No activity in this window." }),
        /* @__PURE__ */ o("span", { className: "text-xs text-nim-faint", children: "Try a wider range to catch up on the team." })
      ]
    }
  ) : /* @__PURE__ */ m(
    "div",
    {
      className: "flex h-full min-h-0 flex-col bg-nim",
      "data-testid": "tracker-radar",
      "data-window-hours": w.windowHours,
      children: [
        /* @__PURE__ */ m("div", { className: "flex shrink-0 flex-wrap items-center gap-2 border-b border-nim px-4 py-2.5", children: [
          /* @__PURE__ */ m("div", { className: "flex items-center gap-1.5 text-xs font-semibold text-nim", children: [
            /* @__PURE__ */ o(
              R,
              {
                icon: "radar",
                size: 16,
                className: "text-[var(--nim-primary)]"
              }
            ),
            "Radar"
          ] }),
          /* @__PURE__ */ o("span", { className: "text-[11px] text-nim-muted", children: ro(w) }),
          /* @__PURE__ */ o(
            "div",
            {
              className: "ml-auto flex items-center rounded-md border border-nim bg-nim-secondary p-0.5",
              "aria-label": "Radar window",
              children: [
                ["since-left", "Since you left"],
                [2, "2h"],
                [8, "8h"],
                [24, "24h"],
                [72, "3d"]
              ].map(([k, D]) => k === "since-left" && !n ? null : /* @__PURE__ */ o(
                "button",
                {
                  type: "button",
                  "aria-pressed": c === k,
                  className: `rounded px-2 py-1 text-[10px] transition-colors ${c === k ? "bg-[var(--nim-primary)] text-white" : "text-nim-muted hover:bg-nim-hover hover:text-nim"}`,
                  onClick: () => {
                    g(!0), d(k);
                  },
                  children: D
                },
                k
              ))
            }
          )
        ] }),
        /* @__PURE__ */ m("div", { className: "min-h-0 flex-1 overflow-y-auto", children: [
          /* @__PURE__ */ o(
            "section",
            {
              className: "border-b border-nim bg-nim-secondary/35 px-4 py-3",
              "aria-label": "People",
              children: /* @__PURE__ */ o("div", { className: "grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-2.5", children: w.lanes.map((k) => {
                const D = h === k.actorKey, _ = D ? "border-[var(--nim-primary)] bg-[var(--nim-primary)]/10" : k.isCurrentUser ? "border-[var(--nim-primary)]/30 bg-[var(--nim-primary)]/5 hover:bg-[var(--nim-primary)]/10" : "border-nim bg-nim hover:bg-nim-hover";
                return /* @__PURE__ */ m(
                  "button",
                  {
                    type: "button",
                    "aria-pressed": D,
                    className: `rounded-lg border p-3 text-left transition-colors ${_}`,
                    onClick: () => b(
                      (U) => U === k.actorKey ? null : k.actorKey
                    ),
                    children: [
                      /* @__PURE__ */ m("span", { className: "flex items-center gap-2", children: [
                        /* @__PURE__ */ o(
                          "span",
                          {
                            className: `size-2 shrink-0 rounded-full ${Za(
                              k
                            )}`
                          }
                        ),
                        /* @__PURE__ */ o("strong", { className: "truncate text-xs text-nim", children: k.isCurrentUser ? "You" : k.actor.displayName }),
                        /* @__PURE__ */ o("span", { className: "ml-auto shrink-0 text-[10px] text-nim-faint", children: Be(
                          k.lastActivityAt,
                          w.windowEnd
                        ) })
                      ] }),
                      /* @__PURE__ */ o("span", { className: "mt-1.5 block text-[11px] leading-4 text-nim-muted", children: no(k) }),
                      k.enrichment?.unpushedCommits ? /* @__PURE__ */ m("span", { className: "mt-1 block text-[10px] text-nim-faint", children: [
                        k.enrichment.unpushedCommits,
                        " unpushed ·",
                        " ",
                        k.enrichment.divergence ?? "local"
                      ] }) : null
                    ]
                  },
                  k.actorKey
                );
              }) })
            }
          ),
          /* @__PURE__ */ o(
            Xa,
            {
              radar: w,
              needsYou: T,
              moved: $,
              sweeps: F,
              stalled: z,
              eventByAction: j,
              laneByActorKey: N,
              filterLabel: h ? E?.isCurrentUser ? "you" : E?.actor.displayName : void 0,
              selectedItemId: s,
              onClearFilter: () => b(null),
              onItemSelect: a,
              onOpenDocument: l
            }
          )
        ] })
      ]
    }
  );
}
function fn(t, e) {
  return (Array.isArray(e) ? e : [e]).filter((r) => r != null && r !== "").map((r) => {
    const i = String(r);
    return t?.options?.find((s) => s.value === i)?.label ?? i;
  }).join(", ");
}
function wl({
  fields: t,
  filters: e,
  onManage: n,
  onRemove: r
}) {
  const i = (e?.clauses ?? []).map((s, a) => ({ clause: s, clauseIndex: a })).filter(({ clause: s }) => Te(s));
  return i.length === 0 ? null : /* @__PURE__ */ o(
    "div",
    {
      className: "flex min-w-0 max-w-[min(40vw,520px)] shrink items-center gap-1 overflow-x-auto [scrollbar-width:none]",
      "data-testid": "tracker-active-filter-pills",
      children: i.map(({ clause: s, clauseIndex: a }) => {
        const l = t.find((d) => d.id === s.field), c = Se.has(s.op) ? "" : s.op === "in-last" || s.op === "not-in-last" ? `${fn(l, s.value)} days` : fn(l, s.value);
        return /* @__PURE__ */ m(
          "div",
          {
            className: "flex h-6 shrink-0 items-center overflow-hidden rounded-full border border-nim bg-nim-secondary text-[11px] text-nim-muted",
            "data-testid": `tracker-active-filter-pill-${a}`,
            children: [
              /* @__PURE__ */ m(
                "button",
                {
                  type: "button",
                  className: "flex h-full items-center gap-1.5 px-2 hover:bg-nim-tertiary hover:text-nim",
                  onClick: n,
                  title: "Manage filters",
                  children: [
                    /* @__PURE__ */ o("span", { className: "font-medium text-nim", children: l?.label ?? s.field }),
                    /* @__PURE__ */ o("span", { className: "text-nim-faint", children: xe[s.op] }),
                    c && /* @__PURE__ */ o("span", { className: "max-w-36 truncate", children: c })
                  ]
                }
              ),
              /* @__PURE__ */ o(
                "button",
                {
                  type: "button",
                  className: "inline-flex h-full w-6 items-center justify-center border-l border-nim text-nim-faint hover:bg-nim-tertiary hover:text-nim",
                  onClick: () => r(a),
                  "aria-label": `Remove ${l?.label ?? s.field} filter`,
                  children: /* @__PURE__ */ o(R, { icon: "close", size: 12 })
                }
              )
            ]
          },
          `${s.field}-${a}`
        );
      })
    }
  );
}
function xl({
  fallbackTitle: t,
  activeSavedViewName: e = null,
  savedViewDirty: n = !1,
  savedViewEditable: r = !0,
  showSaveViewAction: i = !1,
  onSaveView: s,
  onRenameSavedView: a,
  onUpdateSavedView: l,
  onExitSavedView: c
}) {
  const [d, u] = O(null), [g, p] = O(""), f = () => {
    u(null), p("");
  }, h = () => {
    const b = g.trim();
    b && (d === "rename" ? a(b) : s(b), f());
  };
  return d ? /* @__PURE__ */ m(
    "div",
    {
      className: "flex h-7 shrink-0 items-center overflow-hidden rounded border border-nim-focus bg-nim-secondary",
      "data-testid": "tracker-view-title-editor",
      children: [
        /* @__PURE__ */ o(
          R,
          {
            icon: d === "rename" ? "bookmark" : "bookmark_add",
            size: 14,
            className: "ml-2 text-[var(--nim-primary)]"
          }
        ),
        /* @__PURE__ */ o(
          "input",
          {
            autoFocus: !0,
            value: g,
            onFocus: (b) => {
              d === "rename" && b.currentTarget.select();
            },
            onChange: (b) => p(b.target.value),
            onKeyDown: (b) => {
              b.stopPropagation(), b.key === "Enter" && h(), b.key === "Escape" && f();
            },
            onBlur: () => {
              g.trim() ? h() : f();
            },
            placeholder: d === "rename" ? "View name…" : "Name this view…",
            className: "h-full w-44 bg-transparent px-2 text-sm font-semibold text-nim outline-none placeholder:font-normal placeholder:text-nim-faint",
            "data-testid": "tracker-saved-view-name-input"
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            className: "inline-flex h-full w-7 items-center justify-center text-[var(--nim-primary)] hover:bg-nim-tertiary disabled:opacity-35",
            disabled: !g.trim(),
            onMouseDown: (b) => b.preventDefault(),
            onClick: h,
            "aria-label": d === "rename" ? "Save view name" : "Save named view",
            "data-testid": "tracker-saved-view-save",
            children: /* @__PURE__ */ o(R, { icon: "check", size: 14 })
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            type: "button",
            className: "inline-flex h-full w-7 items-center justify-center text-nim-faint hover:bg-nim-tertiary hover:text-nim",
            onMouseDown: (b) => b.preventDefault(),
            onClick: f,
            "aria-label": "Cancel saving view",
            children: /* @__PURE__ */ o(R, { icon: "close", size: 13 })
          }
        )
      ]
    }
  ) : /* @__PURE__ */ m("div", { className: "flex min-w-0 shrink-0 items-center gap-2", children: [
    e && !r ? /* @__PURE__ */ o(
      "span",
      {
        className: "max-w-56 truncate text-sm font-semibold text-nim",
        "data-testid": "tracker-view-title",
        title: e,
        children: e
      }
    ) : e ? /* @__PURE__ */ m(
      "button",
      {
        type: "button",
        className: "group inline-flex min-w-0 max-w-56 items-center gap-1 truncate rounded px-0.5 text-sm font-semibold text-nim hover:bg-nim-tertiary",
        onClick: () => {
          p(e), u("rename");
        },
        "data-testid": "tracker-view-title",
        title: "Rename saved view",
        children: [
          /* @__PURE__ */ o("span", { className: "truncate", children: e }),
          /* @__PURE__ */ o(
            R,
            {
              icon: "edit",
              size: 12,
              className: "shrink-0 text-nim-faint opacity-0 transition-opacity group-hover:opacity-100"
            }
          )
        ]
      }
    ) : /* @__PURE__ */ o(
      "span",
      {
        className: "max-w-56 truncate text-sm font-semibold text-nim",
        "data-testid": "tracker-view-title",
        title: t,
        children: t
      }
    ),
    e && n ? /* @__PURE__ */ m(
      "button",
      {
        type: "button",
        className: "inline-flex h-7 items-center gap-1 rounded border border-nim px-2 text-[11px] font-medium text-nim-muted hover:bg-nim-tertiary hover:text-nim",
        onClick: l,
        "data-testid": "tracker-saved-view-update",
        children: [
          /* @__PURE__ */ o(R, { icon: "save", size: 13 }),
          "Save changes"
        ]
      }
    ) : !e && i ? /* @__PURE__ */ m(
      "button",
      {
        type: "button",
        className: "inline-flex h-7 items-center gap-1 rounded border border-nim px-2 text-[11px] font-medium text-nim-muted hover:bg-nim-tertiary hover:text-nim",
        onClick: () => u("create"),
        "data-testid": "tracker-saved-view-add",
        children: [
          /* @__PURE__ */ o(R, { icon: "bookmark_add", size: 13 }),
          "Save view"
        ]
      }
    ) : null,
    e && /* @__PURE__ */ o(
      "button",
      {
        type: "button",
        className: "inline-flex h-7 w-7 items-center justify-center rounded text-nim-faint hover:bg-nim-tertiary hover:text-nim",
        onClick: c,
        "aria-label": "Exit saved view",
        title: "Exit saved view",
        "data-testid": "tracker-saved-view-exit",
        children: /* @__PURE__ */ o(R, { icon: "close", size: 14 })
      }
    )
  ] });
}
const io = ({ savedViews: t, activeSavedViewId: e, isSharedLayout: n, onApplyView: r, onDeleteView: i, onToggleShareView: s }) => /* @__PURE__ */ m("div", { className: "px-2 pt-2 pb-1", "data-testid": "tracker-saved-views", children: [
  /* @__PURE__ */ o("div", { className: "flex items-center justify-between px-1 mb-1.5", children: /* @__PURE__ */ o("span", { className: "text-[10px] font-semibold text-nim-faint uppercase tracking-wider", children: "Saved Views" }) }),
  t.length === 0 ? /* @__PURE__ */ o("div", { className: "px-1 text-[10px] text-nim-faint italic", children: "Saved views will appear here." }) : /* @__PURE__ */ o("div", { className: "flex flex-col gap-0.5", children: t.map((a) => /* @__PURE__ */ m(
    "div",
    {
      className: `group flex items-center gap-1 rounded-md ${e === a.id ? "bg-nim-active" : "hover:bg-nim-tertiary"}`,
      "data-testid": "tracker-saved-view-item",
      children: [
        /* @__PURE__ */ m(
          "button",
          {
            className: "flex-1 flex items-center gap-2 px-2 py-1.5 text-left text-[12px] text-nim-muted hover:text-nim min-w-0",
            onClick: () => r(a),
            title: `Apply view: ${a.name}`,
            children: [
              /* @__PURE__ */ o(
                R,
                {
                  icon: a.builtIn ? "bolt" : "bookmark",
                  size: 13,
                  className: "shrink-0"
                }
              ),
              /* @__PURE__ */ o("span", { className: "flex-1 truncate", children: a.name }),
              a.shared && /* @__PURE__ */ o(
                R,
                {
                  icon: "group",
                  size: 12,
                  className: "shrink-0 text-nim-faint",
                  title: "Shared with this team"
                }
              )
            ]
          }
        ),
        n && s && !a.builtIn && /* @__PURE__ */ o(
          "button",
          {
            className: a.shared ? "px-1.5 text-[var(--nim-primary)]" : "opacity-0 group-hover:opacity-100 px-1.5 text-nim-faint hover:text-nim transition-opacity",
            onClick: () => s(a),
            title: a.shared ? "Stop sharing with the team" : "Share view with the team",
            "data-testid": "tracker-saved-view-share",
            children: /* @__PURE__ */ o(R, { icon: a.shared ? "group" : "group_add", size: 13 })
          }
        ),
        i && !a.builtIn && /* @__PURE__ */ o(
          "button",
          {
            className: "opacity-0 group-hover:opacity-100 px-1.5 text-nim-faint hover:text-nim-error transition-opacity",
            onClick: () => i(a),
            title: a.shared ? "Delete view for the whole team" : "Delete view",
            "data-testid": "tracker-saved-view-delete",
            children: /* @__PURE__ */ o(R, { icon: "close", size: 13 })
          }
        )
      ]
    },
    a.id
  )) })
] }), kl = ({
  items: t,
  onOpenItem: e
}) => {
  const n = Q(
    () => t.map((c) => c.id).sort().join("|"),
    [t]
  ), [r, i] = O(null), [s, a] = O(!1), l = Q(
    () => t.some((c) => kr(Ft(c))),
    [t]
  );
  return t.length === 0 || r === n ? null : /* @__PURE__ */ m(
    "div",
    {
      className: "tracker-dependency-cycle-banner flex flex-col gap-1.5 px-3 py-2 border-b border-nim bg-nim-tertiary text-xs text-nim shrink-0",
      role: "status",
      "data-testid": "tracker-dependency-cycle-banner",
      "data-cycle-item-count": t.length,
      children: [
        /* @__PURE__ */ m("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ o(R, { icon: "sync_problem", size: 16, className: "text-nim-warning" }),
          /* @__PURE__ */ m("span", { className: "flex-1", children: [
            t.length,
            " ",
            t.length === 1 ? "item is" : "items are",
            " in a dependency cycle.",
            " ",
            Ir
          ] }),
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              className: "px-2 py-0.5 rounded border border-nim text-nim-muted hover:bg-nim hover:text-nim transition-colors",
              onClick: () => a((c) => !c),
              "data-testid": "tracker-dependency-cycle-toggle",
              children: s ? "Hide items" : "Show items"
            }
          ),
          /* @__PURE__ */ o(
            "button",
            {
              type: "button",
              className: "text-nim-faint hover:text-nim p-0.5",
              onClick: () => i(n),
              "aria-label": "Dismiss",
              "data-testid": "tracker-dependency-cycle-dismiss",
              children: /* @__PURE__ */ o(R, { icon: "close", size: 14 })
            }
          )
        ] }),
        s && /* @__PURE__ */ o("ul", { className: "m-0 flex list-none flex-col gap-0.5 p-0 pl-6 select-text", children: t.map((c) => /* @__PURE__ */ o("li", { children: /* @__PURE__ */ m(
          "button",
          {
            type: "button",
            className: "flex w-full items-baseline gap-2 rounded px-1 py-0.5 text-left hover:bg-nim",
            onClick: () => e(c.id),
            "data-testid": "tracker-dependency-cycle-item",
            children: [
              /* @__PURE__ */ o("span", { className: "shrink-0 font-mono text-[10px] uppercase tracking-[0.08em] text-nim-faint", children: Ft(c) ?? "" }),
              /* @__PURE__ */ o("span", { className: "min-w-0 flex-1 truncate", children: ze(c) })
            ]
          }
        ) }, c.id)) }),
        s && l && /* @__PURE__ */ o("p", { className: "m-0 pl-6 text-nim-faint", "data-testid": "tracker-dependency-cycle-local-ref-note", children: Tr })
      ]
    }
  );
};
function so(t) {
  return t.pending === !0;
}
function dr(t) {
  if (!t || typeof t != "object") return;
  const e = t.clientMutationId;
  return typeof e == "string" ? e : dr(t.result);
}
const ao = ({
  comments: t,
  identity: e,
  mutate: n,
  formatTimestamp: r,
  readOnly: i = !1,
  mutationRejection: s = null,
  collapsedComposer: a = !1,
  draft: l,
  onDraftChange: c
}) => {
  const [d, u] = O(""), g = l ?? d, p = c ?? u, f = ce(g);
  f.current = g;
  const h = Z((P) => {
    const K = f.current;
    p(K && K !== P ? `${P}

${K}` : P);
  }, [p]), [b, w] = O(!1), L = a ? "textarea" : "input", [N, E] = O(!1), [A, j] = O([]), [T, $] = O(null), [F, z] = O(""), [k, D] = O(null), _ = Q(
    () => (t ?? []).filter((P) => !P.deleted),
    [t]
  ), U = Q(() => {
    if (A.length === 0) return _;
    const P = new Set(_.map((J) => J.body)), K = A.filter((J) => !P.has(J.body));
    return K.length < A.length && queueMicrotask(() => j(K)), [..._, ...K];
  }, [_, A]), ee = Z(async (P) => {
    D(null);
    try {
      return { accepted: !0, result: await n(P) };
    } catch (K) {
      return D(K instanceof Error ? K.message : String(K)), { accepted: !1 };
    }
  }, [n]);
  pe(() => {
    const P = s?.clientMutationId;
    if (!s || !P) return;
    const K = A.find((J) => J.clientMutationId === P);
    K && (h(K.body), j((J) => J.filter((G) => G.clientMutationId !== P)), D(ir(s)));
  }, [s, A, h]);
  const X = Z(async () => {
    const P = g.trim();
    if (!P || N) return;
    E(!0), w(!0);
    const K = {
      id: `pending_${Date.now()}`,
      body: P,
      createdAt: Date.now(),
      pending: !0
    };
    j((G) => [...G, K]), p("");
    const J = await ee({ kind: "add", body: P });
    if (!J.accepted)
      j((G) => G.filter((B) => B.id !== K.id)), h(P);
    else {
      const G = dr(J.result);
      G && j((B) => B.map((se) => se.id === K.id ? { ...se, clientMutationId: G } : se));
    }
    E(!1);
  }, [g, ee, N, p, h]), oe = Z(async (P) => {
    const K = F.trim();
    K && (await ee({ kind: "update", commentId: P, body: K })).accepted && $(null);
  }, [F, ee]);
  return /* @__PURE__ */ m("div", { className: "tracker-comments-section space-y-2 select-text", children: [
    U.map((P) => {
      const K = so(P), J = !i && !K && Sr(P.authorIdentity ?? null, e), G = T === P.id;
      return /* @__PURE__ */ m(
        "div",
        {
          className: `tracker-comment group rounded bg-nim-tertiary p-2 space-y-1${K ? " opacity-70" : ""}`,
          children: [
            /* @__PURE__ */ m("div", { className: "flex items-center gap-2 text-[11px]", children: [
              /* @__PURE__ */ o("span", { className: "font-medium text-nim-muted", children: !K && P.authorIdentity?.displayName || "You" }),
              /* @__PURE__ */ o("span", { className: "text-nim-faint", children: r(P.createdAt) }),
              !K && P.updatedAt ? /* @__PURE__ */ o("span", { className: "text-nim-faint", children: "(edited)" }) : null,
              J && !G && /* @__PURE__ */ m("span", { className: "ml-auto flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity", children: [
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "tracker-comment-edit text-nim-faint hover:text-nim",
                    title: "Edit comment",
                    onClick: () => {
                      $(P.id), z(P.body);
                    },
                    children: /* @__PURE__ */ o(R, { icon: "edit", size: 13 })
                  }
                ),
                /* @__PURE__ */ o(
                  "button",
                  {
                    className: "tracker-comment-delete text-nim-faint hover:text-nim-error",
                    title: "Delete comment",
                    onClick: () => ee({ kind: "delete", commentId: P.id }),
                    children: /* @__PURE__ */ o(R, { icon: "delete", size: 13 })
                  }
                )
              ] })
            ] }),
            G ? /* @__PURE__ */ m("div", { className: "flex gap-1", children: [
              /* @__PURE__ */ o(
                "input",
                {
                  type: "text",
                  value: F,
                  autoFocus: !0,
                  onChange: (B) => z(B.target.value),
                  onKeyDown: (B) => {
                    B.key === "Enter" && !B.shiftKey && (B.preventDefault(), oe(P.id)), B.key === "Escape" && $(null);
                  },
                  className: "min-w-0 flex-1 bg-nim-secondary border border-nim rounded px-2 py-1 text-xs text-nim outline-none focus:border-nim-primary"
                }
              ),
              /* @__PURE__ */ o(
                "button",
                {
                  onClick: () => oe(P.id),
                  disabled: !F.trim(),
                  className: "px-2 py-1 rounded text-xs bg-nim-primary text-nim-on-primary disabled:opacity-40",
                  children: "Save"
                }
              ),
              /* @__PURE__ */ o(
                "button",
                {
                  onClick: () => $(null),
                  className: "px-2 py-1 rounded text-xs text-nim-muted hover:text-nim",
                  children: "Cancel"
                }
              )
            ] }) : /* @__PURE__ */ o("p", { className: "text-xs text-nim m-0 whitespace-pre-wrap", children: P.body })
          ]
        },
        P.id
      );
    }),
    i ? null : a && !b && !g ? /* @__PURE__ */ o("button", { type: "button", className: "tracker-add-comment", onClick: () => w(!0), children: "Add comment" }) : /* @__PURE__ */ m("div", { className: "tracker-comment-composer flex gap-1", children: [
      /* @__PURE__ */ o(
        L,
        {
          ...a ? { rows: 3 } : { type: "text" },
          "aria-label": "Comment",
          value: g,
          onChange: (P) => p(P.target.value),
          onKeyDown: (P) => {
            P.key === "Enter" && (!a && !P.shiftKey || P.metaKey || P.ctrlKey) && (P.preventDefault(), X());
          },
          placeholder: "Add a comment...",
          className: "min-w-0 flex-1 bg-nim-secondary border border-nim rounded px-2 py-1 text-xs text-nim placeholder:text-nim-faint outline-none focus:border-nim-primary",
          "data-testid": "tracker-comment-input"
        }
      ),
      /* @__PURE__ */ o(
        "button",
        {
          onClick: X,
          disabled: !g.trim() || N,
          className: "px-2 py-1 rounded text-xs bg-nim-primary text-nim-on-primary disabled:opacity-40 hover:opacity-90 transition-opacity",
          children: "Post"
        }
      )
    ] }),
    k && /* @__PURE__ */ o("p", { className: "tracker-comment-error m-0 text-xs text-nim-error", role: "alert", children: k })
  ] });
};
function pt({
  tracker: t,
  selected: e,
  nested: n = !1,
  count: r,
  className: i = "",
  ...s
}) {
  return /* @__PURE__ */ m(
    "button",
    {
      type: "button",
      "data-tracker-type": t.type,
      className: `tracker-nav-type-row w-full flex items-center gap-2 pr-2 py-1.5 rounded-md text-sm transition-colors ${n ? "pl-7" : "pl-2"} ${e ? "bg-nim-active text-nim" : "text-nim-muted hover:bg-nim-tertiary hover:text-nim"} ${i}`,
      ...s,
      children: [
        /* @__PURE__ */ o("span", { className: "shrink-0", style: { color: t.color }, children: /* @__PURE__ */ o(R, { icon: t.icon || "checklist", size: 16 }) }),
        /* @__PURE__ */ o("span", { className: "min-w-0 flex-1 text-left truncate", children: t.displayNamePlural || t.displayName || t.type }),
        /* @__PURE__ */ o("span", { className: "shrink-0 min-w-[20px] text-right text-[10px] font-semibold tabular-nums text-nim-muted", children: r })
      ]
    }
  );
}
const oo = {
  type: "all",
  icon: "checklist",
  displayName: "All"
};
function Il({
  trackerTypes: t,
  navigationEntries: e,
  savedViews: n,
  activeSavedViewId: r,
  selectedType: i,
  countsByType: s,
  expandedFolderIds: a,
  onToggleFolder: l,
  onSelectType: c,
  onApplyView: d,
  onDeleteView: u,
  onToggleShareView: g
}) {
  const { personalState: p } = Rr(), f = Q(
    () => p ? t : t.filter((w) => !Je(w)),
    [p, t]
  ), h = Q(
    () => sa(f, e),
    [f, e]
  ), b = Q(() => new Set(a), [a]);
  return (
    // No "Trackers" title bar over the sections. Desktop needs one because its
    // sidebar sits under a workspace summary that names a project, not a
    // surface; here the gutter's selected mode and the pane header above both
    // already say it, and a third restatement was the same redundancy as the
    // duplicated breadcrumb segment beside it.
    /* @__PURE__ */ o("div", { className: "tracker-navigation flex flex-col h-full min-h-0", "data-testid": "tracker-navigation", children: /* @__PURE__ */ m("div", { className: "flex-1 overflow-y-auto", children: [
      /* @__PURE__ */ o(
        io,
        {
          savedViews: n,
          activeSavedViewId: r,
          isSharedLayout: !0,
          onApplyView: d,
          onDeleteView: u,
          onToggleShareView: g
        }
      ),
      /* @__PURE__ */ m("div", { className: "px-1.5 py-2 border-t border-nim mt-1", children: [
        /* @__PURE__ */ o("div", { className: "px-2 mb-1 text-[10px] font-semibold text-nim-faint uppercase tracking-wider", children: "Types" }),
        /* @__PURE__ */ o(
          pt,
          {
            "data-testid": "tracker-nav-type",
            tracker: oo,
            selected: i === "all",
            onClick: () => c("all")
          }
        ),
        h.folders.map(({ folder: w, trackerTypes: L }) => {
          const N = b.has(w.folderId);
          return /* @__PURE__ */ m(Pe.Fragment, { children: [
            /* @__PURE__ */ m(
              "button",
              {
                "data-testid": "tracker-nav-folder",
                "data-folder-id": w.folderId,
                className: "w-full flex items-center gap-1 px-1 py-1 rounded-md text-sm text-nim-muted hover:bg-nim-tertiary hover:text-nim",
                onClick: () => l(w.folderId),
                children: [
                  /* @__PURE__ */ o(R, { icon: N ? "expand_more" : "chevron_right", size: 15 }),
                  /* @__PURE__ */ o(R, { icon: N ? "folder_open" : "folder", size: 16 }),
                  /* @__PURE__ */ o("span", { className: "min-w-0 flex-1 text-left truncate", children: w.name })
                ]
              }
            ),
            N ? L.map(({ tracker: E }) => /* @__PURE__ */ o(
              pt,
              {
                "data-testid": "tracker-nav-type",
                tracker: E,
                nested: !0,
                selected: i === E.type,
                count: s?.get(E.type),
                onClick: () => c(E.type)
              },
              E.type
            )) : null
          ] }, w.entryId);
        }),
        h.rootTypes.map(({ tracker: w }) => /* @__PURE__ */ o(
          pt,
          {
            "data-testid": "tracker-nav-type",
            tracker: w,
            selected: i === w.type,
            count: s?.get(w.type),
            onClick: () => c(w.type)
          },
          w.type
        ))
      ] })
    ] }) })
  );
}
async function lo(t) {
  const { copyToClipboard: e } = await import("./clipboard-hsoeGPuZ.js");
  await e(t);
}
const co = 1600;
function uo({
  value: t,
  label: e = "Copy link",
  icon: n = "link",
  className: r,
  testId: i
}) {
  const [s, a] = O("idle"), l = ce(null);
  pe(
    () => () => {
      l.current && clearTimeout(l.current);
    },
    []
  );
  const c = Z(async () => {
    l.current && clearTimeout(l.current);
    try {
      await lo(t), a("copied");
    } catch {
      a("failed");
    }
    l.current = setTimeout(() => a("idle"), co);
  }, [t]), d = s === "copied" ? "Link copied" : s === "failed" ? "Could not copy link" : e;
  return /* @__PURE__ */ m(
    "button",
    {
      type: "button",
      className: `tracker-copy-link flex size-6 items-center justify-center rounded text-nim-faint hover:bg-nim-hover hover:text-nim ${r ?? ""}`,
      "aria-label": d,
      title: d,
      "data-copy-state": s,
      "data-testid": i,
      onClick: () => {
        c();
      },
      children: [
        /* @__PURE__ */ o(
          R,
          {
            icon: s === "copied" ? "check" : s === "failed" ? "error" : n,
            size: 16
          }
        ),
        /* @__PURE__ */ o("span", { className: "sr-only", role: "status", "aria-live": "polite", children: s === "idle" ? "" : d })
      ]
    }
  );
}
const Ge = () => import("./TrackerItemActionsPopover-CiqxIH0M.js"), po = ye(
  () => Ge().then((t) => ({
    default: t.TrackerItemActionsPopover
  }))
);
function mo({
  actions: t,
  label: e = "Item actions",
  className: n
}) {
  const [r, i] = O(!1), [s, a] = O(null);
  return t.length === 0 ? null : /* @__PURE__ */ m(Le, { children: [
    /* @__PURE__ */ o(
      "button",
      {
        type: "button",
        ref: a,
        className: `tracker-item-actions-trigger flex size-6 items-center justify-center rounded text-nim-faint hover:bg-nim-hover hover:text-nim ${n ?? ""}`,
        "aria-label": e,
        "aria-haspopup": "menu",
        "aria-expanded": r,
        onPointerEnter: () => {
          Ge();
        },
        onFocus: () => {
          Ge();
        },
        onPointerDown: () => {
          Ge();
        },
        onClick: () => i((l) => !l),
        children: /* @__PURE__ */ o(R, { icon: "more_vert", size: 16 })
      }
    ),
    r && s ? /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(
      po,
      {
        actions: t,
        reference: s,
        onClose: () => i(!1)
      }
    ) }) : null
  ] });
}
function hn({ fields: t, values: e, editing: n, onChange: r, teamMembers: i = [] }) {
  return /* @__PURE__ */ o("div", { className: "tracker-phone-properties", children: t.map((s) => {
    const a = e[s.name], l = s.name.replace(/([A-Z])/g, " $1").replace(/^./, (d) => d.toUpperCase()), c = (d) => {
      Promise.resolve(r?.(s.name, d)).catch(() => {
      });
    };
    if (!n || s.readOnly) {
      const d = s.options?.find((u) => u.value === a)?.label ?? (a == null || a === "" ? "—" : typeof a == "object" ? JSON.stringify(a) : String(a));
      return /* @__PURE__ */ m("div", { className: "tracker-phone-property-value", children: [
        /* @__PURE__ */ o("span", { children: l }),
        /* @__PURE__ */ o("span", { children: d })
      ] }, s.name);
    }
    if (s.type === "select" || s.type === "user") {
      const d = s.type === "user" ? i.map((u) => ({ value: u.email, label: u.name || u.email })) : s.options ?? [];
      return /* @__PURE__ */ m("label", { children: [
        l,
        /* @__PURE__ */ m("select", { "aria-label": l, value: String(a ?? ""), onChange: (u) => c(u.target.value), children: [
          /* @__PURE__ */ o("option", { value: "", children: "Choose…" }),
          a && !d.some((u) => u.value === a) ? /* @__PURE__ */ o("option", { value: String(a), children: String(a) }) : null,
          d.map((u) => /* @__PURE__ */ o("option", { value: u.value, children: u.label }, u.value))
        ] })
      ] }, s.name);
    }
    return /* @__PURE__ */ o(Ct, { field: s, value: a, onChange: c, layout: "vertical", teamMembers: i }, s.name);
  }) });
}
function fo(t) {
  const e = ue.get(t), n = Ar(t, "title");
  return (e?.fields ?? []).filter((r) => r.name !== n);
}
function Tl({
  item: t,
  identity: e,
  onFieldChange: n,
  commentMutate: r,
  formatTimestamp: i,
  teamMembers: s,
  bodySlot: a,
  headerStatus: l,
  copyLinkHref: c,
  overflowActions: d,
  onClose: u,
  mutationRejection: g,
  compact: p = !1,
  editing: f = !1,
  onEditingChange: h,
  backLabel: b = "Back to trackers",
  commentDraft: w,
  onCommentDraftChange: L
}) {
  const N = fo(t.primaryType), E = !n, [A, j] = O(!1), T = ue.get(t.primaryType), $ = Nr(t, "progress");
  return /* @__PURE__ */ m(
    "div",
    {
      className: "tracker-item-detail flex h-full min-h-0 flex-col bg-nim",
      "data-testid": "tracker-item-detail",
      "data-item-id": t.id,
      "data-compact": p,
      "data-editing": f,
      children: [
        p || h && !f ? /* @__PURE__ */ m("div", { className: "tracker-phone-reader-bar", children: [
          /* @__PURE__ */ o("button", { type: "button", onClick: u, children: b }),
          !E && h ? /* @__PURE__ */ o("button", { type: "button", onClick: () => h(!f), children: f ? "Done" : "Edit" }) : null
        ] }) : null,
        /* @__PURE__ */ m("div", { className: "tracker-item-detail-header border-b border-nim px-4 py-3", children: [
          /* @__PURE__ */ m("div", { className: "flex min-w-0 items-center gap-2", children: [
            /* @__PURE__ */ o($r, { label: t.primaryType, color: Er(t.primaryType) }),
            t.issueKey ? /* @__PURE__ */ o("span", { className: "font-mono text-[10px] uppercase tracking-[0.08em] text-nim-faint select-text", children: t.issueKey }) : null,
            /* @__PURE__ */ o(Mr, { item: t, identity: e }),
            /* @__PURE__ */ o("span", { className: "ml-auto" }),
            l,
            c ? /* @__PURE__ */ o(uo, { value: c, testId: "tracker-copy-link" }) : null,
            /* @__PURE__ */ o(mo, { actions: d ?? [] }),
            u && !p ? /* @__PURE__ */ o(
              "button",
              {
                type: "button",
                className: "flex size-6 items-center justify-center rounded text-nim-faint hover:bg-nim-hover hover:text-nim",
                "aria-label": "Close item",
                onClick: u,
                children: /* @__PURE__ */ o(R, { icon: "close", size: 16 })
              }
            ) : null
          ] }),
          /* @__PURE__ */ o("h2", { className: `mt-1 text-base font-semibold text-nim select-text${p ? " tracker-phone-title" : " truncate"}`, children: ze(t) }),
          p ? /* @__PURE__ */ m("div", { className: "tracker-phone-summary", children: [
            /* @__PURE__ */ o("span", { children: Tn(t) }),
            typeof $ == "number" ? /* @__PURE__ */ m("span", { children: [
              $,
              "%"
            ] }) : null,
            f ? /* @__PURE__ */ o("span", { children: "Live edits" }) : null
          ] }) : null
        ] }),
        /* @__PURE__ */ m("div", { className: "tracker-item-detail-scroll min-h-0 flex-1 overflow-y-auto", children: [
          /* @__PURE__ */ m("div", { className: "tracker-item-detail-fields grid gap-3 border-b border-nim px-4 py-3", children: [
            p ? /* @__PURE__ */ m(Le, { children: [
              /* @__PURE__ */ m("button", { type: "button", className: "tracker-phone-properties-toggle", "aria-expanded": A || f, onClick: () => j(!A), disabled: f, children: [
                "Properties",
                f ? " · Editing" : A ? " −" : " +"
              ] }),
              A || f ? /* @__PURE__ */ o(hn, { fields: f ? T?.fields ?? N : N, values: t.fields, editing: f && !E, onChange: n, teamMembers: s }) : null
            ] }) : null,
            !p && h && !f ? /* @__PURE__ */ o(hn, { fields: N, values: t.fields, editing: !1, teamMembers: s }) : null,
            !p && (!h || f) ? /* @__PURE__ */ o(Le, { children: N.map((F) => /* @__PURE__ */ o(
              Ct,
              {
                field: E ? { ...F, readOnly: !0 } : F,
                value: t.fields[F.name],
                onChange: (z) => n?.(F.name, z),
                layout: "horizontal",
                teamMembers: s
              },
              F.name
            )) }) : null
          ] }),
          a ? /* @__PURE__ */ o("div", { className: "tracker-item-detail-body border-b border-nim", children: a }) : null,
          /* @__PURE__ */ m("div", { className: "px-4 py-3", children: [
            /* @__PURE__ */ o("div", { className: "mb-2 text-[10px] font-semibold uppercase tracking-wider text-nim-faint", children: "Comments" }),
            /* @__PURE__ */ o(
              ao,
              {
                comments: t.system.comments,
                identity: e,
                mutate: r,
                formatTimestamp: i,
                readOnly: E,
                collapsedComposer: p,
                draft: w,
                onDraftChange: L,
                mutationRejection: g
              }
            )
          ] })
        ] })
      ]
    }
  );
}
const ho = "flex w-full items-center gap-2 px-3 py-1.5 text-left text-[13px] text-nim hover:bg-nim-tertiary disabled:cursor-default disabled:opacity-40 disabled:hover:bg-transparent";
function Sl({ actions: t, onBeforeSelect: e }) {
  return /* @__PURE__ */ o(Le, { children: t.map((n) => {
    const r = n.separatorBefore ? /* @__PURE__ */ o("div", { className: "my-1 border-t border-nim", "aria-hidden": "true" }, `${n.id}-rule`) : null;
    return n.caption ? /* @__PURE__ */ m(Pe.Fragment, { children: [
      r,
      /* @__PURE__ */ o("div", { className: "px-3 pb-0.5 pt-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-nim-faint", children: n.label })
    ] }, n.id) : /* @__PURE__ */ m(Pe.Fragment, { children: [
      r,
      /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          role: "menuitem",
          disabled: n.disabled,
          "aria-label": n.label,
          className: ho,
          onClick: () => {
            e?.(), n.onSelect?.();
          },
          children: [
            n.swatch ? /* @__PURE__ */ o(
              "span",
              {
                className: "size-2.5 shrink-0 rounded-full",
                style: { backgroundColor: n.swatch }
              }
            ) : n.icon ? /* @__PURE__ */ o(R, { icon: n.icon, size: 16, className: "text-nim-muted" }) : null,
            /* @__PURE__ */ o("span", { className: "min-w-0 flex-1 truncate", children: n.label })
          ]
        }
      )
    ] }, n.id);
  }) });
}
const yo = () => import("./TrackerContextMenuPopover-DRNaVXjQ.js"), go = ye(
  () => yo().then((t) => ({
    default: t.TrackerContextMenuPopover
  }))
);
function Nl({
  point: t,
  actions: e,
  onClose: n,
  label: r = "Item actions",
  className: i
}) {
  return t ? /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(
    go,
    {
      point: t,
      actions: e,
      onClose: n,
      label: r,
      className: i
    }
  ) }) : null;
}
const bo = ye(
  () => import("./OntologyInspector-DP0Tv1xF.js").then((t) => ({ default: t.OntologyInspector }))
);
function El(t) {
  return /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(bo, { ...t }) });
}
function vo(t, e) {
  const n = t.fields[e];
  if (n != null) return n;
  const r = t.fields.customFields;
  return r && typeof r == "object" ? r[e] : void 0;
}
function yn(t) {
  const e = t.fields.title;
  return typeof e == "string" && e.trim() || t.issueKey || t.id;
}
function Al(t) {
  return t == null ? !0 : typeof t == "string" ? t.trim() === "" : Array.isArray(t) ? t.length === 0 : typeof t == "object" ? Object.keys(t).length === 0 : !1;
}
function ur(t) {
  return Array.isArray(t) ? t.flatMap(ur) : typeof t == "string" && t ? [t] : t && typeof t == "object" && typeof t.itemId == "string" ? [t.itemId] : [];
}
function Cl(t, e) {
  return ur(vo(t, e));
}
function Ll(t) {
  return Array.isArray(t) ? t.filter((e) => typeof e == "string") : [];
}
function gn(t, e) {
  return yn(t).localeCompare(yn(e));
}
const it = "entity", mt = ["annual-revenue", "funding-total", "headcount", "valuation", "last-round", "founded", "hq"], ft = ["lifecycle", "pricing", "license", "platforms", "launched", "users"], wo = [
  { id: "home", label: "Home", pluralLabel: "Home", icon: "home", role: "structure" },
  { id: "area", label: "Area", pluralLabel: "Areas", icon: "folder", role: "structure" },
  { id: "market", label: "Market", pluralLabel: "Markets", icon: "storefront", role: "market-node", factBox: [...mt, ...ft] },
  {
    id: "product",
    label: "Product",
    pluralLabel: "Products",
    icon: "inventory_2",
    role: "page",
    properties: ["website", "in-market", "made-by", "competes-with", ...ft],
    expects: [{ property: "in-market", min: 1 }, { property: "made-by", min: 1 }],
    factBox: [...ft]
  },
  {
    id: "organization",
    label: "Organization",
    pluralLabel: "Organizations",
    icon: "apartment",
    role: "page",
    properties: ["website", ...mt],
    factBox: [...mt]
  }
], xo = {
  "in-market": { range: ["market"], facet: !0 },
  "made-by": { range: ["organization", "person"], facet: !0 },
  "competes-with": { range: ["product", "capability"] },
  lifecycle: { options: ["active", "declining", "unmaintained", "defunct"], facet: !0 }
};
function Pl(t, e = {}) {
  if (t && !An(t)) return t;
  const n = wo.map((s) => ({ ...s })), r = new Set(n.map((s) => s.id)), i = (s, a) => {
    !s || r.has(s) || (r.add(s), n.push({ id: s, label: a || s.replace(/-/g, " ").replace(/^./, (l) => l.toUpperCase()), role: "page" }));
  };
  for (const s of e.kindOptions ?? []) i(s.value, s.label);
  for (const s of e.observedKinds ?? []) i(s);
  return { labels: n, properties: [], claimProperties: { ...xo } };
}
function Dl(t) {
  return !t || An(t);
}
function pr(t) {
  return new Map(t.labels.map((e) => [e.id, e]));
}
function _l(t, e, n = !1) {
  const r = t.labels.find((i) => i.id === e);
  return r ? n ? r.pluralLabel ?? `${r.label}s` : r.label : e.replace(/-/g, " ").replace(/^./, (i) => i.toUpperCase());
}
function mr(t) {
  return t.primaryType === it ? Et(t.fields) : [];
}
function ko(t, e) {
  return e.primaryType === it ? En(t, e.fields) : [];
}
function Io(t, e) {
  if (e.primaryType !== it) return null;
  const n = pr(t), r = ko(t, e).map((i) => n.get(i)?.role);
  return r.includes("structure") ? "structure" : r.includes("market-node") ? "market-node" : "page";
}
function Rl(t, e, n) {
  return Io(t, e) === n;
}
function $l(t) {
  return mr(t).includes("home");
}
function bn(t, e, n) {
  const r = t.get(e);
  r ? r.push(n) : t.set(e, [n]);
}
function Ml(t, e) {
  const n = pr(t), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = [], c = /* @__PURE__ */ new Set();
  for (const d of e) {
    if (d.archived || d.primaryType !== it) continue;
    const u = mr(d), g = En(t, d.fields);
    r.set(d.id, u), i.set(d.id, g), u.length === 0 && l.push(d);
    for (const p of u)
      bn(a, p, d), n.has(p) || c.add(p);
    for (const p of g) bn(s, p, d);
  }
  for (const d of s.values()) d.sort(gn);
  return { registry: t, labels: n, own: r, effective: i, members: s, direct: a, unlabeled: l.sort(gn), undeclared: [...c].sort() };
}
function Ol(t, e) {
  const n = t.properties.find((r) => r.id === e);
  return n ? n.type === "relationship" ? n.range ?? [] : [] : t.claimProperties[e]?.range ?? [];
}
function Fl(t, e) {
  return t.labels.filter((n) => n.broader?.includes(e)).map((n) => n.id);
}
const To = ye(() => import("./OntologyTypeMap-Dvatyvg_.js").then((t) => ({ default: t.OntologyTypeMap }))), So = ye(() => import("./OntologyLabelReview-eIwOSAA1.js").then((t) => ({ default: t.OntologyLabelReview })));
function Bl(t) {
  return /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(To, { ...t }) });
}
function jl(t) {
  return /* @__PURE__ */ o(he, { fallback: null, children: /* @__PURE__ */ o(So, { ...t }) });
}
const Vl = () => import("./ontologyTypesApi-D-cTU6Eo.js"), Kl = () => import("./index-BCLC2sbX.js");
export {
  Tl as $,
  ks as A,
  ei as B,
  Os as C,
  hl as D,
  oo as E,
  ll as F,
  cl as G,
  ui as H,
  uo as I,
  qa as J,
  we as K,
  it as L,
  El as M,
  jl as N,
  Bl as O,
  ul as P,
  It as Q,
  yl as R,
  Wo as S,
  Sl as T,
  wl as U,
  ja as V,
  ao as W,
  Nl as X,
  kl as Y,
  Ka as Z,
  mo as _,
  yn as a,
  ea as a$,
  pl as a0,
  pt as a1,
  Il as a2,
  vl as a3,
  Zo as a4,
  Us as a5,
  io as a6,
  Xo as a7,
  gl as a8,
  bl as a9,
  Kn as aA,
  pr as aB,
  Vl as aC,
  Kl as aD,
  Jo as aE,
  nl as aF,
  rl as aG,
  Fn as aH,
  Uo as aI,
  el as aJ,
  kt as aK,
  Ko as aL,
  Vo as aM,
  Bn as aN,
  tl as aO,
  ln as aP,
  cn as aQ,
  an as aR,
  on as aS,
  dn as aT,
  ol as aU,
  al as aV,
  sl as aW,
  ko as aX,
  mr as aY,
  Fo as aZ,
  Da as a_,
  xl as aa,
  Ke as ab,
  ml as ac,
  ta as ad,
  sa as ae,
  bt as af,
  fi as ag,
  Yt as ah,
  gt as ai,
  hi as aj,
  lo as ak,
  Qo as al,
  rt as am,
  ki as an,
  qo as ao,
  fl as ap,
  Dt as aq,
  Go as ar,
  ia as as,
  ir as at,
  Rl as au,
  yi as av,
  $l as aw,
  Pt as ax,
  Je as ay,
  Ti as az,
  gn as b,
  Js as b0,
  Xn as b1,
  xi as b2,
  Zt as b3,
  zo as b4,
  De as b5,
  Gs as b6,
  il as b7,
  He as b8,
  ra as b9,
  dl as ba,
  sn as bb,
  oi as bc,
  Ho as bd,
  _l as c,
  Ml as d,
  Pl as e,
  Hn as f,
  Dl as g,
  Io as h,
  Al as i,
  Bo as j,
  mi as k,
  fs as l,
  ur as m,
  Fl as n,
  vo as o,
  Ol as p,
  jo as q,
  Cl as r,
  Ll as s,
  wt as t,
  Yo as u,
  Ms as v,
  Ns as w,
  _s as x,
  Ds as y,
  At as z
};
//# sourceMappingURL=trackers-ui-DhdMA1TV.js.map
